webpackJsonp([110308036455227],{

/***/ 105:
/***/ (function(module, exports) {

	module.exports = {"categories":{"cms":{"label":"CMS","longLabel":"content management system"},"lang":{"label":"programming language"},"framework":{"label":"web development framework"},"host":{"label":"hosting solution"},"task":{"label":"task"},"hoststyle":{"label":"hosting style"},"employer":{"label":"employer"},"database":{"label":"database"},"pattern":{"label":"pattern"},"template":{"label":"templating language"},"library":{"label":"library"},"api":{"label":"API"},"softwarescripting":{"label":"software scripting"},"realm":{"label":"realm"}},"tags":{"web":{"label":"web","category":{"label":"realm"}},"app":{"label":"app","category":{"label":"realm"}},"print":{"label":"print","category":{"label":"realm"}},"software":{"label":"software","category":{"label":"realm"}},"installation":{"label":"installation","category":{"label":"realm"}},"fedev":{"label":"front-end","longLabel":"front-end development","category":{"label":"task"}},"bedev":{"label":"back-end","longLabel":"back-end development","category":{"label":"task"}},"devops":{"label":"devops","category":{"label":"task"}},"design":{"label":"design","category":{"label":"task"}},"typesetting":{"label":"typesetting","category":{"label":"task"}},"js":{"label":"Javascript","category":{"label":"programming language"}},"coffee":{"label":"Coffee","longLabel":"Coffeescript","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"programming language"}},"es6":{"label":"ES6","longLabel":"Ecmascript 2015","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"programming language"}},"typescript":{"label":"Typescript","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"programming language"}},"node":{"label":"NodeJS","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"programming language"}},"php":{"label":"PHP","category":{"label":"programming language"}},"python":{"label":"Python","category":{"label":"programming language"}},"css":{"label":"CSS","category":{"label":"programming language"}},"sass":{"label":"Sass","parent":{"label":"CSS","category":{"label":"programming language"}},"category":{"label":"programming language"}},"less":{"label":"Less","parent":{"label":"CSS","category":{"label":"programming language"}},"category":{"label":"programming language"}},"stylus":{"label":"Stylus","parent":{"label":"CSS","category":{"label":"programming language"}},"category":{"label":"programming language"}},"styledcomponents":{"label":"Styled Components","parent":{"label":"CSS","category":{"label":"programming language"}},"category":{"label":"programming language"}},"cssnext":{"label":"cssnext","parent":{"label":"CSS","category":{"label":"programming language"}},"category":{"label":"programming language"}},"geojson":{"label":"Geojson","category":{"label":"programming language"}},"webgl":{"label":"WebGL","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"programming language"}},"java":{"label":"Java","category":{"label":"programming language"}},"scheme":{"label":"Scheme","category":{"label":"programming language"}},"flash":{"label":"Flash","category":{"label":"programming language"}},"actionscript":{"label":"Actionscript","parent":{"label":"Flash","category":{"label":"programming language"}},"category":{"label":"programming language"}},"shell":{"label":"shell","longLabel":"shell script","category":{"label":"programming language"}},"ruby":{"label":"Ruby","category":{"label":"programming language"}},"plainhtml":{"label":"plain HTML","category":{"label":"templating language"}},"jsx":{"label":"JSX","category":{"label":"templating language"}},"twig":{"label":"Twig","category":{"label":"templating language"}},"jinja2":{"label":"Jinja2","category":{"label":"templating language"}},"blade":{"label":"Blade","category":{"label":"templating language"}},"markdown":{"label":"Markdown","category":{"label":"templating language"}},"pug":{"label":"Pug","category":{"label":"templating language"}},"liquid":{"label":"Liquid","category":{"label":"templating language"}},"nunjucks":{"label":"Nunjucks","category":{"label":"templating language"}},"wordpress":{"label":"Wordpress","parent":{"label":"PHP","category":{"label":"programming language"}},"category":{"label":"CMS","longLabel":"content management system"}},"drupal":{"label":"Drupal","parent":{"label":"PHP","category":{"label":"programming language"}},"category":{"label":"CMS","longLabel":"content management system"}},"prismic":{"label":"Prismic","category":{"label":"CMS","longLabel":"content management system"}},"contentful":{"label":"Contentful","category":{"label":"CMS","longLabel":"content management system"}},"dadabik":{"label":"Dadabik","category":{"label":"CMS","longLabel":"content management system"}},"customcms":{"label":"custom CMS","longLabel":"Custom CMS built from scratch","category":{"label":"CMS","longLabel":"content management system"}},"craft":{"label":"Craft","longLabel":"Craft CMS","category":{"label":"CMS","longLabel":"content management system"}},"netlifycms":{"label":"Netlify CMS","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"CMS","longLabel":"content management system"}},"expo":{"label":"Expo","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"web development framework"}},"reactnative":{"label":"React Native","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"web development framework"}},"laravel":{"label":"Laravel","parent":{"label":"PHP","category":{"label":"programming language"}},"category":{"label":"web development framework"}},"lumen":{"label":"Lumen","parent":{"label":"PHP","category":{"label":"programming language"}},"category":{"label":"web development framework"}},"gatsby":{"label":"Gatsby","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"web development framework"}},"nextjs":{"label":"NextJS","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"web development framework"}},"django":{"label":"Django","parent":{"label":"Python","category":{"label":"programming language"}},"category":{"label":"web development framework"}},"yii":{"label":"Yii","parent":{"label":"PHP","category":{"label":"programming language"}},"category":{"label":"web development framework"}},"jekyll":{"label":"Jekyll","parent":{"label":"Ruby","category":{"label":"programming language"}},"category":{"label":"web development framework"}},"eleventy":{"label":"Eleventy","parent":{"label":"NodeJS","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"programming language"}},"category":{"label":"web development framework"}},"express":{"label":"Express","parent":{"label":"NodeJS","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"programming language"}},"category":{"label":"web development framework"}},"serverless":{"label":"Serverless","longLabel":"Serverless framework","category":{"label":"web development framework"}},"mysql":{"label":"MySQL","category":{"label":"database"}},"dynamodb":{"label":"DynamoDB","category":{"label":"database"}},"mariadb":{"label":"MariaDB","parent":{"label":"MySQL","category":{"label":"database"}},"category":{"label":"database"}},"postgres":{"label":"Postgres","category":{"label":"database"}},"quickbase":{"label":"Quickbase API","category":{"label":"database"}},"flatfile":{"label":"flat-file","longLabel":"flat-file database","category":{"label":"database"}},"graphql":{"label":"GraphQL","category":{"label":"pattern"}},"rest":{"label":"Rest","category":{"label":"pattern"}},"multilingual":{"label":"multilingual","category":{"label":"pattern"}},"sparql":{"label":"Sparql","category":{"label":"pattern"}},"linkeddata":{"label":"linked data","category":{"label":"pattern"}},"qti":{"label":"QTI","category":{"label":"pattern"}},"opensource":{"label":"open-source","category":{"label":"pattern"}},"gtk":{"label":"GTK","category":{"label":"pattern"}},"ecommerce":{"label":"e-commerce","category":{"label":"pattern"}},"websockets":{"label":"websockets","category":{"label":"pattern"}},"googlemaps":{"label":"GMaps","longLabel":"Google Maps","category":{"label":"API"}},"streetview":{"label":"Street View","longLabel":"Google Street View","category":{"label":"API"}},"webpurify":{"label":"WebPurify","category":{"label":"API"}},"filestack":{"label":"Filestack","category":{"label":"API"}},"facebook":{"label":"Facebook API","category":{"label":"API"}},"twitter":{"label":"Twitter API","category":{"label":"API"}},"wunderground":{"label":"Wunderground","longLabel":"Weather Underground API","category":{"label":"API"}},"musicbrainz":{"label":"Musicbrainz","longLabel":"Musicbrainz API","category":{"label":"API"}},"stripe":{"label":"Stripe","category":{"label":"API"}},"imgur":{"label":"Imgur","category":{"label":"API"}},"paypal":{"label":"PayPal","category":{"label":"API"}},"algolia":{"label":"Algolia","category":{"label":"API"}},"discord":{"label":"Discord","category":{"label":"API"}},"react":{"label":"React","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"library"}},"openlayers":{"label":"Openlayers","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"library"}},"threejs":{"label":"ThreeJS","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"library"}},"discordjs":{"label":"DiscordJS","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"library"}},"tailwind":{"label":"Tailwind","parent":{"label":"CSS","category":{"label":"programming language"}},"category":{"label":"library"}},"illustratorscripting":{"label":"Illustrator scripting","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"software scripting"}},"blenderscripting":{"label":"Blender scripting","parent":{"label":"Python","category":{"label":"programming language"}},"category":{"label":"software scripting"}},"imagemagick":{"label":"Imagemagick","category":{"label":"software scripting"}},"ffmpeg":{"label":"FFmpeg","category":{"label":"software scripting"}},"phantomjs":{"label":"PhantomJS","parent":{"label":"Javascript","category":{"label":"programming language"}},"category":{"label":"software scripting"}},"gimpscripting":{"label":"Gimp scripting","parent":{"label":"Scheme","category":{"label":"programming language"}},"category":{"label":"software scripting"}},"aws":{"label":"AWS","longLabel":"Amazon Web Services","category":{"label":"hosting solution"}},"heroku":{"label":"Heroku","category":{"label":"hosting solution"}},"netlify":{"label":"Netlify","category":{"label":"hosting solution"}},"railway":{"label":"Railway","category":{"label":"hosting solution"}},"static":{"label":"static","longLabel":"statically hosted","category":{"label":"hosting style"}},"lambda":{"label":"Lambda","longLabel":"AWS Lambda","parent":{"label":"AWS","longLabel":"Amazon Web Services","category":{"label":"hosting solution"}},"category":{"label":"hosting style"}},"vps":{"label":"VPS","longLabel":"virtual private server","category":{"label":"hosting style"}},"personal":{"label":"personal","category":{"label":"employer"}},"freelance":{"label":"freelance","category":{"label":"employer"}},"will":{"label":"Will","longLabel":"Will Creative","url":"https://hiwill.ca/","category":{"label":"employer"}},"assemblyco":{"label":"ACO","longLabel":"Assembly Co","url":"http://assemblyco.com/","category":{"label":"employer"}},"switch":{"label":"Switch","longLabel":"Switch United","url":"http://switchunited.com/","category":{"label":"employer"}},"contentandbrand":{"label":"C&B","longLabel":"Content and Brand","url":"https://contentandbrand.com/","category":{"label":"employer"}},"poundandgrain":{"label":"P&G","longLabel":"Pound and Grain","url":"https://poundandgrain.com/","category":{"label":"employer"}},"applydigital":{"label":"Apply","longLabel":"Apply Digital","url":"https://applydigital.co/","category":{"label":"employer"}},"tribal":{"label":"Tribal","longLabel":"Tribal Worldwide","url":"http://tribalworldwide.com/","category":{"label":"employer"}},"assemblydigital":{"label":"Assembly","longLabel":"Assembly Digital","url":"https://assemblydigital.com/","category":{"label":"employer"}},"blast":{"label":"Blast","longLabel":"Blast Radius","url":"http://www.blastradius.com/","category":{"label":"employer"}},"ecs":{"label":"ECS","longLabel":"Electronics and Computer Science, University of Southampton","url":"https://www.ecs.soton.ac.uk/","category":{"label":"employer"}},"susu":{"label":"Susu","longLabel":"University of Southampton Students’ Union","url":"http://www.susu.org/","category":{"label":"employer"}},"kor":{"label":"Kor","longLabel":"Kor Control","url":"https://korcontrol.com/","category":{"label":"employer"}}}}

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * chroma.js - JavaScript library for color conversions
	 *
	 * Copyright (c) 2011-2018, Gregor Aisch
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 * 1. Redistributions of source code must retain the above copyright notice, this
	 * list of conditions and the following disclaimer.
	 *
	 * 2. Redistributions in binary form must reproduce the above copyright notice,
	 * this list of conditions and the following disclaimer in the documentation
	 * and/or other materials provided with the distribution.
	 *
	 * 3. The name Gregor Aisch may not be used to endorse or promote products
	 * derived from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 *
	 * -------------------------------------------------------
	 *
	 * chroma.js includes colors from colorbrewer2.org, which are released under
	 * the following license:
	 *
	 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
	 * and The Pennsylvania State University.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing,
	 * software distributed under the License is distributed on an
	 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
	 * either express or implied. See the License for the specific
	 * language governing permissions and limitations under the License.
	 *
	 * ------------------------------------------------------
	 *
	 * Named colors are taken from X11 Color Names.
	 * http://www.w3.org/TR/css3-color/#svg-color
	 *
	 * @preserve
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.chroma = factory());
	}(this, (function () { 'use strict';
	
	    var limit = function (x, min, max) {
	        if ( min === void 0 ) min=0;
	        if ( max === void 0 ) max=1;
	
	        return x < min ? min : x > max ? max : x;
	    };
	
	    var clip_rgb = function (rgb) {
	        rgb._clipped = false;
	        rgb._unclipped = rgb.slice(0);
	        for (var i=0; i<=3; i++) {
	            if (i < 3) {
	                if (rgb[i] < 0 || rgb[i] > 255) { rgb._clipped = true; }
	                rgb[i] = limit(rgb[i], 0, 255);
	            } else if (i === 3) {
	                rgb[i] = limit(rgb[i], 0, 1);
	            }
	        }
	        return rgb;
	    };
	
	    // ported from jQuery's $.type
	    var classToType = {};
	    for (var i = 0, list = ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Undefined', 'Null']; i < list.length; i += 1) {
	        var name = list[i];
	
	        classToType[("[object " + name + "]")] = name.toLowerCase();
	    }
	    var type = function(obj) {
	        return classToType[Object.prototype.toString.call(obj)] || "object";
	    };
	
	    var unpack = function (args, keyOrder) {
	        if ( keyOrder === void 0 ) keyOrder=null;
	
	    	// if called with more than 3 arguments, we return the arguments
	        if (args.length >= 3) { return Array.prototype.slice.call(args); }
	        // with less than 3 args we check if first arg is object
	        // and use the keyOrder string to extract and sort properties
	    	if (type(args[0]) == 'object' && keyOrder) {
	    		return keyOrder.split('')
	    			.filter(function (k) { return args[0][k] !== undefined; })
	    			.map(function (k) { return args[0][k]; });
	    	}
	    	// otherwise we just return the first argument
	    	// (which we suppose is an array of args)
	        return args[0];
	    };
	
	    var last = function (args) {
	        if (args.length < 2) { return null; }
	        var l = args.length-1;
	        if (type(args[l]) == 'string') { return args[l].toLowerCase(); }
	        return null;
	    };
	
	    var PI = Math.PI;
	
	    var utils = {
	    	clip_rgb: clip_rgb,
	    	limit: limit,
	    	type: type,
	    	unpack: unpack,
	    	last: last,
	    	PI: PI,
	    	TWOPI: PI*2,
	    	PITHIRD: PI/3,
	    	DEG2RAD: PI / 180,
	    	RAD2DEG: 180 / PI
	    };
	
	    var input = {
	    	format: {},
	    	autodetect: []
	    };
	
	    var last$1 = utils.last;
	    var clip_rgb$1 = utils.clip_rgb;
	    var type$1 = utils.type;
	
	
	    var Color = function Color() {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var me = this;
	        if (type$1(args[0]) === 'object' &&
	            args[0].constructor &&
	            args[0].constructor === this.constructor) {
	            // the argument is already a Color instance
	            return args[0];
	        }
	
	        // last argument could be the mode
	        var mode = last$1(args);
	        var autodetect = false;
	
	        if (!mode) {
	            autodetect = true;
	            if (!input.sorted) {
	                input.autodetect = input.autodetect.sort(function (a,b) { return b.p - a.p; });
	                input.sorted = true;
	            }
	            // auto-detect format
	            for (var i = 0, list = input.autodetect; i < list.length; i += 1) {
	                var chk = list[i];
	
	                mode = chk.test.apply(chk, args);
	                if (mode) { break; }
	            }
	        }
	
	        if (input.format[mode]) {
	            var rgb = input.format[mode].apply(null, autodetect ? args : args.slice(0,-1));
	            me._rgb = clip_rgb$1(rgb);
	        } else {
	            throw new Error('unknown format: '+args);
	        }
	
	        // add alpha channel
	        if (me._rgb.length === 3) { me._rgb.push(1); }
	    };
	
	    Color.prototype.toString = function toString () {
	        if (type$1(this.hex) == 'function') { return this.hex(); }
	        return ("[" + (this._rgb.join(',')) + "]");
	    };
	
	    var Color_1 = Color;
	
	    var chroma = function () {
	    	var args = [], len = arguments.length;
	    	while ( len-- ) args[ len ] = arguments[ len ];
	
	    	return new (Function.prototype.bind.apply( chroma.Color, [ null ].concat( args) ));
	    };
	
	    chroma.Color = Color_1;
	    chroma.version = '2.0.2';
	
	    var chroma_1 = chroma;
	
	    var unpack$1 = utils.unpack;
	    var max = Math.max;
	
	    var rgb2cmyk = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var ref = unpack$1(args, 'rgb');
	        var r = ref[0];
	        var g = ref[1];
	        var b = ref[2];
	        r = r / 255;
	        g = g / 255;
	        b = b / 255;
	        var k = 1 - max(r,max(g,b));
	        var f = k < 1 ? 1 / (1-k) : 0;
	        var c = (1-r-k) * f;
	        var m = (1-g-k) * f;
	        var y = (1-b-k) * f;
	        return [c,m,y,k];
	    };
	
	    var rgb2cmyk_1 = rgb2cmyk;
	
	    var unpack$2 = utils.unpack;
	
	    var cmyk2rgb = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        args = unpack$2(args, 'cmyk');
	        var c = args[0];
	        var m = args[1];
	        var y = args[2];
	        var k = args[3];
	        var alpha = args.length > 4 ? args[4] : 1;
	        if (k === 1) { return [0,0,0,alpha]; }
	        return [
	            c >= 1 ? 0 : 255 * (1-c) * (1-k), // r
	            m >= 1 ? 0 : 255 * (1-m) * (1-k), // g
	            y >= 1 ? 0 : 255 * (1-y) * (1-k), // b
	            alpha
	        ];
	    };
	
	    var cmyk2rgb_1 = cmyk2rgb;
	
	    var unpack$3 = utils.unpack;
	    var type$2 = utils.type;
	
	
	
	    Color_1.prototype.cmyk = function() {
	        return rgb2cmyk_1(this._rgb);
	    };
	
	    chroma_1.cmyk = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['cmyk']) ));
	    };
	
	    input.format.cmyk = cmyk2rgb_1;
	
	    input.autodetect.push({
	        p: 2,
	        test: function () {
	            var args = [], len = arguments.length;
	            while ( len-- ) args[ len ] = arguments[ len ];
	
	            args = unpack$3(args, 'cmyk');
	            if (type$2(args) === 'array' && args.length === 4) {
	                return 'cmyk';
	            }
	        }
	    });
	
	    var unpack$4 = utils.unpack;
	    var last$2 = utils.last;
	    var rnd = function (a) { return Math.round(a*100)/100; };
	
	    /*
	     * supported arguments:
	     * - hsl2css(h,s,l)
	     * - hsl2css(h,s,l,a)
	     * - hsl2css([h,s,l], mode)
	     * - hsl2css([h,s,l,a], mode)
	     * - hsl2css({h,s,l,a}, mode)
	     */
	    var hsl2css = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var hsla = unpack$4(args, 'hsla');
	        var mode = last$2(args) || 'lsa';
	        hsla[0] = rnd(hsla[0] || 0);
	        hsla[1] = rnd(hsla[1]*100) + '%';
	        hsla[2] = rnd(hsla[2]*100) + '%';
	        if (mode === 'hsla' || (hsla.length > 3 && hsla[3]<1)) {
	            hsla[3] = hsla.length > 3 ? hsla[3] : 1;
	            mode = 'hsla';
	        } else {
	            hsla.length = 3;
	        }
	        return (mode + "(" + (hsla.join(',')) + ")");
	    };
	
	    var hsl2css_1 = hsl2css;
	
	    var unpack$5 = utils.unpack;
	
	    /*
	     * supported arguments:
	     * - rgb2hsl(r,g,b)
	     * - rgb2hsl(r,g,b,a)
	     * - rgb2hsl([r,g,b])
	     * - rgb2hsl([r,g,b,a])
	     * - rgb2hsl({r,g,b,a})
	     */
	    var rgb2hsl = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        args = unpack$5(args, 'rgba');
	        var r = args[0];
	        var g = args[1];
	        var b = args[2];
	
	        r /= 255;
	        g /= 255;
	        b /= 255;
	
	        var min = Math.min(r, g, b);
	        var max = Math.max(r, g, b);
	
	        var l = (max + min) / 2;
	        var s, h;
	
	        if (max === min){
	            s = 0;
	            h = Number.NaN;
	        } else {
	            s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
	        }
	
	        if (r == max) { h = (g - b) / (max - min); }
	        else if (g == max) { h = 2 + (b - r) / (max - min); }
	        else if (b == max) { h = 4 + (r - g) / (max - min); }
	
	        h *= 60;
	        if (h < 0) { h += 360; }
	        if (args.length>3 && args[3]!==undefined) { return [h,s,l,args[3]]; }
	        return [h,s,l];
	    };
	
	    var rgb2hsl_1 = rgb2hsl;
	
	    var unpack$6 = utils.unpack;
	    var last$3 = utils.last;
	
	
	    var round = Math.round;
	
	    /*
	     * supported arguments:
	     * - rgb2css(r,g,b)
	     * - rgb2css(r,g,b,a)
	     * - rgb2css([r,g,b], mode)
	     * - rgb2css([r,g,b,a], mode)
	     * - rgb2css({r,g,b,a}, mode)
	     */
	    var rgb2css = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var rgba = unpack$6(args, 'rgba');
	        var mode = last$3(args) || 'rgb';
	        if (mode.substr(0,3) == 'hsl') {
	            return hsl2css_1(rgb2hsl_1(rgba), mode);
	        }
	        rgba[0] = round(rgba[0]);
	        rgba[1] = round(rgba[1]);
	        rgba[2] = round(rgba[2]);
	        if (mode === 'rgba' || (rgba.length > 3 && rgba[3]<1)) {
	            rgba[3] = rgba.length > 3 ? rgba[3] : 1;
	            mode = 'rgba';
	        }
	        return (mode + "(" + (rgba.slice(0,mode==='rgb'?3:4).join(',')) + ")");
	    };
	
	    var rgb2css_1 = rgb2css;
	
	    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
	    var RE_HEXA = /^#?([A-Fa-f0-9]{8})$/;
	
	    var hex2rgb = function (hex) {
	        if (hex.match(RE_HEX)) {
	            // remove optional leading #
	            if (hex.length === 4 || hex.length === 7) {
	                hex = hex.substr(1);
	            }
	            // expand short-notation to full six-digit
	            if (hex.length === 3) {
	                hex = hex.split('');
	                hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
	            }
	            var u = parseInt(hex, 16);
	            var r = u >> 16;
	            var g = u >> 8 & 0xFF;
	            var b = u & 0xFF;
	            return [r,g,b,1];
	        }
	
	        // match rgba hex format, eg #FF000077
	        if (hex.match(RE_HEXA)) {
	            if (hex.length === 9) {
	                // remove optional leading #
	                hex = hex.substr(1);
	            }
	            var u$1 = parseInt(hex, 16);
	            var r$1 = u$1 >> 24 & 0xFF;
	            var g$1 = u$1 >> 16 & 0xFF;
	            var b$1 = u$1 >> 8 & 0xFF;
	            var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
	            return [r$1,g$1,b$1,a];
	        }
	
	        // we used to check for css colors here
	        // if _input.css? and rgb = _input.css hex
	        //     return rgb
	
	        throw new Error(("unknown hex color: " + hex));
	    };
	
	    var hex2rgb_1 = hex2rgb;
	
	    var unpack$7 = utils.unpack;
	    var round$1 = Math.round;
	
	    var hsl2rgb = function () {
	        var assign;
	
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	        args = unpack$7(args, 'hsl');
	        var h = args[0];
	        var s = args[1];
	        var l = args[2];
	        var r,g,b;
	        if (s === 0) {
	            r = g = b = l*255;
	        } else {
	            var t3 = [0,0,0];
	            var c = [0,0,0];
	            var t2 = l < 0.5 ? l * (1+s) : l+s-l*s;
	            var t1 = 2 * l - t2;
	            var h_ = h / 360;
	            t3[0] = h_ + 1/3;
	            t3[1] = h_;
	            t3[2] = h_ - 1/3;
	            for (var i=0; i<3; i++) {
	                if (t3[i] < 0) { t3[i] += 1; }
	                if (t3[i] > 1) { t3[i] -= 1; }
	                if (6 * t3[i] < 1)
	                    { c[i] = t1 + (t2 - t1) * 6 * t3[i]; }
	                else if (2 * t3[i] < 1)
	                    { c[i] = t2; }
	                else if (3 * t3[i] < 2)
	                    { c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6; }
	                else
	                    { c[i] = t1; }
	            }
	            (assign = [round$1(c[0]*255),round$1(c[1]*255),round$1(c[2]*255)], r = assign[0], g = assign[1], b = assign[2]);
	        }
	        if (args.length > 3) {
	            // keep alpha channel
	            return [r,g,b,args[3]];
	        }
	        return [r,g,b];
	    };
	
	    var hsl2rgb_1 = hsl2rgb;
	
	    /**
	    	X11 color names
	
	    	http://www.w3.org/TR/css3-color/#svg-color
	    */
	
	    var w3cx11 = {
	        aliceblue: '#f0f8ff',
	        antiquewhite: '#faebd7',
	        aqua: '#00ffff',
	        aquamarine: '#7fffd4',
	        azure: '#f0ffff',
	        beige: '#f5f5dc',
	        bisque: '#ffe4c4',
	        black: '#000000',
	        blanchedalmond: '#ffebcd',
	        blue: '#0000ff',
	        blueviolet: '#8a2be2',
	        brown: '#a52a2a',
	        burlywood: '#deb887',
	        cadetblue: '#5f9ea0',
	        chartreuse: '#7fff00',
	        chocolate: '#d2691e',
	        coral: '#ff7f50',
	        cornflower: '#6495ed',
	        cornflowerblue: '#6495ed',
	        cornsilk: '#fff8dc',
	        crimson: '#dc143c',
	        cyan: '#00ffff',
	        darkblue: '#00008b',
	        darkcyan: '#008b8b',
	        darkgoldenrod: '#b8860b',
	        darkgray: '#a9a9a9',
	        darkgreen: '#006400',
	        darkgrey: '#a9a9a9',
	        darkkhaki: '#bdb76b',
	        darkmagenta: '#8b008b',
	        darkolivegreen: '#556b2f',
	        darkorange: '#ff8c00',
	        darkorchid: '#9932cc',
	        darkred: '#8b0000',
	        darksalmon: '#e9967a',
	        darkseagreen: '#8fbc8f',
	        darkslateblue: '#483d8b',
	        darkslategray: '#2f4f4f',
	        darkslategrey: '#2f4f4f',
	        darkturquoise: '#00ced1',
	        darkviolet: '#9400d3',
	        deeppink: '#ff1493',
	        deepskyblue: '#00bfff',
	        dimgray: '#696969',
	        dimgrey: '#696969',
	        dodgerblue: '#1e90ff',
	        firebrick: '#b22222',
	        floralwhite: '#fffaf0',
	        forestgreen: '#228b22',
	        fuchsia: '#ff00ff',
	        gainsboro: '#dcdcdc',
	        ghostwhite: '#f8f8ff',
	        gold: '#ffd700',
	        goldenrod: '#daa520',
	        gray: '#808080',
	        green: '#008000',
	        greenyellow: '#adff2f',
	        grey: '#808080',
	        honeydew: '#f0fff0',
	        hotpink: '#ff69b4',
	        indianred: '#cd5c5c',
	        indigo: '#4b0082',
	        ivory: '#fffff0',
	        khaki: '#f0e68c',
	        laserlemon: '#ffff54',
	        lavender: '#e6e6fa',
	        lavenderblush: '#fff0f5',
	        lawngreen: '#7cfc00',
	        lemonchiffon: '#fffacd',
	        lightblue: '#add8e6',
	        lightcoral: '#f08080',
	        lightcyan: '#e0ffff',
	        lightgoldenrod: '#fafad2',
	        lightgoldenrodyellow: '#fafad2',
	        lightgray: '#d3d3d3',
	        lightgreen: '#90ee90',
	        lightgrey: '#d3d3d3',
	        lightpink: '#ffb6c1',
	        lightsalmon: '#ffa07a',
	        lightseagreen: '#20b2aa',
	        lightskyblue: '#87cefa',
	        lightslategray: '#778899',
	        lightslategrey: '#778899',
	        lightsteelblue: '#b0c4de',
	        lightyellow: '#ffffe0',
	        lime: '#00ff00',
	        limegreen: '#32cd32',
	        linen: '#faf0e6',
	        magenta: '#ff00ff',
	        maroon: '#800000',
	        maroon2: '#7f0000',
	        maroon3: '#b03060',
	        mediumaquamarine: '#66cdaa',
	        mediumblue: '#0000cd',
	        mediumorchid: '#ba55d3',
	        mediumpurple: '#9370db',
	        mediumseagreen: '#3cb371',
	        mediumslateblue: '#7b68ee',
	        mediumspringgreen: '#00fa9a',
	        mediumturquoise: '#48d1cc',
	        mediumvioletred: '#c71585',
	        midnightblue: '#191970',
	        mintcream: '#f5fffa',
	        mistyrose: '#ffe4e1',
	        moccasin: '#ffe4b5',
	        navajowhite: '#ffdead',
	        navy: '#000080',
	        oldlace: '#fdf5e6',
	        olive: '#808000',
	        olivedrab: '#6b8e23',
	        orange: '#ffa500',
	        orangered: '#ff4500',
	        orchid: '#da70d6',
	        palegoldenrod: '#eee8aa',
	        palegreen: '#98fb98',
	        paleturquoise: '#afeeee',
	        palevioletred: '#db7093',
	        papayawhip: '#ffefd5',
	        peachpuff: '#ffdab9',
	        peru: '#cd853f',
	        pink: '#ffc0cb',
	        plum: '#dda0dd',
	        powderblue: '#b0e0e6',
	        purple: '#800080',
	        purple2: '#7f007f',
	        purple3: '#a020f0',
	        rebeccapurple: '#663399',
	        red: '#ff0000',
	        rosybrown: '#bc8f8f',
	        royalblue: '#4169e1',
	        saddlebrown: '#8b4513',
	        salmon: '#fa8072',
	        sandybrown: '#f4a460',
	        seagreen: '#2e8b57',
	        seashell: '#fff5ee',
	        sienna: '#a0522d',
	        silver: '#c0c0c0',
	        skyblue: '#87ceeb',
	        slateblue: '#6a5acd',
	        slategray: '#708090',
	        slategrey: '#708090',
	        snow: '#fffafa',
	        springgreen: '#00ff7f',
	        steelblue: '#4682b4',
	        tan: '#d2b48c',
	        teal: '#008080',
	        thistle: '#d8bfd8',
	        tomato: '#ff6347',
	        turquoise: '#40e0d0',
	        violet: '#ee82ee',
	        wheat: '#f5deb3',
	        white: '#ffffff',
	        whitesmoke: '#f5f5f5',
	        yellow: '#ffff00',
	        yellowgreen: '#9acd32'
	    };
	
	    var w3cx11_1 = w3cx11;
	
	    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
	    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
	    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
	    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
	    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
	    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
	
	    var round$2 = Math.round;
	
	    var css2rgb = function (css) {
	        css = css.toLowerCase().trim();
	        // named X11 colors
	        if (w3cx11_1[css]) {
	            return hex2rgb_1(w3cx11_1[css]);
	        }
	        var m;
	
	        // rgb(250,20,0)
	        if ((m = css.match(RE_RGB))) {
	            var rgb = m.slice(1,4);
	            for (var i=0; i<3; i++) {
	                rgb[i] = +rgb[i];
	            }
	            rgb[3] = 1;  // default alpha
	            return rgb;
	        }
	
	        // rgba(250,20,0,0.4)
	        if ((m = css.match(RE_RGBA))) {
	            var rgb$1 = m.slice(1,5);
	            for (var i$1=0; i$1<4; i$1++) {
	                rgb$1[i$1] = +rgb$1[i$1];
	            }
	            return rgb$1;
	        }
	
	        // rgb(100%,0%,0%)
	        if ((m = css.match(RE_RGB_PCT))) {
	            var rgb$2 = m.slice(1,4);
	            for (var i$2=0; i$2<3; i$2++) {
	                rgb$2[i$2] = round$2(rgb$2[i$2] * 2.55);
	            }
	            rgb$2[3] = 1;  // default alpha
	            return rgb$2;
	        }
	
	        // rgba(100%,0%,0%,0.4)
	        if ((m = css.match(RE_RGBA_PCT))) {
	            var rgb$3 = m.slice(1,5);
	            for (var i$3=0; i$3<3; i$3++) {
	                rgb$3[i$3] = round$2(rgb$3[i$3] * 2.55);
	            }
	            rgb$3[3] = +rgb$3[3];
	            return rgb$3;
	        }
	
	        // hsl(0,100%,50%)
	        if ((m = css.match(RE_HSL))) {
	            var hsl = m.slice(1,4);
	            hsl[1] *= 0.01;
	            hsl[2] *= 0.01;
	            var rgb$4 = hsl2rgb_1(hsl);
	            rgb$4[3] = 1;
	            return rgb$4;
	        }
	
	        // hsla(0,100%,50%,0.5)
	        if ((m = css.match(RE_HSLA))) {
	            var hsl$1 = m.slice(1,4);
	            hsl$1[1] *= 0.01;
	            hsl$1[2] *= 0.01;
	            var rgb$5 = hsl2rgb_1(hsl$1);
	            rgb$5[3] = +m[4];  // default alpha = 1
	            return rgb$5;
	        }
	    };
	
	    css2rgb.test = function (s) {
	        return RE_RGB.test(s) ||
	            RE_RGBA.test(s) ||
	            RE_RGB_PCT.test(s) ||
	            RE_RGBA_PCT.test(s) ||
	            RE_HSL.test(s) ||
	            RE_HSLA.test(s);
	    };
	
	    var css2rgb_1 = css2rgb;
	
	    var type$3 = utils.type;
	
	
	
	
	    Color_1.prototype.css = function(mode) {
	        return rgb2css_1(this._rgb, mode);
	    };
	
	    chroma_1.css = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['css']) ));
	    };
	
	    input.format.css = css2rgb_1;
	
	    input.autodetect.push({
	        p: 5,
	        test: function (h) {
	            var rest = [], len = arguments.length - 1;
	            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];
	
	            if (!rest.length && type$3(h) === 'string' && css2rgb_1.test(h)) {
	                return 'css';
	            }
	        }
	    });
	
	    var unpack$8 = utils.unpack;
	
	    input.format.gl = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var rgb = unpack$8(args, 'rgba');
	        rgb[0] *= 255;
	        rgb[1] *= 255;
	        rgb[2] *= 255;
	        return rgb;
	    };
	
	    chroma_1.gl = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['gl']) ));
	    };
	
	    Color_1.prototype.gl = function() {
	        var rgb = this._rgb;
	        return [rgb[0]/255, rgb[1]/255, rgb[2]/255, rgb[3]];
	    };
	
	    var unpack$9 = utils.unpack;
	
	    var rgb2hcg = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var ref = unpack$9(args, 'rgb');
	        var r = ref[0];
	        var g = ref[1];
	        var b = ref[2];
	        var min = Math.min(r, g, b);
	        var max = Math.max(r, g, b);
	        var delta = max - min;
	        var c = delta * 100 / 255;
	        var _g = min / (255 - delta) * 100;
	        var h;
	        if (delta === 0) {
	            h = Number.NaN;
	        } else {
	            if (r === max) { h = (g - b) / delta; }
	            if (g === max) { h = 2+(b - r) / delta; }
	            if (b === max) { h = 4+(r - g) / delta; }
	            h *= 60;
	            if (h < 0) { h += 360; }
	        }
	        return [h, c, _g];
	    };
	
	    var rgb2hcg_1 = rgb2hcg;
	
	    var unpack$a = utils.unpack;
	    var floor = Math.floor;
	
	    /*
	     * this is basically just HSV with some minor tweaks
	     *
	     * hue.. [0..360]
	     * chroma .. [0..1]
	     * grayness .. [0..1]
	     */
	
	    var hcg2rgb = function () {
	        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
	
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	        args = unpack$a(args, 'hcg');
	        var h = args[0];
	        var c = args[1];
	        var _g = args[2];
	        var r,g,b;
	        _g = _g * 255;
	        var _c = c * 255;
	        if (c === 0) {
	            r = g = b = _g;
	        } else {
	            if (h === 360) { h = 0; }
	            if (h > 360) { h -= 360; }
	            if (h < 0) { h += 360; }
	            h /= 60;
	            var i = floor(h);
	            var f = h - i;
	            var p = _g * (1 - c);
	            var q = p + _c * (1 - f);
	            var t = p + _c * f;
	            var v = p + _c;
	            switch (i) {
	                case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
	                case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
	                case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
	                case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
	                case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
	                case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
	            }
	        }
	        return [r, g, b, args.length > 3 ? args[3] : 1];
	    };
	
	    var hcg2rgb_1 = hcg2rgb;
	
	    var unpack$b = utils.unpack;
	    var type$4 = utils.type;
	
	
	
	
	
	
	    Color_1.prototype.hcg = function() {
	        return rgb2hcg_1(this._rgb);
	    };
	
	    chroma_1.hcg = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcg']) ));
	    };
	
	    input.format.hcg = hcg2rgb_1;
	
	    input.autodetect.push({
	        p: 1,
	        test: function () {
	            var args = [], len = arguments.length;
	            while ( len-- ) args[ len ] = arguments[ len ];
	
	            args = unpack$b(args, 'hcg');
	            if (type$4(args) === 'array' && args.length === 3) {
	                return 'hcg';
	            }
	        }
	    });
	
	    var unpack$c = utils.unpack;
	    var last$4 = utils.last;
	    var round$3 = Math.round;
	
	    var rgb2hex = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var ref = unpack$c(args, 'rgba');
	        var r = ref[0];
	        var g = ref[1];
	        var b = ref[2];
	        var a = ref[3];
	        var mode = last$4(args) || 'auto';
	        if (a === undefined) { a = 1; }
	        if (mode === 'auto') {
	            mode = a < 1 ? 'rgba' : 'rgb';
	        }
	        r = round$3(r);
	        g = round$3(g);
	        b = round$3(b);
	        var u = r << 16 | g << 8 | b;
	        var str = "000000" + u.toString(16); //#.toUpperCase();
	        str = str.substr(str.length - 6);
	        var hxa = '0' + round$3(a * 255).toString(16);
	        hxa = hxa.substr(hxa.length - 2);
	        switch (mode.toLowerCase()) {
	            case 'rgba': return ("#" + str + hxa);
	            case 'argb': return ("#" + hxa + str);
	            default: return ("#" + str);
	        }
	    };
	
	    var rgb2hex_1 = rgb2hex;
	
	    var type$5 = utils.type;
	
	
	
	
	    Color_1.prototype.hex = function(mode) {
	        return rgb2hex_1(this._rgb, mode);
	    };
	
	    chroma_1.hex = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hex']) ));
	    };
	
	    input.format.hex = hex2rgb_1;
	    input.autodetect.push({
	        p: 4,
	        test: function (h) {
	            var rest = [], len = arguments.length - 1;
	            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];
	
	            if (!rest.length && type$5(h) === 'string' && [3,4,6,7,8,9].includes(h.length)) {
	                return 'hex';
	            }
	        }
	    });
	
	    var unpack$d = utils.unpack;
	    var TWOPI = utils.TWOPI;
	    var min = Math.min;
	    var sqrt = Math.sqrt;
	    var acos = Math.acos;
	
	    var rgb2hsi = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        /*
	        borrowed from here:
	        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
	        */
	        var ref = unpack$d(args, 'rgb');
	        var r = ref[0];
	        var g = ref[1];
	        var b = ref[2];
	        r /= 255;
	        g /= 255;
	        b /= 255;
	        var h;
	        var min_ = min(r,g,b);
	        var i = (r+g+b) / 3;
	        var s = i > 0 ? 1 - min_/i : 0;
	        if (s === 0) {
	            h = NaN;
	        } else {
	            h = ((r-g)+(r-b)) / 2;
	            h /= sqrt((r-g)*(r-g) + (r-b)*(g-b));
	            h = acos(h);
	            if (b > g) {
	                h = TWOPI - h;
	            }
	            h /= TWOPI;
	        }
	        return [h*360,s,i];
	    };
	
	    var rgb2hsi_1 = rgb2hsi;
	
	    var unpack$e = utils.unpack;
	    var limit$1 = utils.limit;
	    var TWOPI$1 = utils.TWOPI;
	    var PITHIRD = utils.PITHIRD;
	    var cos = Math.cos;
	
	    /*
	     * hue [0..360]
	     * saturation [0..1]
	     * intensity [0..1]
	     */
	    var hsi2rgb = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        /*
	        borrowed from here:
	        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
	        */
	        args = unpack$e(args, 'hsi');
	        var h = args[0];
	        var s = args[1];
	        var i = args[2];
	        var r,g,b;
	
	        if (isNaN(h)) { h = 0; }
	        if (isNaN(s)) { s = 0; }
	        // normalize hue
	        if (h > 360) { h -= 360; }
	        if (h < 0) { h += 360; }
	        h /= 360;
	        if (h < 1/3) {
	            b = (1-s)/3;
	            r = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
	            g = 1 - (b+r);
	        } else if (h < 2/3) {
	            h -= 1/3;
	            r = (1-s)/3;
	            g = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
	            b = 1 - (r+g);
	        } else {
	            h -= 2/3;
	            g = (1-s)/3;
	            b = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
	            r = 1 - (g+b);
	        }
	        r = limit$1(i*r*3);
	        g = limit$1(i*g*3);
	        b = limit$1(i*b*3);
	        return [r*255, g*255, b*255, args.length > 3 ? args[3] : 1];
	    };
	
	    var hsi2rgb_1 = hsi2rgb;
	
	    var unpack$f = utils.unpack;
	    var type$6 = utils.type;
	
	
	
	
	
	
	    Color_1.prototype.hsi = function() {
	        return rgb2hsi_1(this._rgb);
	    };
	
	    chroma_1.hsi = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsi']) ));
	    };
	
	    input.format.hsi = hsi2rgb_1;
	
	    input.autodetect.push({
	        p: 2,
	        test: function () {
	            var args = [], len = arguments.length;
	            while ( len-- ) args[ len ] = arguments[ len ];
	
	            args = unpack$f(args, 'hsi');
	            if (type$6(args) === 'array' && args.length === 3) {
	                return 'hsi';
	            }
	        }
	    });
	
	    var unpack$g = utils.unpack;
	    var type$7 = utils.type;
	
	
	
	
	
	
	    Color_1.prototype.hsl = function() {
	        return rgb2hsl_1(this._rgb);
	    };
	
	    chroma_1.hsl = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsl']) ));
	    };
	
	    input.format.hsl = hsl2rgb_1;
	
	    input.autodetect.push({
	        p: 2,
	        test: function () {
	            var args = [], len = arguments.length;
	            while ( len-- ) args[ len ] = arguments[ len ];
	
	            args = unpack$g(args, 'hsl');
	            if (type$7(args) === 'array' && args.length === 3) {
	                return 'hsl';
	            }
	        }
	    });
	
	    var unpack$h = utils.unpack;
	    var min$1 = Math.min;
	    var max$1 = Math.max;
	
	    /*
	     * supported arguments:
	     * - rgb2hsv(r,g,b)
	     * - rgb2hsv([r,g,b])
	     * - rgb2hsv({r,g,b})
	     */
	    var rgb2hsl$1 = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        args = unpack$h(args, 'rgb');
	        var r = args[0];
	        var g = args[1];
	        var b = args[2];
	        var min_ = min$1(r, g, b);
	        var max_ = max$1(r, g, b);
	        var delta = max_ - min_;
	        var h,s,v;
	        v = max_ / 255.0;
	        if (max_ === 0) {
	            h = Number.NaN;
	            s = 0;
	        } else {
	            s = delta / max_;
	            if (r === max_) { h = (g - b) / delta; }
	            if (g === max_) { h = 2+(b - r) / delta; }
	            if (b === max_) { h = 4+(r - g) / delta; }
	            h *= 60;
	            if (h < 0) { h += 360; }
	        }
	        return [h, s, v]
	    };
	
	    var rgb2hsv = rgb2hsl$1;
	
	    var unpack$i = utils.unpack;
	    var floor$1 = Math.floor;
	
	    var hsv2rgb = function () {
	        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
	
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	        args = unpack$i(args, 'hsv');
	        var h = args[0];
	        var s = args[1];
	        var v = args[2];
	        var r,g,b;
	        v *= 255;
	        if (s === 0) {
	            r = g = b = v;
	        } else {
	            if (h === 360) { h = 0; }
	            if (h > 360) { h -= 360; }
	            if (h < 0) { h += 360; }
	            h /= 60;
	
	            var i = floor$1(h);
	            var f = h - i;
	            var p = v * (1 - s);
	            var q = v * (1 - s * f);
	            var t = v * (1 - s * (1 - f));
	
	            switch (i) {
	                case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
	                case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
	                case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
	                case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
	                case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
	                case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
	            }
	        }
	        return [r,g,b,args.length > 3?args[3]:1];
	    };
	
	    var hsv2rgb_1 = hsv2rgb;
	
	    var unpack$j = utils.unpack;
	    var type$8 = utils.type;
	
	
	
	
	
	
	    Color_1.prototype.hsv = function() {
	        return rgb2hsv(this._rgb);
	    };
	
	    chroma_1.hsv = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsv']) ));
	    };
	
	    input.format.hsv = hsv2rgb_1;
	
	    input.autodetect.push({
	        p: 2,
	        test: function () {
	            var args = [], len = arguments.length;
	            while ( len-- ) args[ len ] = arguments[ len ];
	
	            args = unpack$j(args, 'hsv');
	            if (type$8(args) === 'array' && args.length === 3) {
	                return 'hsv';
	            }
	        }
	    });
	
	    var labConstants = {
	        // Corresponds roughly to RGB brighter/darker
	        Kn: 18,
	
	        // D65 standard referent
	        Xn: 0.950470,
	        Yn: 1,
	        Zn: 1.088830,
	
	        t0: 0.137931034,  // 4 / 29
	        t1: 0.206896552,  // 6 / 29
	        t2: 0.12841855,   // 3 * t1 * t1
	        t3: 0.008856452,  // t1 * t1 * t1
	    };
	
	    var unpack$k = utils.unpack;
	    var pow = Math.pow;
	
	    var rgb2lab = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var ref = unpack$k(args, 'rgb');
	        var r = ref[0];
	        var g = ref[1];
	        var b = ref[2];
	        var ref$1 = rgb2xyz(r,g,b);
	        var x = ref$1[0];
	        var y = ref$1[1];
	        var z = ref$1[2];
	        var l = 116 * y - 16;
	        return [l < 0 ? 0 : l, 500 * (x - y), 200 * (y - z)];
	    };
	
	    var rgb_xyz = function (r) {
	        if ((r /= 255) <= 0.04045) { return r / 12.92; }
	        return pow((r + 0.055) / 1.055, 2.4);
	    };
	
	    var xyz_lab = function (t) {
	        if (t > labConstants.t3) { return pow(t, 1 / 3); }
	        return t / labConstants.t2 + labConstants.t0;
	    };
	
	    var rgb2xyz = function (r,g,b) {
	        r = rgb_xyz(r);
	        g = rgb_xyz(g);
	        b = rgb_xyz(b);
	        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / labConstants.Xn);
	        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / labConstants.Yn);
	        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / labConstants.Zn);
	        return [x,y,z];
	    };
	
	    var rgb2lab_1 = rgb2lab;
	
	    var unpack$l = utils.unpack;
	    var pow$1 = Math.pow;
	
	    /*
	     * L* [0..100]
	     * a [-100..100]
	     * b [-100..100]
	     */
	    var lab2rgb = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        args = unpack$l(args, 'lab');
	        var l = args[0];
	        var a = args[1];
	        var b = args[2];
	        var x,y,z, r,g,b_;
	
	        y = (l + 16) / 116;
	        x = isNaN(a) ? y : y + a / 500;
	        z = isNaN(b) ? y : y - b / 200;
	
	        y = labConstants.Yn * lab_xyz(y);
	        x = labConstants.Xn * lab_xyz(x);
	        z = labConstants.Zn * lab_xyz(z);
	
	        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);  // D65 -> sRGB
	        g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
	        b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
	
	        return [r,g,b_,args.length > 3 ? args[3] : 1];
	    };
	
	    var xyz_rgb = function (r) {
	        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$1(r, 1 / 2.4) - 0.055)
	    };
	
	    var lab_xyz = function (t) {
	        return t > labConstants.t1 ? t * t * t : labConstants.t2 * (t - labConstants.t0)
	    };
	
	    var lab2rgb_1 = lab2rgb;
	
	    var unpack$m = utils.unpack;
	    var type$9 = utils.type;
	
	
	
	
	
	
	    Color_1.prototype.lab = function() {
	        return rgb2lab_1(this._rgb);
	    };
	
	    chroma_1.lab = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lab']) ));
	    };
	
	    input.format.lab = lab2rgb_1;
	
	    input.autodetect.push({
	        p: 2,
	        test: function () {
	            var args = [], len = arguments.length;
	            while ( len-- ) args[ len ] = arguments[ len ];
	
	            args = unpack$m(args, 'lab');
	            if (type$9(args) === 'array' && args.length === 3) {
	                return 'lab';
	            }
	        }
	    });
	
	    var unpack$n = utils.unpack;
	    var RAD2DEG = utils.RAD2DEG;
	    var sqrt$1 = Math.sqrt;
	    var atan2 = Math.atan2;
	    var round$4 = Math.round;
	
	    var lab2lch = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var ref = unpack$n(args, 'lab');
	        var l = ref[0];
	        var a = ref[1];
	        var b = ref[2];
	        var c = sqrt$1(a * a + b * b);
	        var h = (atan2(b, a) * RAD2DEG + 360) % 360;
	        if (round$4(c*10000) === 0) { h = Number.NaN; }
	        return [l, c, h];
	    };
	
	    var lab2lch_1 = lab2lch;
	
	    var unpack$o = utils.unpack;
	
	
	
	    var rgb2lch = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var ref = unpack$o(args, 'rgb');
	        var r = ref[0];
	        var g = ref[1];
	        var b = ref[2];
	        var ref$1 = rgb2lab_1(r,g,b);
	        var l = ref$1[0];
	        var a = ref$1[1];
	        var b_ = ref$1[2];
	        return lab2lch_1(l,a,b_);
	    };
	
	    var rgb2lch_1 = rgb2lch;
	
	    var unpack$p = utils.unpack;
	    var DEG2RAD = utils.DEG2RAD;
	    var sin = Math.sin;
	    var cos$1 = Math.cos;
	
	    var lch2lab = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        /*
	        Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
	        These formulas were invented by David Dalrymple to obtain maximum contrast without going
	        out of gamut if the parameters are in the range 0-1.
	
	        A saturation multiplier was added by Gregor Aisch
	        */
	        var ref = unpack$p(args, 'lch');
	        var l = ref[0];
	        var c = ref[1];
	        var h = ref[2];
	        if (isNaN(h)) { h = 0; }
	        h = h * DEG2RAD;
	        return [l, cos$1(h) * c, sin(h) * c]
	    };
	
	    var lch2lab_1 = lch2lab;
	
	    var unpack$q = utils.unpack;
	
	
	
	    var lch2rgb = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        args = unpack$q(args, 'lch');
	        var l = args[0];
	        var c = args[1];
	        var h = args[2];
	        var ref = lch2lab_1 (l,c,h);
	        var L = ref[0];
	        var a = ref[1];
	        var b_ = ref[2];
	        var ref$1 = lab2rgb_1 (L,a,b_);
	        var r = ref$1[0];
	        var g = ref$1[1];
	        var b = ref$1[2];
	        return [r, g, b, args.length > 3 ? args[3] : 1];
	    };
	
	    var lch2rgb_1 = lch2rgb;
	
	    var unpack$r = utils.unpack;
	
	
	    var hcl2rgb = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var hcl = unpack$r(args, 'hcl').reverse();
	        return lch2rgb_1.apply(void 0, hcl);
	    };
	
	    var hcl2rgb_1 = hcl2rgb;
	
	    var unpack$s = utils.unpack;
	    var type$a = utils.type;
	
	
	
	
	
	
	    Color_1.prototype.lch = function() { return rgb2lch_1(this._rgb); };
	    Color_1.prototype.hcl = function() { return rgb2lch_1(this._rgb).reverse(); };
	
	    chroma_1.lch = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lch']) ));
	    };
	    chroma_1.hcl = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcl']) ));
	    };
	
	    input.format.lch = lch2rgb_1;
	    input.format.hcl = hcl2rgb_1;
	
	    ['lch','hcl'].forEach(function (m) { return input.autodetect.push({
	        p: 2,
	        test: function () {
	            var args = [], len = arguments.length;
	            while ( len-- ) args[ len ] = arguments[ len ];
	
	            args = unpack$s(args, m);
	            if (type$a(args) === 'array' && args.length === 3) {
	                return m;
	            }
	        }
	    }); });
	
	    var type$b = utils.type;
	
	
	
	
	
	    Color_1.prototype.name = function() {
	        var hex = rgb2hex_1(this._rgb, 'rgb');
	        for (var i = 0, list = Object.keys(w3cx11_1); i < list.length; i += 1) {
	            var n = list[i];
	
	            if (w3cx11_1[n] === hex) { return n.toLowerCase(); }
	        }
	        return hex;
	    };
	
	    input.format.named = function (name) {
	        name = name.toLowerCase();
	        if (w3cx11_1[name]) { return hex2rgb_1(w3cx11_1[name]); }
	        throw new Error('unknown color name: '+name);
	    };
	
	    input.autodetect.push({
	        p: 5,
	        test: function (h) {
	            var rest = [], len = arguments.length - 1;
	            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];
	
	            if (!rest.length && type$b(h) === 'string' && w3cx11_1[h.toLowerCase()]) {
	                return 'named';
	            }
	        }
	    });
	
	    var unpack$t = utils.unpack;
	
	    var rgb2num = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var ref = unpack$t(args, 'rgb');
	        var r = ref[0];
	        var g = ref[1];
	        var b = ref[2];
	        return (r << 16) + (g << 8) + b;
	    };
	
	    var rgb2num_1 = rgb2num;
	
	    var type$c = utils.type;
	
	    var num2rgb = function (num) {
	        if (type$c(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
	            var r = num >> 16;
	            var g = (num >> 8) & 0xFF;
	            var b = num & 0xFF;
	            return [r,g,b,1];
	        }
	        throw new Error("unknown num color: "+num);
	    };
	
	    var num2rgb_1 = num2rgb;
	
	    var type$d = utils.type;
	
	
	
	    Color_1.prototype.num = function() {
	        return rgb2num_1(this._rgb);
	    };
	
	    chroma_1.num = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['num']) ));
	    };
	
	    input.format.num = num2rgb_1;
	
	    input.autodetect.push({
	        p: 5,
	        test: function () {
	            var args = [], len = arguments.length;
	            while ( len-- ) args[ len ] = arguments[ len ];
	
	            if (args.length === 1 && type$d(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xFFFFFF) {
	                return 'num';
	            }
	        }
	    });
	
	    var unpack$u = utils.unpack;
	    var type$e = utils.type;
	    var round$5 = Math.round;
	
	    Color_1.prototype.rgb = function(rnd) {
	        if ( rnd === void 0 ) rnd=true;
	
	        if (rnd === false) { return this._rgb.slice(0,3); }
	        return this._rgb.slice(0,3).map(round$5);
	    };
	
	    Color_1.prototype.rgba = function(rnd) {
	        if ( rnd === void 0 ) rnd=true;
	
	        return this._rgb.slice(0,4).map(function (v,i) {
	            return i<3 ? (rnd === false ? v : round$5(v)) : v;
	        });
	    };
	
	    chroma_1.rgb = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['rgb']) ));
	    };
	
	    input.format.rgb = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var rgba = unpack$u(args, 'rgba');
	        if (rgba[3] === undefined) { rgba[3] = 1; }
	        return rgba;
	    };
	
	    input.autodetect.push({
	        p: 3,
	        test: function () {
	            var args = [], len = arguments.length;
	            while ( len-- ) args[ len ] = arguments[ len ];
	
	            args = unpack$u(args, 'rgba');
	            if (type$e(args) === 'array' && (args.length === 3 ||
	                args.length === 4 && type$e(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) {
	                return 'rgb';
	            }
	        }
	    });
	
	    /*
	     * Based on implementation by Neil Bartlett
	     * https://github.com/neilbartlett/color-temperature
	     */
	
	    var log = Math.log;
	
	    var temperature2rgb = function (kelvin) {
	        var temp = kelvin / 100;
	        var r,g,b;
	        if (temp < 66) {
	            r = 255;
	            g = -155.25485562709179 - 0.44596950469579133 * (g = temp-2) + 104.49216199393888 * log(g);
	            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp-10) + 115.67994401066147 * log(b);
	        } else {
	            r = 351.97690566805693 + 0.114206453784165 * (r = temp-55) - 40.25366309332127 * log(r);
	            g = 325.4494125711974 + 0.07943456536662342 * (g = temp-50) - 28.0852963507957 * log(g);
	            b = 255;
	        }
	        return [r,g,b,1];
	    };
	
	    var temperature2rgb_1 = temperature2rgb;
	
	    /*
	     * Based on implementation by Neil Bartlett
	     * https://github.com/neilbartlett/color-temperature
	     **/
	
	
	    var unpack$v = utils.unpack;
	    var round$6 = Math.round;
	
	    var rgb2temperature = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        var rgb = unpack$v(args, 'rgb');
	        var r = rgb[0], b = rgb[2];
	        var minTemp = 1000;
	        var maxTemp = 40000;
	        var eps = 0.4;
	        var temp;
	        while (maxTemp - minTemp > eps) {
	            temp = (maxTemp + minTemp) * 0.5;
	            var rgb$1 = temperature2rgb_1(temp);
	            if ((rgb$1[2] / rgb$1[0]) >= (b / r)) {
	                maxTemp = temp;
	            } else {
	                minTemp = temp;
	            }
	        }
	        return round$6(temp);
	    };
	
	    var rgb2temperature_1 = rgb2temperature;
	
	    Color_1.prototype.temp =
	    Color_1.prototype.kelvin =
	    Color_1.prototype.temperature = function() {
	        return rgb2temperature_1(this._rgb);
	    };
	
	    chroma_1.temp =
	    chroma_1.kelvin =
	    chroma_1.temperature = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['temp']) ));
	    };
	
	    input.format.temp =
	    input.format.kelvin =
	    input.format.temperature = temperature2rgb_1;
	
	    var type$f = utils.type;
	
	    Color_1.prototype.alpha = function(a, mutate) {
	        if ( mutate === void 0 ) mutate=false;
	
	        if (a !== undefined && type$f(a) === 'number') {
	            if (mutate) {
	                this._rgb[3] = a;
	                return this;
	            }
	            return new Color_1([this._rgb[0], this._rgb[1], this._rgb[2], a], 'rgb');
	        }
	        return this._rgb[3];
	    };
	
	    Color_1.prototype.clipped = function() {
	        return this._rgb._clipped || false;
	    };
	
	    Color_1.prototype.darken = function(amount) {
	    	if ( amount === void 0 ) amount=1;
	
	    	var me = this;
	    	var lab = me.lab();
	    	lab[0] -= labConstants.Kn * amount;
	    	return new Color_1(lab, 'lab').alpha(me.alpha(), true);
	    };
	
	    Color_1.prototype.brighten = function(amount) {
	    	if ( amount === void 0 ) amount=1;
	
	    	return this.darken(-amount);
	    };
	
	    Color_1.prototype.darker = Color_1.prototype.darken;
	    Color_1.prototype.brighter = Color_1.prototype.brighten;
	
	    Color_1.prototype.get = function(mc) {
	        var ref = mc.split('.');
	        var mode = ref[0];
	        var channel = ref[1];
	        var src = this[mode]();
	        if (channel) {
	            var i = mode.indexOf(channel);
	            if (i > -1) { return src[i]; }
	            throw new Error(("unknown channel " + channel + " in mode " + mode));
	        } else {
	            return src;
	        }
	    };
	
	    var type$g = utils.type;
	    var pow$2 = Math.pow;
	
	    var EPS = 1e-7;
	    var MAX_ITER = 20;
	
	    Color_1.prototype.luminance = function(lum) {
	        if (lum !== undefined && type$g(lum) === 'number') {
	            if (lum === 0) {
	                // return pure black
	                return new Color_1([0,0,0,this._rgb[3]], 'rgb');
	            }
	            if (lum === 1) {
	                // return pure white
	                return new Color_1([255,255,255,this._rgb[3]], 'rgb');
	            }
	            // compute new color using...
	            var cur_lum = this.luminance();
	            var mode = 'rgb';
	            var max_iter = MAX_ITER;
	
	            var test = function (low, high) {
	                var mid = low.interpolate(high, 0.5, mode);
	                var lm = mid.luminance();
	                if (Math.abs(lum - lm) < EPS || !max_iter--) {
	                    // close enough
	                    return mid;
	                }
	                return lm > lum ? test(low, mid) : test(mid, high);
	            };
	
	            var rgb = (cur_lum > lum ? test(new Color_1([0,0,0]), this) : test(this, new Color_1([255,255,255]))).rgb();
	            return new Color_1(rgb.concat( [this._rgb[3]]));
	        }
	        return rgb2luminance.apply(void 0, (this._rgb).slice(0,3));
	    };
	
	
	    var rgb2luminance = function (r,g,b) {
	        // relative luminance
	        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	        r = luminance_x(r);
	        g = luminance_x(g);
	        b = luminance_x(b);
	        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
	    };
	
	    var luminance_x = function (x) {
	        x /= 255;
	        return x <= 0.03928 ? x/12.92 : pow$2((x+0.055)/1.055, 2.4);
	    };
	
	    var interpolator = {};
	
	    var type$h = utils.type;
	
	
	    var mix = function (col1, col2, f) {
	        if ( f === void 0 ) f=0.5;
	        var rest = [], len = arguments.length - 3;
	        while ( len-- > 0 ) rest[ len ] = arguments[ len + 3 ];
	
	        var mode = rest[0] || 'lrgb';
	        if (!interpolator[mode] && !rest.length) {
	            // fall back to the first supported mode
	            mode = Object.keys(interpolator)[0];
	        }
	        if (!interpolator[mode]) {
	            throw new Error(("interpolation mode " + mode + " is not defined"));
	        }
	        if (type$h(col1) !== 'object') { col1 = new Color_1(col1); }
	        if (type$h(col2) !== 'object') { col2 = new Color_1(col2); }
	        return interpolator[mode](col1, col2, f)
	            .alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
	    };
	
	    Color_1.prototype.mix =
	    Color_1.prototype.interpolate = function(col2, f) {
	    	if ( f === void 0 ) f=0.5;
	    	var rest = [], len = arguments.length - 2;
	    	while ( len-- > 0 ) rest[ len ] = arguments[ len + 2 ];
	
	    	return mix.apply(void 0, [ this, col2, f ].concat( rest ));
	    };
	
	    Color_1.prototype.premultiply = function(mutate) {
	    	if ( mutate === void 0 ) mutate=false;
	
	    	var rgb = this._rgb;
	    	var a = rgb[3];
	    	if (mutate) {
	    		this._rgb = [rgb[0]*a, rgb[1]*a, rgb[2]*a, a];
	    		return this;
	    	} else {
	    		return new Color_1([rgb[0]*a, rgb[1]*a, rgb[2]*a, a], 'rgb');
	    	}
	    };
	
	    Color_1.prototype.saturate = function(amount) {
	    	if ( amount === void 0 ) amount=1;
	
	    	var me = this;
	    	var lch = me.lch();
	    	lch[1] += labConstants.Kn * amount;
	    	if (lch[1] < 0) { lch[1] = 0; }
	    	return new Color_1(lch, 'lch').alpha(me.alpha(), true);
	    };
	
	    Color_1.prototype.desaturate = function(amount) {
	    	if ( amount === void 0 ) amount=1;
	
	    	return this.saturate(-amount);
	    };
	
	    var type$i = utils.type;
	
	    Color_1.prototype.set = function(mc, value, mutate) {
	        if ( mutate === void 0 ) mutate=false;
	
	        var ref = mc.split('.');
	        var mode = ref[0];
	        var channel = ref[1];
	        var src = this[mode]();
	        if (channel) {
	            var i = mode.indexOf(channel);
	            if (i > -1) {
	                if (type$i(value) == 'string') {
	                    switch(value.charAt(0)) {
	                        case '+': src[i] += +value; break;
	                        case '-': src[i] += +value; break;
	                        case '*': src[i] *= +(value.substr(1)); break;
	                        case '/': src[i] /= +(value.substr(1)); break;
	                        default: src[i] = +value;
	                    }
	                } else if (type$i(value) === 'number') {
	                    src[i] = value;
	                } else {
	                    throw new Error("unsupported value for Color.set");
	                }
	                var out = new Color_1(src, mode);
	                if (mutate) {
	                    this._rgb = out._rgb;
	                    return this;
	                }
	                return out;
	            }
	            throw new Error(("unknown channel " + channel + " in mode " + mode));
	        } else {
	            return src;
	        }
	    };
	
	    var rgb$1 = function (col1, col2, f) {
	        var xyz0 = col1._rgb;
	        var xyz1 = col2._rgb;
	        return new Color_1(
	            xyz0[0] + f * (xyz1[0]-xyz0[0]),
	            xyz0[1] + f * (xyz1[1]-xyz0[1]),
	            xyz0[2] + f * (xyz1[2]-xyz0[2]),
	            'rgb'
	        )
	    };
	
	    // register interpolator
	    interpolator.rgb = rgb$1;
	
	    var sqrt$2 = Math.sqrt;
	    var pow$3 = Math.pow;
	
	    var lrgb = function (col1, col2, f) {
	        var ref = col1._rgb;
	        var x1 = ref[0];
	        var y1 = ref[1];
	        var z1 = ref[2];
	        var ref$1 = col2._rgb;
	        var x2 = ref$1[0];
	        var y2 = ref$1[1];
	        var z2 = ref$1[2];
	        return new Color_1(
	            sqrt$2(pow$3(x1,2) * (1-f) + pow$3(x2,2) * f),
	            sqrt$2(pow$3(y1,2) * (1-f) + pow$3(y2,2) * f),
	            sqrt$2(pow$3(z1,2) * (1-f) + pow$3(z2,2) * f),
	            'rgb'
	        )
	    };
	
	    // register interpolator
	    interpolator.lrgb = lrgb;
	
	    var lab$1 = function (col1, col2, f) {
	        var xyz0 = col1.lab();
	        var xyz1 = col2.lab();
	        return new Color_1(
	            xyz0[0] + f * (xyz1[0]-xyz0[0]),
	            xyz0[1] + f * (xyz1[1]-xyz0[1]),
	            xyz0[2] + f * (xyz1[2]-xyz0[2]),
	            'lab'
	        )
	    };
	
	    // register interpolator
	    interpolator.lab = lab$1;
	
	    var _hsx = function (col1, col2, f, m) {
	        var assign, assign$1;
	
	        var xyz0, xyz1;
	        if (m === 'hsl') {
	            xyz0 = col1.hsl();
	            xyz1 = col2.hsl();
	        } else if (m === 'hsv') {
	            xyz0 = col1.hsv();
	            xyz1 = col2.hsv();
	        } else if (m === 'hcg') {
	            xyz0 = col1.hcg();
	            xyz1 = col2.hcg();
	        } else if (m === 'hsi') {
	            xyz0 = col1.hsi();
	            xyz1 = col2.hsi();
	        } else if (m === 'lch' || m === 'hcl') {
	            m = 'hcl';
	            xyz0 = col1.hcl();
	            xyz1 = col2.hcl();
	        }
	
	        var hue0, hue1, sat0, sat1, lbv0, lbv1;
	        if (m.substr(0, 1) === 'h') {
	            (assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2]);
	            (assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2]);
	        }
	
	        var sat, hue, lbv, dh;
	
	        if (!isNaN(hue0) && !isNaN(hue1)) {
	            // both colors have hue
	            if (hue1 > hue0 && hue1 - hue0 > 180) {
	                dh = hue1-(hue0+360);
	            } else if (hue1 < hue0 && hue0 - hue1 > 180) {
	                dh = hue1+360-hue0;
	            } else{
	                dh = hue1 - hue0;
	            }
	            hue = hue0 + f * dh;
	        } else if (!isNaN(hue0)) {
	            hue = hue0;
	            if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') { sat = sat0; }
	        } else if (!isNaN(hue1)) {
	            hue = hue1;
	            if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') { sat = sat1; }
	        } else {
	            hue = Number.NaN;
	        }
	
	        if (sat === undefined) { sat = sat0 + f * (sat1 - sat0); }
	        lbv = lbv0 + f * (lbv1-lbv0);
	        return new Color_1([hue, sat, lbv], m);
	    };
	
	    var lch$1 = function (col1, col2, f) {
	    	return _hsx(col1, col2, f, 'lch');
	    };
	
	    // register interpolator
	    interpolator.lch = lch$1;
	    interpolator.hcl = lch$1;
	
	    var num$1 = function (col1, col2, f) {
	        var c1 = col1.num();
	        var c2 = col2.num();
	        return new Color_1(c1 + f * (c2-c1), 'num')
	    };
	
	    // register interpolator
	    interpolator.num = num$1;
	
	    var hcg$1 = function (col1, col2, f) {
	    	return _hsx(col1, col2, f, 'hcg');
	    };
	
	    // register interpolator
	    interpolator.hcg = hcg$1;
	
	    var hsi$1 = function (col1, col2, f) {
	    	return _hsx(col1, col2, f, 'hsi');
	    };
	
	    // register interpolator
	    interpolator.hsi = hsi$1;
	
	    var hsl$1 = function (col1, col2, f) {
	    	return _hsx(col1, col2, f, 'hsl');
	    };
	
	    // register interpolator
	    interpolator.hsl = hsl$1;
	
	    var hsv$1 = function (col1, col2, f) {
	    	return _hsx(col1, col2, f, 'hsv');
	    };
	
	    // register interpolator
	    interpolator.hsv = hsv$1;
	
	    var clip_rgb$2 = utils.clip_rgb;
	    var pow$4 = Math.pow;
	    var sqrt$3 = Math.sqrt;
	    var PI$1 = Math.PI;
	    var cos$2 = Math.cos;
	    var sin$1 = Math.sin;
	    var atan2$1 = Math.atan2;
	
	    var average = function (colors, mode) {
	        if ( mode === void 0 ) mode='lrgb';
	
	        var l = colors.length;
	        // convert colors to Color objects
	        colors = colors.map(function (c) { return new Color_1(c); });
	        if (mode === 'lrgb') {
	            return _average_lrgb(colors)
	        }
	        var first = colors.shift();
	        var xyz = first.get(mode);
	        var cnt = [];
	        var dx = 0;
	        var dy = 0;
	        // initial color
	        for (var i=0; i<xyz.length; i++) {
	            xyz[i] = xyz[i] || 0;
	            cnt.push(isNaN(xyz[i]) ? 0 : 1);
	            if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
	                var A = xyz[i] / 180 * PI$1;
	                dx += cos$2(A);
	                dy += sin$1(A);
	            }
	        }
	
	        var alpha = first.alpha();
	        colors.forEach(function (c) {
	            var xyz2 = c.get(mode);
	            alpha += c.alpha();
	            for (var i=0; i<xyz.length; i++) {
	                if (!isNaN(xyz2[i])) {
	                    cnt[i]++;
	                    if (mode.charAt(i) === 'h') {
	                        var A = xyz2[i] / 180 * PI$1;
	                        dx += cos$2(A);
	                        dy += sin$1(A);
	                    } else {
	                        xyz[i] += xyz2[i];
	                    }
	                }
	            }
	        });
	
	        for (var i$1=0; i$1<xyz.length; i$1++) {
	            if (mode.charAt(i$1) === 'h') {
	                var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
	                while (A$1 < 0) { A$1 += 360; }
	                while (A$1 >= 360) { A$1 -= 360; }
	                xyz[i$1] = A$1;
	            } else {
	                xyz[i$1] = xyz[i$1]/cnt[i$1];
	            }
	        }
	        alpha /= l;
	        return (new Color_1(xyz, mode)).alpha(alpha > 0.99999 ? 1 : alpha, true);
	    };
	
	
	    var _average_lrgb = function (colors) {
	        var l = colors.length;
	        var f = 1/l;
	        var xyz = [0,0,0,0];
	        for (var i = 0, list = colors; i < list.length; i += 1) {
	            var col = list[i];
	
	            var rgb = col._rgb;
	            xyz[0] += pow$4(rgb[0],2) * f;
	            xyz[1] += pow$4(rgb[1],2) * f;
	            xyz[2] += pow$4(rgb[2],2) * f;
	            xyz[3] += rgb[3] * f;
	        }
	        xyz[0] = sqrt$3(xyz[0]);
	        xyz[1] = sqrt$3(xyz[1]);
	        xyz[2] = sqrt$3(xyz[2]);
	        if (xyz[3] > 0.9999999) { xyz[3] = 1; }
	        return new Color_1(clip_rgb$2(xyz));
	    };
	
	    // minimal multi-purpose interface
	
	    // @requires utils color analyze
	
	
	    var type$j = utils.type;
	
	    var pow$5 = Math.pow;
	
	    var scale = function(colors) {
	
	        // constructor
	        var _mode = 'rgb';
	        var _nacol = chroma_1('#ccc');
	        var _spread = 0;
	        // const _fixed = false;
	        var _domain = [0, 1];
	        var _pos = [];
	        var _padding = [0,0];
	        var _classes = false;
	        var _colors = [];
	        var _out = false;
	        var _min = 0;
	        var _max = 1;
	        var _correctLightness = false;
	        var _colorCache = {};
	        var _useCache = true;
	        var _gamma = 1;
	
	        // private methods
	
	        var setColors = function(colors) {
	            colors = colors || ['#fff', '#000'];
	            if (colors && type$j(colors) === 'string' && chroma_1.brewer &&
	                chroma_1.brewer[colors.toLowerCase()]) {
	                colors = chroma_1.brewer[colors.toLowerCase()];
	            }
	            if (type$j(colors) === 'array') {
	                // handle single color
	                if (colors.length === 1) {
	                    colors = [colors[0], colors[0]];
	                }
	                // make a copy of the colors
	                colors = colors.slice(0);
	                // convert to chroma classes
	                for (var c=0; c<colors.length; c++) {
	                    colors[c] = chroma_1(colors[c]);
	                }
	                // auto-fill color position
	                _pos.length = 0;
	                for (var c$1=0; c$1<colors.length; c$1++) {
	                    _pos.push(c$1/(colors.length-1));
	                }
	            }
	            resetCache();
	            return _colors = colors;
	        };
	
	        var getClass = function(value) {
	            if (_classes != null) {
	                var n = _classes.length-1;
	                var i = 0;
	                while (i < n && value >= _classes[i]) {
	                    i++;
	                }
	                return i-1;
	            }
	            return 0;
	        };
	
	        var tmap = function (t) { return t; };
	
	        // const classifyValue = function(value) {
	        //     let val = value;
	        //     if (_classes.length > 2) {
	        //         const n = _classes.length-1;
	        //         const i = getClass(value);
	        //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
	        //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
	        //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
	        //     }
	        //     return val;
	        // };
	
	        var getColor = function(val, bypassMap) {
	            var col, t;
	            if (bypassMap == null) { bypassMap = false; }
	            if (isNaN(val) || (val === null)) { return _nacol; }
	            if (!bypassMap) {
	                if (_classes && (_classes.length > 2)) {
	                    // find the class
	                    var c = getClass(val);
	                    t = c / (_classes.length-2);
	                } else if (_max !== _min) {
	                    // just interpolate between min/max
	                    t = (val - _min) / (_max - _min);
	                } else {
	                    t = 1;
	                }
	            } else {
	                t = val;
	            }
	
	            if (!bypassMap) {
	                t = tmap(t);  // lightness correction
	            }
	
	            if (_gamma !== 1) { t = pow$5(t, _gamma); }
	
	            t = _padding[0] + (t * (1 - _padding[0] - _padding[1]));
	
	            t = Math.min(1, Math.max(0, t));
	
	            var k = Math.floor(t * 10000);
	
	            if (_useCache && _colorCache[k]) {
	                col = _colorCache[k];
	            } else {
	                if (type$j(_colors) === 'array') {
	                    //for i in [0.._pos.length-1]
	                    for (var i=0; i<_pos.length; i++) {
	                        var p = _pos[i];
	                        if (t <= p) {
	                            col = _colors[i];
	                            break;
	                        }
	                        if ((t >= p) && (i === (_pos.length-1))) {
	                            col = _colors[i];
	                            break;
	                        }
	                        if (t > p && t < _pos[i+1]) {
	                            t = (t-p)/(_pos[i+1]-p);
	                            col = chroma_1.interpolate(_colors[i], _colors[i+1], t, _mode);
	                            break;
	                        }
	                    }
	                } else if (type$j(_colors) === 'function') {
	                    col = _colors(t);
	                }
	                if (_useCache) { _colorCache[k] = col; }
	            }
	            return col;
	        };
	
	        var resetCache = function () { return _colorCache = {}; };
	
	        setColors(colors);
	
	        // public interface
	
	        var f = function(v) {
	            var c = chroma_1(getColor(v));
	            if (_out && c[_out]) { return c[_out](); } else { return c; }
	        };
	
	        f.classes = function(classes) {
	            if (classes != null) {
	                if (type$j(classes) === 'array') {
	                    _classes = classes;
	                    _domain = [classes[0], classes[classes.length-1]];
	                } else {
	                    var d = chroma_1.analyze(_domain);
	                    if (classes === 0) {
	                        _classes = [d.min, d.max];
	                    } else {
	                        _classes = chroma_1.limits(d, 'e', classes);
	                    }
	                }
	                return f;
	            }
	            return _classes;
	        };
	
	
	        f.domain = function(domain) {
	            if (!arguments.length) {
	                return _domain;
	            }
	            _min = domain[0];
	            _max = domain[domain.length-1];
	            _pos = [];
	            var k = _colors.length;
	            if ((domain.length === k) && (_min !== _max)) {
	                // update positions
	                for (var i = 0, list = Array.from(domain); i < list.length; i += 1) {
	                    var d = list[i];
	
	                  _pos.push((d-_min) / (_max-_min));
	                }
	            } else {
	                for (var c=0; c<k; c++) {
	                    _pos.push(c/(k-1));
	                }
	            }
	            _domain = [_min, _max];
	            return f;
	        };
	
	        f.mode = function(_m) {
	            if (!arguments.length) {
	                return _mode;
	            }
	            _mode = _m;
	            resetCache();
	            return f;
	        };
	
	        f.range = function(colors, _pos) {
	            setColors(colors, _pos);
	            return f;
	        };
	
	        f.out = function(_o) {
	            _out = _o;
	            return f;
	        };
	
	        f.spread = function(val) {
	            if (!arguments.length) {
	                return _spread;
	            }
	            _spread = val;
	            return f;
	        };
	
	        f.correctLightness = function(v) {
	            if (v == null) { v = true; }
	            _correctLightness = v;
	            resetCache();
	            if (_correctLightness) {
	                tmap = function(t) {
	                    var L0 = getColor(0, true).lab()[0];
	                    var L1 = getColor(1, true).lab()[0];
	                    var pol = L0 > L1;
	                    var L_actual = getColor(t, true).lab()[0];
	                    var L_ideal = L0 + ((L1 - L0) * t);
	                    var L_diff = L_actual - L_ideal;
	                    var t0 = 0;
	                    var t1 = 1;
	                    var max_iter = 20;
	                    while ((Math.abs(L_diff) > 1e-2) && (max_iter-- > 0)) {
	                        (function() {
	                            if (pol) { L_diff *= -1; }
	                            if (L_diff < 0) {
	                                t0 = t;
	                                t += (t1 - t) * 0.5;
	                            } else {
	                                t1 = t;
	                                t += (t0 - t) * 0.5;
	                            }
	                            L_actual = getColor(t, true).lab()[0];
	                            return L_diff = L_actual - L_ideal;
	                        })();
	                    }
	                    return t;
	                };
	            } else {
	                tmap = function (t) { return t; };
	            }
	            return f;
	        };
	
	        f.padding = function(p) {
	            if (p != null) {
	                if (type$j(p) === 'number') {
	                    p = [p,p];
	                }
	                _padding = p;
	                return f;
	            } else {
	                return _padding;
	            }
	        };
	
	        f.colors = function(numColors, out) {
	            // If no arguments are given, return the original colors that were provided
	            if (arguments.length < 2) { out = 'hex'; }
	            var result = [];
	
	            if (arguments.length === 0) {
	                result = _colors.slice(0);
	
	            } else if (numColors === 1) {
	                result = [f(0.5)];
	
	            } else if (numColors > 1) {
	                var dm = _domain[0];
	                var dd = _domain[1] - dm;
	                result = __range__(0, numColors, false).map(function (i) { return f( dm + ((i/(numColors-1)) * dd) ); });
	
	            } else { // returns all colors based on the defined classes
	                colors = [];
	                var samples = [];
	                if (_classes && (_classes.length > 2)) {
	                    for (var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
	                        samples.push((_classes[i-1]+_classes[i])*0.5);
	                    }
	                } else {
	                    samples = _domain;
	                }
	                result = samples.map(function (v) { return f(v); });
	            }
	
	            if (chroma_1[out]) {
	                result = result.map(function (c) { return c[out](); });
	            }
	            return result;
	        };
	
	        f.cache = function(c) {
	            if (c != null) {
	                _useCache = c;
	                return f;
	            } else {
	                return _useCache;
	            }
	        };
	
	        f.gamma = function(g) {
	            if (g != null) {
	                _gamma = g;
	                return f;
	            } else {
	                return _gamma;
	            }
	        };
	
	        f.nodata = function(d) {
	            if (d != null) {
	                _nacol = chroma_1(d);
	                return f;
	            } else {
	                return _nacol;
	            }
	        };
	
	        return f;
	    };
	
	    function __range__(left, right, inclusive) {
	      var range = [];
	      var ascending = left < right;
	      var end = !inclusive ? right : ascending ? right + 1 : right - 1;
	      for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
	        range.push(i);
	      }
	      return range;
	    }
	
	    //
	    // interpolates between a set of colors uzing a bezier spline
	    //
	
	    // @requires utils lab
	
	
	
	
	    var bezier = function(colors) {
	        var assign, assign$1, assign$2;
	
	        var I, lab0, lab1, lab2;
	        colors = colors.map(function (c) { return new Color_1(c); });
	        if (colors.length === 2) {
	            // linear interpolation
	            (assign = colors.map(function (c) { return c.lab(); }), lab0 = assign[0], lab1 = assign[1]);
	            I = function(t) {
	                var lab = ([0, 1, 2].map(function (i) { return lab0[i] + (t * (lab1[i] - lab0[i])); }));
	                return new Color_1(lab, 'lab');
	            };
	        } else if (colors.length === 3) {
	            // quadratic bezier interpolation
	            (assign$1 = colors.map(function (c) { return c.lab(); }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2]);
	            I = function(t) {
	                var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t) * lab0[i]) + (2 * (1-t) * t * lab1[i]) + (t * t * lab2[i]); }));
	                return new Color_1(lab, 'lab');
	            };
	        } else if (colors.length === 4) {
	            // cubic bezier interpolation
	            var lab3;
	            (assign$2 = colors.map(function (c) { return c.lab(); }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3]);
	            I = function(t) {
	                var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t)*(1-t) * lab0[i]) + (3 * (1-t) * (1-t) * t * lab1[i]) + (3 * (1-t) * t * t * lab2[i]) + (t*t*t * lab3[i]); }));
	                return new Color_1(lab, 'lab');
	            };
	        } else if (colors.length === 5) {
	            var I0 = bezier(colors.slice(0, 3));
	            var I1 = bezier(colors.slice(2, 5));
	            I = function(t) {
	                if (t < 0.5) {
	                    return I0(t*2);
	                } else {
	                    return I1((t-0.5)*2);
	                }
	            };
	        }
	        return I;
	    };
	
	    var bezier_1 = function (colors) {
	        var f = bezier(colors);
	        f.scale = function () { return scale(f); };
	        return f;
	    };
	
	    /*
	     * interpolates between a set of colors uzing a bezier spline
	     * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
	     */
	
	
	
	
	    var blend = function (bottom, top, mode) {
	        if (!blend[mode]) {
	            throw new Error('unknown blend mode ' + mode);
	        }
	        return blend[mode](bottom, top);
	    };
	
	    var blend_f = function (f) { return function (bottom,top) {
	            var c0 = chroma_1(top).rgb();
	            var c1 = chroma_1(bottom).rgb();
	            return chroma_1.rgb(f(c0, c1));
	        }; };
	
	    var each = function (f) { return function (c0, c1) {
	            var out = [];
	            out[0] = f(c0[0], c1[0]);
	            out[1] = f(c0[1], c1[1]);
	            out[2] = f(c0[2], c1[2]);
	            return out;
	        }; };
	
	    var normal = function (a) { return a; };
	    var multiply = function (a,b) { return a * b / 255; };
	    var darken$1 = function (a,b) { return a > b ? b : a; };
	    var lighten = function (a,b) { return a > b ? a : b; };
	    var screen = function (a,b) { return 255 * (1 - (1-a/255) * (1-b/255)); };
	    var overlay = function (a,b) { return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255 ) * ( 1 - b / 255 )); };
	    var burn = function (a,b) { return 255 * (1 - (1 - b / 255) / (a/255)); };
	    var dodge = function (a,b) {
	        if (a === 255) { return 255; }
	        a = 255 * (b / 255) / (1 - a / 255);
	        return a > 255 ? 255 : a
	    };
	
	    // # add = (a,b) ->
	    // #     if (a + b > 255) then 255 else a + b
	
	    blend.normal = blend_f(each(normal));
	    blend.multiply = blend_f(each(multiply));
	    blend.screen = blend_f(each(screen));
	    blend.overlay = blend_f(each(overlay));
	    blend.darken = blend_f(each(darken$1));
	    blend.lighten = blend_f(each(lighten));
	    blend.dodge = blend_f(each(dodge));
	    blend.burn = blend_f(each(burn));
	    // blend.add = blend_f(each(add));
	
	    var blend_1 = blend;
	
	    // cubehelix interpolation
	    // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
	    // http://astron-soc.in/bulletin/11June/289392011.pdf
	
	    var type$k = utils.type;
	    var clip_rgb$3 = utils.clip_rgb;
	    var TWOPI$2 = utils.TWOPI;
	    var pow$6 = Math.pow;
	    var sin$2 = Math.sin;
	    var cos$3 = Math.cos;
	
	
	    var cubehelix = function(start, rotations, hue, gamma, lightness) {
	        if ( start === void 0 ) start=300;
	        if ( rotations === void 0 ) rotations=-1.5;
	        if ( hue === void 0 ) hue=1;
	        if ( gamma === void 0 ) gamma=1;
	        if ( lightness === void 0 ) lightness=[0,1];
	
	        var dh = 0, dl;
	        if (type$k(lightness) === 'array') {
	            dl = lightness[1] - lightness[0];
	        } else {
	            dl = 0;
	            lightness = [lightness, lightness];
	        }
	
	        var f = function(fract) {
	            var a = TWOPI$2 * (((start+120)/360) + (rotations * fract));
	            var l = pow$6(lightness[0] + (dl * fract), gamma);
	            var h = dh !== 0 ? hue[0] + (fract * dh) : hue;
	            var amp = (h * l * (1-l)) / 2;
	            var cos_a = cos$3(a);
	            var sin_a = sin$2(a);
	            var r = l + (amp * ((-0.14861 * cos_a) + (1.78277* sin_a)));
	            var g = l + (amp * ((-0.29227 * cos_a) - (0.90649* sin_a)));
	            var b = l + (amp * (+1.97294 * cos_a));
	            return chroma_1(clip_rgb$3([r*255,g*255,b*255,1]));
	        };
	
	        f.start = function(s) {
	            if ((s == null)) { return start; }
	            start = s;
	            return f;
	        };
	
	        f.rotations = function(r) {
	            if ((r == null)) { return rotations; }
	            rotations = r;
	            return f;
	        };
	
	        f.gamma = function(g) {
	            if ((g == null)) { return gamma; }
	            gamma = g;
	            return f;
	        };
	
	        f.hue = function(h) {
	            if ((h == null)) { return hue; }
	            hue = h;
	            if (type$k(hue) === 'array') {
	                dh = hue[1] - hue[0];
	                if (dh === 0) { hue = hue[1]; }
	            } else {
	                dh = 0;
	            }
	            return f;
	        };
	
	        f.lightness = function(h) {
	            if ((h == null)) { return lightness; }
	            if (type$k(h) === 'array') {
	                lightness = h;
	                dl = h[1] - h[0];
	            } else {
	                lightness = [h,h];
	                dl = 0;
	            }
	            return f;
	        };
	
	        f.scale = function () { return chroma_1.scale(f); };
	
	        f.hue(hue);
	
	        return f;
	    };
	
	    var digits = '0123456789abcdef';
	
	    var floor$2 = Math.floor;
	    var random = Math.random;
	
	    var random_1 = function () {
	        var code = '#';
	        for (var i=0; i<6; i++) {
	            code += digits.charAt(floor$2(random() * 16));
	        }
	        return new Color_1(code, 'hex');
	    };
	
	    var log$1 = Math.log;
	    var pow$7 = Math.pow;
	    var floor$3 = Math.floor;
	    var abs = Math.abs;
	
	
	    var analyze = function (data, key) {
	        if ( key === void 0 ) key=null;
	
	        var r = {
	            min: Number.MAX_VALUE,
	            max: Number.MAX_VALUE*-1,
	            sum: 0,
	            values: [],
	            count: 0
	        };
	        if (type(data) === 'object') {
	            data = Object.values(data);
	        }
	        data.forEach(function (val) {
	            if (key && type(val) === 'object') { val = val[key]; }
	            if (val !== undefined && val !== null && !isNaN(val)) {
	                r.values.push(val);
	                r.sum += val;
	                if (val < r.min) { r.min = val; }
	                if (val > r.max) { r.max = val; }
	                r.count += 1;
	            }
	        });
	
	        r.domain = [r.min, r.max];
	
	        r.limits = function (mode, num) { return limits(r, mode, num); };
	
	        return r;
	    };
	
	
	    var limits = function (data, mode, num) {
	        if ( mode === void 0 ) mode='equal';
	        if ( num === void 0 ) num=7;
	
	        if (type(data) == 'array') {
	            data = analyze(data);
	        }
	        var min = data.min;
	        var max = data.max;
	        var values = data.values.sort(function (a,b) { return a-b; });
	
	        if (num === 1) { return [min,max]; }
	
	        var limits = [];
	
	        if (mode.substr(0,1) === 'c') { // continuous
	            limits.push(min);
	            limits.push(max);
	        }
	
	        if (mode.substr(0,1) === 'e') { // equal interval
	            limits.push(min);
	            for (var i=1; i<num; i++) {
	                limits.push(min+((i/num)*(max-min)));
	            }
	            limits.push(max);
	        }
	
	        else if (mode.substr(0,1) === 'l') { // log scale
	            if (min <= 0) {
	                throw new Error('Logarithmic scales are only possible for values > 0');
	            }
	            var min_log = Math.LOG10E * log$1(min);
	            var max_log = Math.LOG10E * log$1(max);
	            limits.push(min);
	            for (var i$1=1; i$1<num; i$1++) {
	                limits.push(pow$7(10, min_log + ((i$1/num) * (max_log - min_log))));
	            }
	            limits.push(max);
	        }
	
	        else if (mode.substr(0,1) === 'q') { // quantile scale
	            limits.push(min);
	            for (var i$2=1; i$2<num; i$2++) {
	                var p = ((values.length-1) * i$2)/num;
	                var pb = floor$3(p);
	                if (pb === p) {
	                    limits.push(values[pb]);
	                } else { // p > pb
	                    var pr = p - pb;
	                    limits.push((values[pb]*(1-pr)) + (values[pb+1]*pr));
	                }
	            }
	            limits.push(max);
	
	        }
	
	        else if (mode.substr(0,1) === 'k') { // k-means clustering
	            /*
	            implementation based on
	            http://code.google.com/p/figue/source/browse/trunk/figue.js#336
	            simplified for 1-d input values
	            */
	            var cluster;
	            var n = values.length;
	            var assignments = new Array(n);
	            var clusterSizes = new Array(num);
	            var repeat = true;
	            var nb_iters = 0;
	            var centroids = null;
	
	            // get seed values
	            centroids = [];
	            centroids.push(min);
	            for (var i$3=1; i$3<num; i$3++) {
	                centroids.push(min + ((i$3/num) * (max-min)));
	            }
	            centroids.push(max);
	
	            while (repeat) {
	                // assignment step
	                for (var j=0; j<num; j++) {
	                    clusterSizes[j] = 0;
	                }
	                for (var i$4=0; i$4<n; i$4++) {
	                    var value = values[i$4];
	                    var mindist = Number.MAX_VALUE;
	                    var best = (void 0);
	                    for (var j$1=0; j$1<num; j$1++) {
	                        var dist = abs(centroids[j$1]-value);
	                        if (dist < mindist) {
	                            mindist = dist;
	                            best = j$1;
	                        }
	                        clusterSizes[best]++;
	                        assignments[i$4] = best;
	                    }
	                }
	
	                // update centroids step
	                var newCentroids = new Array(num);
	                for (var j$2=0; j$2<num; j$2++) {
	                    newCentroids[j$2] = null;
	                }
	                for (var i$5=0; i$5<n; i$5++) {
	                    cluster = assignments[i$5];
	                    if (newCentroids[cluster] === null) {
	                        newCentroids[cluster] = values[i$5];
	                    } else {
	                        newCentroids[cluster] += values[i$5];
	                    }
	                }
	                for (var j$3=0; j$3<num; j$3++) {
	                    newCentroids[j$3] *= 1/clusterSizes[j$3];
	                }
	
	                // check convergence
	                repeat = false;
	                for (var j$4=0; j$4<num; j$4++) {
	                    if (newCentroids[j$4] !== centroids[j$4]) {
	                        repeat = true;
	                        break;
	                    }
	                }
	
	                centroids = newCentroids;
	                nb_iters++;
	
	                if (nb_iters > 200) {
	                    repeat = false;
	                }
	            }
	
	            // finished k-means clustering
	            // the next part is borrowed from gabrielflor.it
	            var kClusters = {};
	            for (var j$5=0; j$5<num; j$5++) {
	                kClusters[j$5] = [];
	            }
	            for (var i$6=0; i$6<n; i$6++) {
	                cluster = assignments[i$6];
	                kClusters[cluster].push(values[i$6]);
	            }
	            var tmpKMeansBreaks = [];
	            for (var j$6=0; j$6<num; j$6++) {
	                tmpKMeansBreaks.push(kClusters[j$6][0]);
	                tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length-1]);
	            }
	            tmpKMeansBreaks = tmpKMeansBreaks.sort(function (a,b){ return a-b; });
	            limits.push(tmpKMeansBreaks[0]);
	            for (var i$7=1; i$7 < tmpKMeansBreaks.length; i$7+= 2) {
	                var v = tmpKMeansBreaks[i$7];
	                if (!isNaN(v) && (limits.indexOf(v) === -1)) {
	                    limits.push(v);
	                }
	            }
	        }
	        return limits;
	    };
	
	    var analyze_1 = {analyze: analyze, limits: limits};
	
	    var contrast = function (a, b) {
	        // WCAG contrast ratio
	        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	        a = new Color_1(a);
	        b = new Color_1(b);
	        var l1 = a.luminance();
	        var l2 = b.luminance();
	        return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
	    };
	
	    var sqrt$4 = Math.sqrt;
	    var atan2$2 = Math.atan2;
	    var abs$1 = Math.abs;
	    var cos$4 = Math.cos;
	    var PI$2 = Math.PI;
	
	    var deltaE = function(a, b, L, C) {
	        if ( L === void 0 ) L=1;
	        if ( C === void 0 ) C=1;
	
	        // Delta E (CMC)
	        // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CMC.html
	        a = new Color_1(a);
	        b = new Color_1(b);
	        var ref = Array.from(a.lab());
	        var L1 = ref[0];
	        var a1 = ref[1];
	        var b1 = ref[2];
	        var ref$1 = Array.from(b.lab());
	        var L2 = ref$1[0];
	        var a2 = ref$1[1];
	        var b2 = ref$1[2];
	        var c1 = sqrt$4((a1 * a1) + (b1 * b1));
	        var c2 = sqrt$4((a2 * a2) + (b2 * b2));
	        var sl = L1 < 16.0 ? 0.511 : (0.040975 * L1) / (1.0 + (0.01765 * L1));
	        var sc = ((0.0638 * c1) / (1.0 + (0.0131 * c1))) + 0.638;
	        var h1 = c1 < 0.000001 ? 0.0 : (atan2$2(b1, a1) * 180.0) / PI$2;
	        while (h1 < 0) { h1 += 360; }
	        while (h1 >= 360) { h1 -= 360; }
	        var t = (h1 >= 164.0) && (h1 <= 345.0) ? (0.56 + abs$1(0.2 * cos$4((PI$2 * (h1 + 168.0)) / 180.0))) : (0.36 + abs$1(0.4 * cos$4((PI$2 * (h1 + 35.0)) / 180.0)));
	        var c4 = c1 * c1 * c1 * c1;
	        var f = sqrt$4(c4 / (c4 + 1900.0));
	        var sh = sc * (((f * t) + 1.0) - f);
	        var delL = L1 - L2;
	        var delC = c1 - c2;
	        var delA = a1 - a2;
	        var delB = b1 - b2;
	        var dH2 = ((delA * delA) + (delB * delB)) - (delC * delC);
	        var v1 = delL / (L * sl);
	        var v2 = delC / (C * sc);
	        var v3 = sh;
	        return sqrt$4((v1 * v1) + (v2 * v2) + (dH2 / (v3 * v3)));
	    };
	
	    // simple Euclidean distance
	    var distance = function(a, b, mode) {
	        if ( mode === void 0 ) mode='lab';
	
	        // Delta E (CIE 1976)
	        // see http://www.brucelindbloom.com/index.html?Equations.html
	        a = new Color_1(a);
	        b = new Color_1(b);
	        var l1 = a.get(mode);
	        var l2 = b.get(mode);
	        var sum_sq = 0;
	        for (var i in l1) {
	            var d = (l1[i] || 0) - (l2[i] || 0);
	            sum_sq += d*d;
	        }
	        return Math.sqrt(sum_sq);
	    };
	
	    var valid = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	        try {
	            new (Function.prototype.bind.apply( Color_1, [ null ].concat( args) ));
	            return true;
	        } catch (e) {
	            return false;
	        }
	    };
	
	    // some pre-defined color scales:
	
	
	
	
	    var scales = {
	    	cool: function cool() { return scale([chroma_1.hsl(180,1,.9), chroma_1.hsl(250,.7,.4)]) },
	    	hot: function hot() { return scale(['#000','#f00','#ff0','#fff'], [0,.25,.75,1]).mode('rgb') }
	    };
	
	    /**
	        ColorBrewer colors for chroma.js
	
	        Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
	        Pennsylvania State University.
	
	        Licensed under the Apache License, Version 2.0 (the "License");
	        you may not use this file except in compliance with the License.
	        You may obtain a copy of the License at
	        http://www.apache.org/licenses/LICENSE-2.0
	
	        Unless required by applicable law or agreed to in writing, software distributed
	        under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	        CONDITIONS OF ANY KIND, either express or implied. See the License for the
	        specific language governing permissions and limitations under the License.
	    */
	
	    var colorbrewer = {
	        // sequential
	        OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
	        PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
	        BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
	        Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
	        BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
	        YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
	        YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
	        Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
	        RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
	        Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
	        YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
	        Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
	        GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
	        Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
	        YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
	        PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
	        Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
	        PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
	        Viridis: ['#440154', '#482777', '#3f4a8a', '#31678e', '#26838f', '#1f9d8a', '#6cce5a', '#b6de2b', '#fee825'],
	
	        // diverging
	
	        Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
	        RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
	        RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
	        PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
	        PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
	        RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
	        BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
	        RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
	        PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],
	
	        // qualitative
	
	        Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
	        Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
	        Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
	        Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
	        Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
	        Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
	        Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
	        Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2'],
	    };
	
	    // add lowercase aliases for case-insensitive matches
	    for (var i$1 = 0, list$1 = Object.keys(colorbrewer); i$1 < list$1.length; i$1 += 1) {
	        var key = list$1[i$1];
	
	        colorbrewer[key.toLowerCase()] = colorbrewer[key];
	    }
	
	    var colorbrewer_1 = colorbrewer;
	
	    // feel free to comment out anything to rollup
	    // a smaller chroma.js built
	
	    // io --> convert colors
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	    // operators --> modify existing Colors
	
	
	
	
	
	
	
	
	
	
	    // interpolators
	
	
	
	
	
	
	
	
	
	
	    // generators -- > create new colors
	    chroma_1.average = average;
	    chroma_1.bezier = bezier_1;
	    chroma_1.blend = blend_1;
	    chroma_1.cubehelix = cubehelix;
	    chroma_1.mix = chroma_1.interpolate = mix;
	    chroma_1.random = random_1;
	    chroma_1.scale = scale;
	
	    // other utility methods
	    chroma_1.analyze = analyze_1.analyze;
	    chroma_1.contrast = contrast;
	    chroma_1.deltaE = deltaE;
	    chroma_1.distance = distance;
	    chroma_1.limits = analyze_1.limits;
	    chroma_1.valid = valid;
	
	    // scale
	    chroma_1.scales = scales;
	
	    // colors
	    chroma_1.colors = w3cx11_1;
	    chroma_1.brewer = colorbrewer_1;
	
	    var chroma_js = chroma_1;
	
	    return chroma_js;
	
	})));


/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(74);
	var isArguments = __webpack_require__(73);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 160:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 77:
/***/ (function(module, exports) {

	/**
	 * Calculate a CRC32 value for a string.
	 *
	 * @param  {String|Buffer} s  A string or buffer to calculate a CRC on.
	 * @return {Number}           A cyclic redundancy check integer.
	 */
	module.exports = function crc32 (s) {
	  if (typeof s !== 'string') {
	    s = s.toString()
	  }
	  var l = s.length
	  var a = new Array(l)
	  for (var i = 0, n = 0, c; i < l; ++i) {
	    c = s.charCodeAt(i)
	    if (c < 128) {
	      a[n++] = c
	    } else if (c < 2048) {
	      a[n++] = (c >> 6) | 192
	      a[n++] = (c & 63) | 128
	    } else {
	      a[n++] = (c >> 12) | 224
	      a[n++] = ((c >> 6) & 63) | 128
	      a[n++] = (c & 63) | 128
	    }
	  }
	  var v = -1
	  l = a.length
	  for (i = 0; i < l; ++i) {
	    c = (v ^ a[i]) & 255
	    v = (v >>> 8) ^ t[c]
	  }
	  return (v ^ -1) >>> 0
	}
	
	// Build the cache table.
	var t = []
	for (var i = 0, j, v; i < 256; ++i) {
	  v = i
	  j = 8
	  while (j--) {
	    if ((v & 1) === 1) {
	      v = (v >>> 1) ^ 3988292384
	    } else {
	      v >>>= 1
	    }
	  }
	  t[i] = v >>> 0
	}


/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	
	  try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _construct(Parent, args, Class) {
	  if (isNativeReflectConstruct()) {
	    _construct = Reflect.construct;
	  } else {
	    _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) _setPrototypeOf(instance, Class.prototype);
	      return instance;
	    };
	  }
	
	  return _construct.apply(null, arguments);
	}
	
	function _isNativeFunction(fn) {
	  return Function.toString.call(fn).indexOf("[native code]") !== -1;
	}
	
	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;
	
	  _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !_isNativeFunction(Class)) return Class;
	
	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);
	
	      _cache.set(Class, Wrapper);
	    }
	
	    function Wrapper() {
	      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
	    }
	
	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return _setPrototypeOf(Wrapper, Class);
	  };
	
	  return _wrapNativeSuper(Class);
	}
	
	/*
	  This is just a junk drawer, containing anything used across multiple classes.
	  Because Luxon is small(ish), this should stay small and we won't worry about splitting
	  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
	*/
	
	/**
	 * @private
	 */
	// TYPES
	function isUndefined(o) {
	  return typeof o === "undefined";
	}
	function isNumber(o) {
	  return typeof o === "number";
	}
	function isString(o) {
	  return typeof o === "string";
	}
	function isDate(o) {
	  return Object.prototype.toString.call(o) === "[object Date]";
	} // CAPABILITIES
	
	function hasIntl() {
	  return typeof Intl !== "undefined" && Intl.DateTimeFormat;
	}
	function hasFormatToParts() {
	  return !isUndefined(Intl.DateTimeFormat.prototype.formatToParts);
	}
	function hasRelative() {
	  return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
	} // OBJECTS AND ARRAYS
	
	function maybeArray(thing) {
	  return Array.isArray(thing) ? thing : [thing];
	}
	function bestBy(arr, by, compare) {
	  if (arr.length === 0) {
	    return undefined;
	  }
	
	  return arr.reduce(function (best, next) {
	    var pair = [by(next), next];
	
	    if (!best) {
	      return pair;
	    } else if (compare(best[0], pair[0]) === best[0]) {
	      return best;
	    } else {
	      return pair;
	    }
	  }, null)[1];
	}
	function pick(obj, keys) {
	  return keys.reduce(function (a, k) {
	    a[k] = obj[k];
	    return a;
	  }, {});
	} // NUMBERS AND STRINGS
	
	function numberBetween(thing, bottom, top) {
	  return isNumber(thing) && thing >= bottom && thing <= top;
	} // x % n but takes the sign of n instead of x
	
	function floorMod(x, n) {
	  return x - n * Math.floor(x / n);
	}
	function padStart(input, n) {
	  if (n === void 0) {
	    n = 2;
	  }
	
	  if (input.toString().length < n) {
	    return ("0".repeat(n) + input).slice(-n);
	  } else {
	    return input.toString();
	  }
	}
	function parseMillis(fraction) {
	  if (isUndefined(fraction)) {
	    return NaN;
	  } else {
	    var f = parseFloat("0." + fraction) * 1000;
	    return Math.floor(f);
	  }
	}
	function roundTo(number, digits, towardZero) {
	  if (towardZero === void 0) {
	    towardZero = false;
	  }
	
	  var factor = Math.pow(10, digits),
	      rounder = towardZero ? Math.trunc : Math.round;
	  return rounder(number * factor) / factor;
	} // DATE BASICS
	
	function isLeapYear(year) {
	  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	}
	function daysInYear(year) {
	  return isLeapYear(year) ? 366 : 365;
	}
	function daysInMonth(year, month) {
	  var modMonth = floorMod(month - 1, 12) + 1,
	      modYear = year + (month - modMonth) / 12;
	
	  if (modMonth === 2) {
	    return isLeapYear(modYear) ? 29 : 28;
	  } else {
	    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
	  }
	}
	function weeksInWeekYear(weekYear) {
	  var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7,
	      last = weekYear - 1,
	      p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
	  return p1 === 4 || p2 === 3 ? 53 : 52;
	}
	function untruncateYear(year) {
	  if (year > 99) {
	    return year;
	  } else return year > 60 ? 1900 + year : 2000 + year;
	} // PARSING
	
	function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
	  if (timeZone === void 0) {
	    timeZone = null;
	  }
	
	  var date = new Date(ts),
	      intlOpts = {
	    hour12: false,
	    year: "numeric",
	    month: "2-digit",
	    day: "2-digit",
	    hour: "2-digit",
	    minute: "2-digit"
	  };
	
	  if (timeZone) {
	    intlOpts.timeZone = timeZone;
	  }
	
	  var modified = Object.assign({
	    timeZoneName: offsetFormat
	  }, intlOpts),
	      intl = hasIntl();
	
	  if (intl && hasFormatToParts()) {
	    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
	      return m.type.toLowerCase() === "timezonename";
	    });
	    return parsed ? parsed.value : null;
	  } else if (intl) {
	    // this probably doesn't work for all locales
	    var without = new Intl.DateTimeFormat(locale, intlOpts).format(date),
	        included = new Intl.DateTimeFormat(locale, modified).format(date),
	        diffed = included.substring(without.length),
	        trimmed = diffed.replace(/^[, \u200e]+/, "");
	    return trimmed;
	  } else {
	    return null;
	  }
	} // signedOffset('-5', '30') -> -330
	
	function signedOffset(offHourStr, offMinuteStr) {
	  var offHour = parseInt(offHourStr, 10) || 0,
	      offMin = parseInt(offMinuteStr, 10) || 0,
	      offMinSigned = offHour < 0 ? -offMin : offMin;
	  return offHour * 60 + offMinSigned;
	} // COERCION
	
	function normalizeObject(obj, normalizer, ignoreUnknown) {
	  if (ignoreUnknown === void 0) {
	    ignoreUnknown = false;
	  }
	
	  var normalized = {};
	
	  for (var u in obj) {
	    if (obj.hasOwnProperty(u)) {
	      var v = obj[u];
	
	      if (v !== null && !isUndefined(v) && !Number.isNaN(v)) {
	        var mapped = normalizer(u, ignoreUnknown);
	
	        if (mapped) {
	          normalized[mapped] = v;
	        }
	      }
	    }
	  }
	
	  return normalized;
	}
	function timeObject(obj) {
	  return pick(obj, ["hour", "minute", "second", "millisecond"]);
	}
	var ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;
	
	/**
	 * @private
	 */
	var n = "numeric",
	    s = "short",
	    l = "long",
	    d2 = "2-digit";
	var DATE_SHORT = {
	  year: n,
	  month: n,
	  day: n
	};
	var DATE_MED = {
	  year: n,
	  month: s,
	  day: n
	};
	var DATE_FULL = {
	  year: n,
	  month: l,
	  day: n
	};
	var DATE_HUGE = {
	  year: n,
	  month: l,
	  day: n,
	  weekday: l
	};
	var TIME_SIMPLE = {
	  hour: n,
	  minute: d2
	};
	var TIME_WITH_SECONDS = {
	  hour: n,
	  minute: d2,
	  second: d2
	};
	var TIME_WITH_SHORT_OFFSET = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  timeZoneName: s
	};
	var TIME_WITH_LONG_OFFSET = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  timeZoneName: l
	};
	var TIME_24_SIMPLE = {
	  hour: n,
	  minute: d2,
	  hour12: false
	};
	/**
	 * {@link toLocaleString}; format like '09:30:23', always 24-hour.
	 */
	
	var TIME_24_WITH_SECONDS = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  hour12: false
	};
	/**
	 * {@link toLocaleString}; format like '09:30:23 EDT', always 24-hour.
	 */
	
	var TIME_24_WITH_SHORT_OFFSET = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  hour12: false,
	  timeZoneName: s
	};
	/**
	 * {@link toLocaleString}; format like '09:30:23 Eastern Daylight Time', always 24-hour.
	 */
	
	var TIME_24_WITH_LONG_OFFSET = {
	  hour: n,
	  minute: d2,
	  second: d2,
	  hour12: false,
	  timeZoneName: l
	};
	/**
	 * {@link toLocaleString}; format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
	 */
	
	var DATETIME_SHORT = {
	  year: n,
	  month: n,
	  day: n,
	  hour: n,
	  minute: d2
	};
	/**
	 * {@link toLocaleString}; format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
	 */
	
	var DATETIME_SHORT_WITH_SECONDS = {
	  year: n,
	  month: n,
	  day: n,
	  hour: n,
	  minute: d2,
	  second: d2
	};
	var DATETIME_MED = {
	  year: n,
	  month: s,
	  day: n,
	  hour: n,
	  minute: d2
	};
	var DATETIME_MED_WITH_SECONDS = {
	  year: n,
	  month: s,
	  day: n,
	  hour: n,
	  minute: d2,
	  second: d2
	};
	var DATETIME_FULL = {
	  year: n,
	  month: l,
	  day: n,
	  hour: n,
	  minute: d2,
	  timeZoneName: s
	};
	var DATETIME_FULL_WITH_SECONDS = {
	  year: n,
	  month: l,
	  day: n,
	  hour: n,
	  minute: d2,
	  second: d2,
	  timeZoneName: s
	};
	var DATETIME_HUGE = {
	  year: n,
	  month: l,
	  day: n,
	  weekday: l,
	  hour: n,
	  minute: d2,
	  timeZoneName: l
	};
	var DATETIME_HUGE_WITH_SECONDS = {
	  year: n,
	  month: l,
	  day: n,
	  weekday: l,
	  hour: n,
	  minute: d2,
	  second: d2,
	  timeZoneName: l
	};
	
	function stringify(obj) {
	  return JSON.stringify(obj, Object.keys(obj).sort());
	}
	/**
	 * @private
	 */
	
	
	var monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	var monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
	function months(length) {
	  switch (length) {
	    case "narrow":
	      return monthsNarrow;
	
	    case "short":
	      return monthsShort;
	
	    case "long":
	      return monthsLong;
	
	    case "numeric":
	      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
	
	    case "2-digit":
	      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
	
	    default:
	      return null;
	  }
	}
	var weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
	var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
	var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
	function weekdays(length) {
	  switch (length) {
	    case "narrow":
	      return weekdaysNarrow;
	
	    case "short":
	      return weekdaysShort;
	
	    case "long":
	      return weekdaysLong;
	
	    case "numeric":
	      return ["1", "2", "3", "4", "5", "6", "7"];
	
	    default:
	      return null;
	  }
	}
	var meridiems = ["AM", "PM"];
	var erasLong = ["Before Christ", "Anno Domini"];
	var erasShort = ["BC", "AD"];
	var erasNarrow = ["B", "A"];
	function eras(length) {
	  switch (length) {
	    case "narrow":
	      return erasNarrow;
	
	    case "short":
	      return erasShort;
	
	    case "long":
	      return erasLong;
	
	    default:
	      return null;
	  }
	}
	function meridiemForDateTime(dt) {
	  return meridiems[dt.hour < 12 ? 0 : 1];
	}
	function weekdayForDateTime(dt, length) {
	  return weekdays(length)[dt.weekday - 1];
	}
	function monthForDateTime(dt, length) {
	  return months(length)[dt.month - 1];
	}
	function eraForDateTime(dt, length) {
	  return eras(length)[dt.year < 0 ? 0 : 1];
	}
	function formatRelativeTime(unit, count, numeric, narrow) {
	  if (numeric === void 0) {
	    numeric = "always";
	  }
	
	  if (narrow === void 0) {
	    narrow = false;
	  }
	
	  var units = {
	    years: ["year", "yr."],
	    quarters: ["quarer", "qtr."],
	    months: ["month", "mo."],
	    weeks: ["week", "wk."],
	    days: ["day", "day"],
	    hours: ["hour", "hr."],
	    minutes: ["minute", "min."],
	    seconds: ["second", "sec."]
	  };
	  var lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
	
	  if (numeric === "auto" && lastable) {
	    var isDay = unit === "days";
	
	    switch (count) {
	      case 1:
	        return isDay ? "tomorrow" : "next " + units[unit][0];
	
	      case -1:
	        return isDay ? "yesterday" : "last " + units[unit][0];
	
	      case 0:
	        return isDay ? "today" : "this " + units[unit][0];
	
	      default: // fall through
	
	    }
	  }
	
	  var isInPast = Object.is(count, -0) || count < 0,
	      fmtValue = Math.abs(count),
	      fmtUnit = narrow ? units[unit][1] : fmtValue === 1 ? units[unit][0] : unit;
	  return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
	}
	function formatString(knownFormat) {
	  // these all have the offsets removed because we don't have access to them
	  // without all the intl stuff this is backfilling
	  var filtered = pick(knownFormat, ["weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName", "hour12"]),
	      key = stringify(filtered),
	      dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
	
	  switch (key) {
	    case stringify(DATE_SHORT):
	      return "M/d/yyyy";
	
	    case stringify(DATE_MED):
	      return "LLL d, yyyy";
	
	    case stringify(DATE_FULL):
	      return "LLLL d, yyyy";
	
	    case stringify(DATE_HUGE):
	      return "EEEE, LLLL d, yyyy";
	
	    case stringify(TIME_SIMPLE):
	      return "h:mm a";
	
	    case stringify(TIME_WITH_SECONDS):
	      return "h:mm:ss a";
	
	    case stringify(TIME_WITH_SHORT_OFFSET):
	      return "h:mm a";
	
	    case stringify(TIME_WITH_LONG_OFFSET):
	      return "h:mm a";
	
	    case stringify(TIME_24_SIMPLE):
	      return "HH:mm";
	
	    case stringify(TIME_24_WITH_SECONDS):
	      return "HH:mm:ss";
	
	    case stringify(TIME_24_WITH_SHORT_OFFSET):
	      return "HH:mm";
	
	    case stringify(TIME_24_WITH_LONG_OFFSET):
	      return "HH:mm";
	
	    case stringify(DATETIME_SHORT):
	      return "M/d/yyyy, h:mm a";
	
	    case stringify(DATETIME_MED):
	      return "LLL d, yyyy, h:mm a";
	
	    case stringify(DATETIME_FULL):
	      return "LLLL d, yyyy, h:mm a";
	
	    case stringify(DATETIME_HUGE):
	      return dateTimeHuge;
	
	    case stringify(DATETIME_SHORT_WITH_SECONDS):
	      return "M/d/yyyy, h:mm:ss a";
	
	    case stringify(DATETIME_MED_WITH_SECONDS):
	      return "LLL d, yyyy, h:mm:ss a";
	
	    case stringify(DATETIME_FULL_WITH_SECONDS):
	      return "LLLL d, yyyy, h:mm:ss a";
	
	    case stringify(DATETIME_HUGE_WITH_SECONDS):
	      return "EEEE, LLLL d, yyyy, h:mm:ss a";
	
	    default:
	      return dateTimeHuge;
	  }
	}
	
	// these aren't really private, but nor are they really useful to document
	
	/**
	 * @private
	 */
	var LuxonError =
	/*#__PURE__*/
	function (_Error) {
	  _inheritsLoose(LuxonError, _Error);
	
	  function LuxonError() {
	    return _Error.apply(this, arguments) || this;
	  }
	
	  return LuxonError;
	}(_wrapNativeSuper(Error));
	/**
	 * @private
	 */
	
	
	var InvalidDateTimeError =
	/*#__PURE__*/
	function (_LuxonError) {
	  _inheritsLoose(InvalidDateTimeError, _LuxonError);
	
	  function InvalidDateTimeError(reason) {
	    return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
	  }
	
	  return InvalidDateTimeError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidIntervalError =
	/*#__PURE__*/
	function (_LuxonError2) {
	  _inheritsLoose(InvalidIntervalError, _LuxonError2);
	
	  function InvalidIntervalError(reason) {
	    return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
	  }
	
	  return InvalidIntervalError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidDurationError =
	/*#__PURE__*/
	function (_LuxonError3) {
	  _inheritsLoose(InvalidDurationError, _LuxonError3);
	
	  function InvalidDurationError(reason) {
	    return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
	  }
	
	  return InvalidDurationError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var ConflictingSpecificationError =
	/*#__PURE__*/
	function (_LuxonError4) {
	  _inheritsLoose(ConflictingSpecificationError, _LuxonError4);
	
	  function ConflictingSpecificationError() {
	    return _LuxonError4.apply(this, arguments) || this;
	  }
	
	  return ConflictingSpecificationError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidUnitError =
	/*#__PURE__*/
	function (_LuxonError5) {
	  _inheritsLoose(InvalidUnitError, _LuxonError5);
	
	  function InvalidUnitError(unit) {
	    return _LuxonError5.call(this, "Invalid unit " + unit) || this;
	  }
	
	  return InvalidUnitError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var InvalidArgumentError =
	/*#__PURE__*/
	function (_LuxonError6) {
	  _inheritsLoose(InvalidArgumentError, _LuxonError6);
	
	  function InvalidArgumentError() {
	    return _LuxonError6.apply(this, arguments) || this;
	  }
	
	  return InvalidArgumentError;
	}(LuxonError);
	/**
	 * @private
	 */
	
	var ZoneIsAbstractError =
	/*#__PURE__*/
	function (_LuxonError7) {
	  _inheritsLoose(ZoneIsAbstractError, _LuxonError7);
	
	  function ZoneIsAbstractError() {
	    return _LuxonError7.call(this, "Zone is an abstract class") || this;
	  }
	
	  return ZoneIsAbstractError;
	}(LuxonError);
	
	/**
	 * @interface
	 */
	
	var Zone =
	/*#__PURE__*/
	function () {
	  function Zone() {}
	
	  var _proto = Zone.prototype;
	
	  /**
	   * Returns the offset's common name (such as EST) at the specified timestamp
	   * @abstract
	   * @param {number} ts - Epoch milliseconds for which to get the name
	   * @param {Object} opts - Options to affect the format
	   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
	   * @param {string} opts.locale - What locale to return the offset name in.
	   * @return {string}
	   */
	  _proto.offsetName = function offsetName(ts, opts) {
	    throw new ZoneIsAbstractError();
	  };
	  /**
	   * Return the offset in minutes for this zone at the specified timestamp.
	   * @abstract
	   * @param {number} ts - Epoch milliseconds for which to compute the offset
	   * @return {number}
	   */
	
	
	  _proto.offset = function offset(ts) {
	    throw new ZoneIsAbstractError();
	  };
	  /**
	   * Return whether this Zone is equal to another zoner
	   * @abstract
	   * @param {Zone} otherZone - the zone to compare
	   * @return {boolean}
	   */
	
	
	  _proto.equals = function equals(otherZone) {
	    throw new ZoneIsAbstractError();
	  };
	  /**
	   * Return whether this Zone is valid.
	   * @abstract
	   * @type {boolean}
	   */
	
	
	  _createClass(Zone, [{
	    key: "type",
	
	    /**
	     * The type of zone
	     * @abstract
	     * @type {string}
	     */
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	    /**
	     * The name of this zone.
	     * @abstract
	     * @type {string}
	     */
	
	  }, {
	    key: "name",
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	    /**
	     * Returns whether the offset is known to be fixed for the whole year.
	     * @abstract
	     * @type {boolean}
	     */
	
	  }, {
	    key: "universal",
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      throw new ZoneIsAbstractError();
	    }
	  }]);
	
	  return Zone;
	}();
	
	var singleton = null;
	
	var LocalZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(LocalZone, _Zone);
	
	  function LocalZone() {
	    return _Zone.apply(this, arguments) || this;
	  }
	
	  var _proto = LocalZone.prototype;
	
	  _proto.offsetName = function offsetName(ts, _ref) {
	    var format = _ref.format,
	        locale = _ref.locale;
	    return parseZoneInfo(ts, format, locale);
	  };
	
	  _proto.offset = function offset(ts) {
	    return -new Date(ts).getTimezoneOffset();
	  };
	
	  _proto.equals = function equals(otherZone) {
	    return otherZone.type === "local";
	  };
	
	  _createClass(LocalZone, [{
	    key: "type",
	    get: function get() {
	      return "local";
	    }
	  }, {
	    key: "name",
	    get: function get() {
	      if (hasIntl()) {
	        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
	      } else return "local";
	    }
	  }, {
	    key: "universal",
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return true;
	    }
	  }], [{
	    key: "instance",
	    get: function get() {
	      if (singleton === null) {
	        singleton = new LocalZone();
	      }
	
	      return singleton;
	    }
	  }]);
	
	  return LocalZone;
	}(Zone);
	
	var matchingRegex = RegExp("^" + ianaRegex.source + "$");
	var dtfCache = {};
	
	function makeDTF(zone) {
	  if (!dtfCache[zone]) {
	    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
	      hour12: false,
	      timeZone: zone,
	      year: "numeric",
	      month: "2-digit",
	      day: "2-digit",
	      hour: "2-digit",
	      minute: "2-digit",
	      second: "2-digit"
	    });
	  }
	
	  return dtfCache[zone];
	}
	
	var typeToPos = {
	  year: 0,
	  month: 1,
	  day: 2,
	  hour: 3,
	  minute: 4,
	  second: 5
	};
	
	function hackyOffset(dtf, date) {
	  var formatted = dtf.format(date).replace(/\u200E/g, ""),
	      parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted),
	      fMonth = parsed[1],
	      fDay = parsed[2],
	      fYear = parsed[3],
	      fHour = parsed[4],
	      fMinute = parsed[5],
	      fSecond = parsed[6];
	  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
	}
	
	function partsOffset(dtf, date) {
	  var formatted = dtf.formatToParts(date),
	      filled = [];
	
	  for (var i = 0; i < formatted.length; i++) {
	    var _formatted$i = formatted[i],
	        type = _formatted$i.type,
	        value = _formatted$i.value,
	        pos = typeToPos[type];
	
	    if (!isUndefined(pos)) {
	      filled[pos] = parseInt(value, 10);
	    }
	  }
	
	  return filled;
	}
	
	var IANAZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(IANAZone, _Zone);
	
	  IANAZone.isValidSpecifier = function isValidSpecifier(s) {
	    return s && s.match(matchingRegex);
	  };
	
	  IANAZone.isValidZone = function isValidZone(zone) {
	    try {
	      new Intl.DateTimeFormat("en-US", {
	        timeZone: zone
	      }).format();
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }; // Etc/GMT+8 -> -480
	
	
	  IANAZone.parseGMTOffset = function parseGMTOffset(specifier) {
	    if (specifier) {
	      var match = specifier.match(/^Etc\/GMT([+-]\d{1,2})$/i);
	
	      if (match) {
	        return -60 * parseInt(match[1]);
	      }
	    }
	
	    return null;
	  };
	
	  function IANAZone(name) {
	    var _this;
	
	    _this = _Zone.call(this) || this;
	    _this.zoneName = name;
	    _this.valid = IANAZone.isValidZone(name);
	    return _this;
	  }
	
	  var _proto = IANAZone.prototype;
	
	  _proto.offsetName = function offsetName(ts, _ref) {
	    var format = _ref.format,
	        locale = _ref.locale;
	    return parseZoneInfo(ts, format, locale, this.zoneName);
	  };
	
	  _proto.offset = function offset(ts) {
	    var date = new Date(ts),
	        dtf = makeDTF(this.zoneName),
	        _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
	        fYear = _ref2[0],
	        fMonth = _ref2[1],
	        fDay = _ref2[2],
	        fHour = _ref2[3],
	        fMinute = _ref2[4],
	        fSecond = _ref2[5],
	        asUTC = Date.UTC(fYear, fMonth - 1, fDay, fHour, fMinute, fSecond);
	
	    var asTS = date.valueOf();
	    asTS -= asTS % 1000;
	    return (asUTC - asTS) / (60 * 1000);
	  };
	
	  _proto.equals = function equals(otherZone) {
	    return otherZone.type === "iana" && otherZone.zoneName === this.zoneName;
	  };
	
	  _createClass(IANAZone, [{
	    key: "type",
	    get: function get() {
	      return "iana";
	    }
	  }, {
	    key: "name",
	    get: function get() {
	      return this.zoneName;
	    }
	  }, {
	    key: "universal",
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return this.valid;
	    }
	  }]);
	
	  return IANAZone;
	}(Zone);
	
	var singleton$1 = null;
	
	function hoursMinutesOffset(z) {
	  var hours = Math.trunc(z.fixed / 60),
	      minutes = Math.abs(z.fixed % 60),
	      sign = hours > 0 ? "+" : "-",
	      base = sign + Math.abs(hours);
	  return minutes > 0 ? base + ":" + padStart(minutes, 2) : base;
	}
	
	var FixedOffsetZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(FixedOffsetZone, _Zone);
	
	  FixedOffsetZone.instance = function instance(offset) {
	    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
	  };
	
	  FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
	    if (s) {
	      var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
	
	      if (r) {
	        return new FixedOffsetZone(signedOffset(r[1], r[2]));
	      }
	    }
	
	    return null;
	  };
	
	  _createClass(FixedOffsetZone, null, [{
	    key: "utcInstance",
	    get: function get() {
	      if (singleton$1 === null) {
	        singleton$1 = new FixedOffsetZone(0);
	      }
	
	      return singleton$1;
	    }
	  }]);
	
	  function FixedOffsetZone(offset) {
	    var _this;
	
	    _this = _Zone.call(this) || this;
	    _this.fixed = offset;
	    return _this;
	  }
	
	  var _proto = FixedOffsetZone.prototype;
	
	  _proto.offsetName = function offsetName() {
	    return this.name;
	  };
	
	  _proto.offset = function offset() {
	    return this.fixed;
	  };
	
	  _proto.equals = function equals(otherZone) {
	    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
	  };
	
	  _createClass(FixedOffsetZone, [{
	    key: "type",
	    get: function get() {
	      return "fixed";
	    }
	  }, {
	    key: "name",
	    get: function get() {
	      return this.fixed === 0 ? "UTC" : "UTC" + hoursMinutesOffset(this);
	    }
	  }, {
	    key: "universal",
	    get: function get() {
	      return true;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return FixedOffsetZone;
	}(Zone);
	
	var InvalidZone =
	/*#__PURE__*/
	function (_Zone) {
	  _inheritsLoose(InvalidZone, _Zone);
	
	  function InvalidZone(zoneName) {
	    var _this;
	
	    _this = _Zone.call(this) || this;
	    _this.zoneName = zoneName;
	    return _this;
	  }
	
	  var _proto = InvalidZone.prototype;
	
	  _proto.offsetName = function offsetName() {
	    return null;
	  };
	
	  _proto.offset = function offset() {
	    return NaN;
	  };
	
	  _proto.equals = function equals() {
	    return false;
	  };
	
	  _createClass(InvalidZone, [{
	    key: "type",
	    get: function get() {
	      return "invalid";
	    }
	  }, {
	    key: "name",
	    get: function get() {
	      return this.zoneName;
	    }
	  }, {
	    key: "universal",
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: "isValid",
	    get: function get() {
	      return false;
	    }
	  }]);
	
	  return InvalidZone;
	}(Zone);
	
	/**
	 * @private
	 */
	function normalizeZone(input, defaultZone) {
	  var offset;
	
	  if (isUndefined(input) || input === null) {
	    return defaultZone;
	  } else if (input instanceof Zone) {
	    return input;
	  } else if (isString(input)) {
	    var lowered = input.toLowerCase();
	    if (lowered === "local") return LocalZone.instance;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else if ((offset = IANAZone.parseGMTOffset(input)) != null) {
	      // handle Etc/GMT-4, which V8 chokes on
	      return FixedOffsetZone.instance(offset);
	    } else if (IANAZone.isValidSpecifier(lowered)) return new IANAZone(input);else return FixedOffsetZone.parseSpecifier(lowered) || new InvalidZone(input);
	  } else if (isNumber(input)) {
	    return FixedOffsetZone.instance(input);
	  } else if (typeof input === "object" && input.offset && typeof input.offset === "number") {
	    // This is dumb, but the instanceof check above doesn't seem to really work
	    // so we're duck checking it
	    return input;
	  } else {
	    return new InvalidZone(input);
	  }
	}
	
	var now = function now() {
	  return Date.now();
	},
	    defaultZone = null,
	    // not setting this directly to LocalZone.instance bc loading order issues
	defaultLocale = null,
	    defaultNumberingSystem = null,
	    defaultOutputCalendar = null,
	    throwOnInvalid = false;
	/**
	 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
	 */
	
	
	var Settings =
	/*#__PURE__*/
	function () {
	  function Settings() {}
	
	  /**
	   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
	   * @return {void}
	   */
	  Settings.resetCaches = function resetCaches() {
	    Locale.resetCache();
	  };
	
	  _createClass(Settings, null, [{
	    key: "now",
	
	    /**
	     * Get the callback for returning the current timestamp.
	     * @type {function}
	     */
	    get: function get() {
	      return now;
	    }
	    /**
	     * Set the callback for returning the current timestamp.
	     * The function should return a number, which will be interpreted as an Epoch millisecond count
	     * @type {function}
	     * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
	     * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
	     */
	    ,
	    set: function set(n) {
	      now = n;
	    }
	    /**
	     * Get the default time zone to create DateTimes in.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultZoneName",
	    get: function get() {
	      return (defaultZone || LocalZone.instance).name;
	    }
	    /**
	     * Set the default time zone to create DateTimes in. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(z) {
	      if (!z) {
	        defaultZone = null;
	      } else {
	        defaultZone = normalizeZone(z);
	      }
	    }
	    /**
	     * Get the default time zone object to create DateTimes in. Does not affect existing instances.
	     * @type {Zone}
	     */
	
	  }, {
	    key: "defaultZone",
	    get: function get() {
	      return defaultZone || LocalZone.instance;
	    }
	    /**
	     * Get the default locale to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultLocale",
	    get: function get() {
	      return defaultLocale;
	    }
	    /**
	     * Set the default locale to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(locale) {
	      defaultLocale = locale;
	    }
	    /**
	     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultNumberingSystem",
	    get: function get() {
	      return defaultNumberingSystem;
	    }
	    /**
	     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(numberingSystem) {
	      defaultNumberingSystem = numberingSystem;
	    }
	    /**
	     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	
	  }, {
	    key: "defaultOutputCalendar",
	    get: function get() {
	      return defaultOutputCalendar;
	    }
	    /**
	     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
	     * @type {string}
	     */
	    ,
	    set: function set(outputCalendar) {
	      defaultOutputCalendar = outputCalendar;
	    }
	    /**
	     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
	     * @type {boolean}
	     */
	
	  }, {
	    key: "throwOnInvalid",
	    get: function get() {
	      return throwOnInvalid;
	    }
	    /**
	     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
	     * @type {boolean}
	     */
	    ,
	    set: function set(t) {
	      throwOnInvalid = t;
	    }
	  }]);
	
	  return Settings;
	}();
	
	function stringifyTokens(splits, tokenToString) {
	  var s = "";
	
	  for (var _iterator = splits, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var token = _ref;
	
	    if (token.literal) {
	      s += token.val;
	    } else {
	      s += tokenToString(token.val);
	    }
	  }
	
	  return s;
	}
	
	var tokenToObject = {
	  D: DATE_SHORT,
	  DD: DATE_MED,
	  DDD: DATE_FULL,
	  DDDD: DATE_HUGE,
	  t: TIME_SIMPLE,
	  tt: TIME_WITH_SECONDS,
	  ttt: TIME_WITH_SHORT_OFFSET,
	  tttt: TIME_WITH_LONG_OFFSET,
	  T: TIME_24_SIMPLE,
	  TT: TIME_24_WITH_SECONDS,
	  TTT: TIME_24_WITH_SHORT_OFFSET,
	  TTTT: TIME_24_WITH_LONG_OFFSET,
	  f: DATETIME_SHORT,
	  ff: DATETIME_MED,
	  fff: DATETIME_FULL,
	  ffff: DATETIME_HUGE,
	  F: DATETIME_SHORT_WITH_SECONDS,
	  FF: DATETIME_MED_WITH_SECONDS,
	  FFF: DATETIME_FULL_WITH_SECONDS,
	  FFFF: DATETIME_HUGE_WITH_SECONDS
	};
	/**
	 * @private
	 */
	
	var Formatter =
	/*#__PURE__*/
	function () {
	  Formatter.create = function create(locale, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return new Formatter(locale, opts);
	  };
	
	  Formatter.parseFormat = function parseFormat(fmt) {
	    var current = null,
	        currentFull = "",
	        bracketed = false;
	    var splits = [];
	
	    for (var i = 0; i < fmt.length; i++) {
	      var c = fmt.charAt(i);
	
	      if (c === "'") {
	        if (currentFull.length > 0) {
	          splits.push({
	            literal: bracketed,
	            val: currentFull
	          });
	        }
	
	        current = null;
	        currentFull = "";
	        bracketed = !bracketed;
	      } else if (bracketed) {
	        currentFull += c;
	      } else if (c === current) {
	        currentFull += c;
	      } else {
	        if (currentFull.length > 0) {
	          splits.push({
	            literal: false,
	            val: currentFull
	          });
	        }
	
	        currentFull = c;
	        current = c;
	      }
	    }
	
	    if (currentFull.length > 0) {
	      splits.push({
	        literal: bracketed,
	        val: currentFull
	      });
	    }
	
	    return splits;
	  };
	
	  function Formatter(locale, formatOpts) {
	    this.opts = formatOpts;
	    this.loc = locale;
	    this.systemLoc = null;
	  }
	
	  var _proto = Formatter.prototype;
	
	  _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
	    if (this.systemLoc === null) {
	      this.systemLoc = this.loc.redefaultToSystem();
	    }
	
	    var df = this.systemLoc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.format();
	  };
	
	  _proto.formatDateTime = function formatDateTime(dt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.format();
	  };
	
	  _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.formatToParts();
	  };
	
	  _proto.resolvedOptions = function resolvedOptions(dt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
	    return df.resolvedOptions();
	  };
	
	  _proto.num = function num(n, p) {
	    if (p === void 0) {
	      p = 0;
	    }
	
	    // we get some perf out of doing this here, annoyingly
	    if (this.opts.forceSimple) {
	      return padStart(n, p);
	    }
	
	    var opts = Object.assign({}, this.opts);
	
	    if (p > 0) {
	      opts.padTo = p;
	    }
	
	    return this.loc.numberFormatter(opts).format(n);
	  };
	
	  _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
	    var _this = this;
	
	    var knownEnglish = this.loc.listingMode() === "en";
	
	    var string = function string(opts, extract) {
	      return _this.loc.extract(dt, opts, extract);
	    },
	        formatOffset = function formatOffset(opts) {
	      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
	        return "Z";
	      }
	
	      var hours = Math.trunc(dt.offset / 60),
	          minutes = Math.abs(dt.offset % 60),
	          sign = hours >= 0 ? "+" : "-",
	          base = "" + sign + Math.abs(hours);
	
	      switch (opts.format) {
	        case "short":
	          return "" + sign + _this.num(Math.abs(hours), 2) + ":" + _this.num(minutes, 2);
	
	        case "narrow":
	          return minutes > 0 ? base + ":" + minutes : base;
	
	        case "techie":
	          return "" + sign + _this.num(Math.abs(hours), 2) + _this.num(minutes, 2);
	
	        default:
	          throw new RangeError("Value format " + opts.format + " is out of range for property format");
	      }
	    },
	        meridiem = function meridiem() {
	      return knownEnglish ? meridiemForDateTime(dt) : string({
	        hour: "numeric",
	        hour12: true
	      }, "dayperiod");
	    },
	        month = function month(length, standalone) {
	      return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
	        month: length
	      } : {
	        month: length,
	        day: "numeric"
	      }, "month");
	    },
	        weekday = function weekday(length, standalone) {
	      return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
	        weekday: length
	      } : {
	        weekday: length,
	        month: "long",
	        day: "numeric"
	      }, "weekday");
	    },
	        maybeMacro = function maybeMacro(token) {
	      var macro = tokenToObject[token];
	
	      if (macro) {
	        return _this.formatWithSystemDefault(dt, macro);
	      } else {
	        return token;
	      }
	    },
	        era = function era(length) {
	      return knownEnglish ? eraForDateTime(dt, length) : string({
	        era: length
	      }, "era");
	    },
	        tokenToString = function tokenToString(token) {
	      var outputCal = _this.loc.outputCalendar; // Where possible: http://cldr.unicode.org/translation/date-time#TOC-Stand-Alone-vs.-Format-Styles
	
	      switch (token) {
	        // ms
	        case "S":
	          return _this.num(dt.millisecond);
	
	        case "u": // falls through
	
	        case "SSS":
	          return _this.num(dt.millisecond, 3);
	        // seconds
	
	        case "s":
	          return _this.num(dt.second);
	
	        case "ss":
	          return _this.num(dt.second, 2);
	        // minutes
	
	        case "m":
	          return _this.num(dt.minute);
	
	        case "mm":
	          return _this.num(dt.minute, 2);
	        // hours
	
	        case "h":
	          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
	
	        case "hh":
	          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
	
	        case "H":
	          return _this.num(dt.hour);
	
	        case "HH":
	          return _this.num(dt.hour, 2);
	        // offset
	
	        case "Z":
	          // like +6
	          return formatOffset({
	            format: "narrow",
	            allowZ: _this.opts.allowZ
	          });
	
	        case "ZZ":
	          // like +06:00
	          return formatOffset({
	            format: "short",
	            allowZ: _this.opts.allowZ
	          });
	
	        case "ZZZ":
	          // like +0600
	          return formatOffset({
	            format: "techie",
	            allowZ: false
	          });
	
	        case "ZZZZ":
	          // like EST
	          return dt.offsetNameShort;
	
	        case "ZZZZZ":
	          // like Eastern Standard Time
	          return dt.offsetNameLong;
	        // zone
	
	        case "z":
	          // like America/New_York
	          return dt.zoneName;
	        // meridiems
	
	        case "a":
	          return meridiem();
	        // dates
	
	        case "d":
	          return outputCal ? string({
	            day: "numeric"
	          }, "day") : _this.num(dt.day);
	
	        case "dd":
	          return outputCal ? string({
	            day: "2-digit"
	          }, "day") : _this.num(dt.day, 2);
	        // weekdays - standalone
	
	        case "c":
	          // like 1
	          return _this.num(dt.weekday);
	
	        case "ccc":
	          // like 'Tues'
	          return weekday("short", true);
	
	        case "cccc":
	          // like 'Tuesday'
	          return weekday("long", true);
	
	        case "ccccc":
	          // like 'T'
	          return weekday("narrow", true);
	        // weekdays - format
	
	        case "E":
	          // like 1
	          return _this.num(dt.weekday);
	
	        case "EEE":
	          // like 'Tues'
	          return weekday("short", false);
	
	        case "EEEE":
	          // like 'Tuesday'
	          return weekday("long", false);
	
	        case "EEEEE":
	          // like 'T'
	          return weekday("narrow", false);
	        // months - standalone
	
	        case "L":
	          // like 1
	          return outputCal ? string({
	            month: "numeric",
	            day: "numeric"
	          }, "month") : _this.num(dt.month);
	
	        case "LL":
	          // like 01, doesn't seem to work
	          return outputCal ? string({
	            month: "2-digit",
	            day: "numeric"
	          }, "month") : _this.num(dt.month, 2);
	
	        case "LLL":
	          // like Jan
	          return month("short", true);
	
	        case "LLLL":
	          // like January
	          return month("long", true);
	
	        case "LLLLL":
	          // like J
	          return month("narrow", true);
	        // months - format
	
	        case "M":
	          // like 1
	          return outputCal ? string({
	            month: "numeric"
	          }, "month") : _this.num(dt.month);
	
	        case "MM":
	          // like 01
	          return outputCal ? string({
	            month: "2-digit"
	          }, "month") : _this.num(dt.month, 2);
	
	        case "MMM":
	          // like Jan
	          return month("short", false);
	
	        case "MMMM":
	          // like January
	          return month("long", false);
	
	        case "MMMMM":
	          // like J
	          return month("narrow", false);
	        // years
	
	        case "y":
	          // like 2014
	          return outputCal ? string({
	            year: "numeric"
	          }, "year") : _this.num(dt.year);
	
	        case "yy":
	          // like 14
	          return outputCal ? string({
	            year: "2-digit"
	          }, "year") : _this.num(dt.year.toString().slice(-2), 2);
	
	        case "yyyy":
	          // like 0012
	          return outputCal ? string({
	            year: "numeric"
	          }, "year") : _this.num(dt.year, 4);
	
	        case "yyyyyy":
	          // like 000012
	          return outputCal ? string({
	            year: "numeric"
	          }, "year") : _this.num(dt.year, 6);
	        // eras
	
	        case "G":
	          // like AD
	          return era("short");
	
	        case "GG":
	          // like Anno Domini
	          return era("long");
	
	        case "GGGGG":
	          return era("narrow");
	
	        case "kk":
	          return _this.num(dt.weekYear.toString().slice(-2), 2);
	
	        case "kkkk":
	          return _this.num(dt.weekYear, 4);
	
	        case "W":
	          return _this.num(dt.weekNumber);
	
	        case "WW":
	          return _this.num(dt.weekNumber, 2);
	
	        case "o":
	          return _this.num(dt.ordinal);
	
	        case "ooo":
	          return _this.num(dt.ordinal, 3);
	
	        case "q":
	          // like 1
	          return _this.num(dt.quarter);
	
	        case "qq":
	          // like 01
	          return _this.num(dt.quarter, 2);
	
	        case "X":
	          return _this.num(Math.floor(dt.ts / 1000));
	
	        case "x":
	          return _this.num(dt.ts);
	
	        default:
	          return maybeMacro(token);
	      }
	    };
	
	    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
	  };
	
	  _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
	    var _this2 = this;
	
	    var tokenToField = function tokenToField(token) {
	      switch (token[0]) {
	        case "S":
	          return "millisecond";
	
	        case "s":
	          return "second";
	
	        case "m":
	          return "minute";
	
	        case "h":
	          return "hour";
	
	        case "d":
	          return "day";
	
	        case "M":
	          return "month";
	
	        case "y":
	          return "year";
	
	        default:
	          return null;
	      }
	    },
	        tokenToString = function tokenToString(lildur) {
	      return function (token) {
	        var mapped = tokenToField(token);
	
	        if (mapped) {
	          return _this2.num(lildur.get(mapped), token.length);
	        } else {
	          return token;
	        }
	      };
	    },
	        tokens = Formatter.parseFormat(fmt),
	        realTokens = tokens.reduce(function (found, _ref2) {
	      var literal = _ref2.literal,
	          val = _ref2.val;
	      return literal ? found : found.concat(val);
	    }, []),
	        collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function (t) {
	      return t;
	    }));
	
	    return stringifyTokens(tokens, tokenToString(collapsed));
	  };
	
	  return Formatter;
	}();
	
	var intlDTCache = {};
	
	function getCachedDTF(locString, opts) {
	  if (opts === void 0) {
	    opts = {};
	  }
	
	  var key = JSON.stringify([locString, opts]);
	  var dtf = intlDTCache[key];
	
	  if (!dtf) {
	    dtf = new Intl.DateTimeFormat(locString, opts);
	    intlDTCache[key] = dtf;
	  }
	
	  return dtf;
	}
	
	var intlNumCache = {};
	
	function getCachendINF(locString, opts) {
	  if (opts === void 0) {
	    opts = {};
	  }
	
	  var key = JSON.stringify([locString, opts]);
	  var inf = intlNumCache[key];
	
	  if (!inf) {
	    inf = new Intl.NumberFormat(locString, opts);
	    intlNumCache[key] = inf;
	  }
	
	  return inf;
	}
	
	var intlRelCache = {};
	
	function getCachendRTF(locString, opts) {
	  if (opts === void 0) {
	    opts = {};
	  }
	
	  var key = JSON.stringify([locString, opts]);
	  var inf = intlRelCache[key];
	
	  if (!inf) {
	    inf = new Intl.RelativeTimeFormat(locString, opts);
	    intlRelCache[key] = inf;
	  }
	
	  return inf;
	}
	
	var sysLocaleCache = null;
	
	function systemLocale() {
	  if (sysLocaleCache) {
	    return sysLocaleCache;
	  } else if (hasIntl()) {
	    var computedSys = new Intl.DateTimeFormat().resolvedOptions().locale; // node sometimes defaults to "und". Override that because that is dumb
	
	    sysLocaleCache = computedSys === "und" ? "en-US" : computedSys;
	    return sysLocaleCache;
	  } else {
	    sysLocaleCache = "en-US";
	    return sysLocaleCache;
	  }
	}
	
	function parseLocaleString(localeStr) {
	  // I really want to avoid writing a BCP 47 parser
	  // see, e.g. https://github.com/wooorm/bcp-47
	  // Intead, we'll do this:
	  // a) if the string has no -u extensions, just leave it alone
	  // b) if it does, use Intl to resolve everything
	  // c) if Intl fails, try again without the -u
	  var uIndex = localeStr.indexOf("-u-");
	
	  if (uIndex === -1) {
	    return [localeStr];
	  } else {
	    var options;
	    var smaller = localeStr.substring(0, uIndex);
	
	    try {
	      options = getCachedDTF(localeStr).resolvedOptions();
	    } catch (e) {
	      options = getCachedDTF(smaller).resolvedOptions();
	    }
	
	    var _options = options,
	        numberingSystem = _options.numberingSystem,
	        calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it
	
	    return [smaller, numberingSystem, calendar];
	  }
	}
	
	function intlConfigString(localeStr, numberingSystem, outputCalendar) {
	  if (hasIntl()) {
	    if (outputCalendar || numberingSystem) {
	      localeStr += "-u";
	
	      if (outputCalendar) {
	        localeStr += "-ca-" + outputCalendar;
	      }
	
	      if (numberingSystem) {
	        localeStr += "-nu-" + numberingSystem;
	      }
	
	      return localeStr;
	    } else {
	      return localeStr;
	    }
	  } else {
	    return [];
	  }
	}
	
	function mapMonths(f) {
	  var ms = [];
	
	  for (var i = 1; i <= 12; i++) {
	    var dt = DateTime.utc(2016, i, 1);
	    ms.push(f(dt));
	  }
	
	  return ms;
	}
	
	function mapWeekdays(f) {
	  var ms = [];
	
	  for (var i = 1; i <= 7; i++) {
	    var dt = DateTime.utc(2016, 11, 13 + i);
	    ms.push(f(dt));
	  }
	
	  return ms;
	}
	
	function listStuff(loc, length, defaultOK, englishFn, intlFn) {
	  var mode = loc.listingMode(defaultOK);
	
	  if (mode === "error") {
	    return null;
	  } else if (mode === "en") {
	    return englishFn(length);
	  } else {
	    return intlFn(length);
	  }
	}
	
	function supportsFastNumbers(loc) {
	  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
	    return false;
	  } else {
	    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || hasIntl() && Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
	  }
	}
	/**
	 * @private
	 */
	
	
	var PolyeNumberFormatter =
	/*#__PURE__*/
	function () {
	  function PolyeNumberFormatter(intl, forceSimple, opts) {
	    this.padTo = opts.padTo || 0;
	    this.floor = opts.floor || false;
	
	    if (!forceSimple && hasIntl()) {
	      var intlOpts = {
	        useGrouping: false
	      };
	      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
	      this.inf = getCachendINF(intl, intlOpts);
	    }
	  }
	
	  var _proto = PolyeNumberFormatter.prototype;
	
	  _proto.format = function format(i) {
	    if (this.inf) {
	      var fixed = this.floor ? Math.floor(i) : i;
	      return this.inf.format(fixed);
	    } else {
	      // to match the browser's numberformatter defaults
	      var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
	
	      return padStart(_fixed, this.padTo);
	    }
	  };
	
	  return PolyeNumberFormatter;
	}();
	/**
	 * @private
	 */
	
	
	var PolyDateFormatter =
	/*#__PURE__*/
	function () {
	  function PolyDateFormatter(dt, intl, opts) {
	    this.opts = opts;
	    this.hasIntl = hasIntl();
	    var z;
	
	    if (dt.zone.universal && this.hasIntl) {
	      // Chromium doesn't support fixed-offset zones like Etc/GMT+8 in its formatter,
	      // See https://bugs.chromium.org/p/chromium/issues/detail?id=364374.
	      // So we have to make do. Two cases:
	      // 1. The format options tell us to show the zone. We can't do that, so the best
	      // we can do is format the date in UTC.
	      // 2. The format options don't tell us to show the zone. Then we can adjust them
	      // the time and tell the formatter to show it to us in UTC, so that the time is right
	      // and the bad zone doesn't show up.
	      // We can clean all this up when Chrome fixes this.
	      z = "UTC";
	
	      if (opts.timeZoneName) {
	        this.dt = dt;
	      } else {
	        this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
	      }
	    } else if (dt.zone.type === "local") {
	      this.dt = dt;
	    } else {
	      this.dt = dt;
	      z = dt.zone.name;
	    }
	
	    if (this.hasIntl) {
	      var intlOpts = Object.assign({}, this.opts);
	
	      if (z) {
	        intlOpts.timeZone = z;
	      }
	
	      this.dtf = getCachedDTF(intl, intlOpts);
	    }
	  }
	
	  var _proto2 = PolyDateFormatter.prototype;
	
	  _proto2.format = function format() {
	    if (this.hasIntl) {
	      return this.dtf.format(this.dt.toJSDate());
	    } else {
	      var tokenFormat = formatString(this.opts),
	          loc = Locale.create("en-US");
	      return Formatter.create(loc).formatDateTimeFromString(this.dt, tokenFormat);
	    }
	  };
	
	  _proto2.formatToParts = function formatToParts() {
	    if (this.hasIntl && hasFormatToParts()) {
	      return this.dtf.formatToParts(this.dt.toJSDate());
	    } else {
	      // This is kind of a cop out. We actually could do this for English. However, we couldn't do it for intl strings
	      // and IMO it's too weird to have an uncanny valley like that
	      return [];
	    }
	  };
	
	  _proto2.resolvedOptions = function resolvedOptions() {
	    if (this.hasIntl) {
	      return this.dtf.resolvedOptions();
	    } else {
	      return {
	        locale: "en-US",
	        numberingSystem: "latn",
	        outputCalendar: "gregory"
	      };
	    }
	  };
	
	  return PolyDateFormatter;
	}();
	/**
	 * @private
	 */
	
	
	var PolyRelFormatter =
	/*#__PURE__*/
	function () {
	  function PolyRelFormatter(intl, isEnglish, opts) {
	    this.opts = Object.assign({
	      style: "long"
	    }, opts);
	
	    if (!isEnglish && hasRelative()) {
	      this.rtf = getCachendRTF(intl, opts);
	    }
	  }
	
	  var _proto3 = PolyRelFormatter.prototype;
	
	  _proto3.format = function format(count, unit) {
	    if (this.rtf) {
	      return this.rtf.format(count, unit);
	    } else {
	      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
	    }
	  };
	
	  _proto3.formatToParts = function formatToParts(count, unit) {
	    if (this.rtf) {
	      return this.rtf.formatToParts(count, unit);
	    } else {
	      return [];
	    }
	  };
	
	  return PolyRelFormatter;
	}();
	/**
	 * @private
	 */
	
	
	var Locale =
	/*#__PURE__*/
	function () {
	  Locale.fromOpts = function fromOpts(opts) {
	    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
	  };
	
	  Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
	    if (defaultToEN === void 0) {
	      defaultToEN = false;
	    }
	
	    var specifiedLocale = locale || Settings.defaultLocale,
	        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
	    localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale()),
	        numberingSystemR = numberingSystem || Settings.defaultNumberingSystem,
	        outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
	    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
	  };
	
	  Locale.resetCache = function resetCache() {
	    sysLocaleCache = null;
	    intlDTCache = {};
	    intlNumCache = {};
	  };
	
	  Locale.fromObject = function fromObject(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        locale = _ref.locale,
	        numberingSystem = _ref.numberingSystem,
	        outputCalendar = _ref.outputCalendar;
	
	    return Locale.create(locale, numberingSystem, outputCalendar);
	  };
	
	  function Locale(locale, numbering, outputCalendar, specifiedLocale) {
	    var _parseLocaleString = parseLocaleString(locale),
	        parsedLocale = _parseLocaleString[0],
	        parsedNumberingSystem = _parseLocaleString[1],
	        parsedOutputCalendar = _parseLocaleString[2];
	
	    this.locale = parsedLocale;
	    this.numberingSystem = numbering || parsedNumberingSystem || null;
	    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
	    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
	    this.weekdaysCache = {
	      format: {},
	      standalone: {}
	    };
	    this.monthsCache = {
	      format: {},
	      standalone: {}
	    };
	    this.meridiemCache = null;
	    this.eraCache = {};
	    this.specifiedLocale = specifiedLocale;
	    this.fastNumbersCached = null;
	  }
	
	  var _proto4 = Locale.prototype;
	
	  _proto4.listingMode = function listingMode(defaultOK) {
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    var intl = hasIntl(),
	        hasFTP = intl && hasFormatToParts(),
	        isActuallyEn = this.isEnglish(),
	        hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
	
	    if (!hasFTP && !(isActuallyEn && hasNoWeirdness) && !defaultOK) {
	      return "error";
	    } else if (!hasFTP || isActuallyEn && hasNoWeirdness) {
	      return "en";
	    } else {
	      return "intl";
	    }
	  };
	
	  _proto4.clone = function clone(alts) {
	    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
	      return this;
	    } else {
	      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
	    }
	  };
	
	  _proto4.redefaultToEN = function redefaultToEN(alts) {
	    if (alts === void 0) {
	      alts = {};
	    }
	
	    return this.clone(Object.assign({}, alts, {
	      defaultToEN: true
	    }));
	  };
	
	  _proto4.redefaultToSystem = function redefaultToSystem(alts) {
	    if (alts === void 0) {
	      alts = {};
	    }
	
	    return this.clone(Object.assign({}, alts, {
	      defaultToEN: false
	    }));
	  };
	
	  _proto4.months = function months$$1(length, format, defaultOK) {
	    var _this = this;
	
	    if (format === void 0) {
	      format = false;
	    }
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, length, defaultOK, months, function () {
	      var intl = format ? {
	        month: length,
	        day: "numeric"
	      } : {
	        month: length
	      },
	          formatStr = format ? "format" : "standalone";
	
	      if (!_this.monthsCache[formatStr][length]) {
	        _this.monthsCache[formatStr][length] = mapMonths(function (dt) {
	          return _this.extract(dt, intl, "month");
	        });
	      }
	
	      return _this.monthsCache[formatStr][length];
	    });
	  };
	
	  _proto4.weekdays = function weekdays$$1(length, format, defaultOK) {
	    var _this2 = this;
	
	    if (format === void 0) {
	      format = false;
	    }
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, length, defaultOK, weekdays, function () {
	      var intl = format ? {
	        weekday: length,
	        year: "numeric",
	        month: "long",
	        day: "numeric"
	      } : {
	        weekday: length
	      },
	          formatStr = format ? "format" : "standalone";
	
	      if (!_this2.weekdaysCache[formatStr][length]) {
	        _this2.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
	          return _this2.extract(dt, intl, "weekday");
	        });
	      }
	
	      return _this2.weekdaysCache[formatStr][length];
	    });
	  };
	
	  _proto4.meridiems = function meridiems$$1(defaultOK) {
	    var _this3 = this;
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, undefined, defaultOK, function () {
	      return meridiems;
	    }, function () {
	      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
	      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
	      if (!_this3.meridiemCache) {
	        var intl = {
	          hour: "numeric",
	          hour12: true
	        };
	        _this3.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
	          return _this3.extract(dt, intl, "dayperiod");
	        });
	      }
	
	      return _this3.meridiemCache;
	    });
	  };
	
	  _proto4.eras = function eras$$1(length, defaultOK) {
	    var _this4 = this;
	
	    if (defaultOK === void 0) {
	      defaultOK = true;
	    }
	
	    return listStuff(this, length, defaultOK, eras, function () {
	      var intl = {
	        era: length
	      }; // This is utter bullshit. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
	      // to definitely enumerate them.
	
	      if (!_this4.eraCache[length]) {
	        _this4.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
	          return _this4.extract(dt, intl, "era");
	        });
	      }
	
	      return _this4.eraCache[length];
	    });
	  };
	
	  _proto4.extract = function extract(dt, intlOpts, field) {
	    var df = this.dtFormatter(dt, intlOpts),
	        results = df.formatToParts(),
	        matching = results.find(function (m) {
	      return m.type.toLowerCase() === field;
	    });
	    return matching ? matching.value : null;
	  };
	
	  _proto4.numberFormatter = function numberFormatter(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
	    // (in contrast, the rest of the condition is used heavily)
	    return new PolyeNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
	  };
	
	  _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
	    if (intlOpts === void 0) {
	      intlOpts = {};
	    }
	
	    return new PolyDateFormatter(dt, this.intl, intlOpts);
	  };
	
	  _proto4.relFormatter = function relFormatter(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
	  };
	
	  _proto4.isEnglish = function isEnglish() {
	    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || hasIntl() && Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
	  };
	
	  _proto4.equals = function equals(other) {
	    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
	  };
	
	  _createClass(Locale, [{
	    key: "fastNumbers",
	    get: function get() {
	      if (this.fastNumbersCached == null) {
	        this.fastNumbersCached = supportsFastNumbers(this);
	      }
	
	      return this.fastNumbersCached;
	    }
	  }]);
	
	  return Locale;
	}();
	
	/*
	 * This file handles parsing for well-specified formats. Here's how it works:
	 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
	 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
	 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
	 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
	 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
	 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
	 */
	
	function combineRegexes() {
	  for (var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++) {
	    regexes[_key] = arguments[_key];
	  }
	
	  var full = regexes.reduce(function (f, r) {
	    return f + r.source;
	  }, "");
	  return RegExp("^" + full + "$");
	}
	
	function combineExtractors() {
	  for (var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    extractors[_key2] = arguments[_key2];
	  }
	
	  return function (m) {
	    return extractors.reduce(function (_ref, ex) {
	      var mergedVals = _ref[0],
	          mergedZone = _ref[1],
	          cursor = _ref[2];
	
	      var _ex = ex(m, cursor),
	          val = _ex[0],
	          zone = _ex[1],
	          next = _ex[2];
	
	      return [Object.assign(mergedVals, val), mergedZone || zone, next];
	    }, [{}, null, 1]).slice(0, 2);
	  };
	}
	
	function parse(s) {
	  if (s == null) {
	    return [null, null];
	  }
	
	  for (var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    patterns[_key3 - 1] = arguments[_key3];
	  }
	
	  for (var _i = 0; _i < patterns.length; _i++) {
	    var _patterns$_i = patterns[_i],
	        regex = _patterns$_i[0],
	        extractor = _patterns$_i[1];
	    var m = regex.exec(s);
	
	    if (m) {
	      return extractor(m);
	    }
	  }
	
	  return [null, null];
	}
	
	function simpleParse() {
	  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    keys[_key4] = arguments[_key4];
	  }
	
	  return function (match, cursor) {
	    var ret = {};
	    var i;
	
	    for (i = 0; i < keys.length; i++) {
	      ret[keys[i]] = parseInt(match[cursor + i]);
	    }
	
	    return [ret, null, cursor + i];
	  };
	} // ISO and SQL parsing
	
	
	var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
	    isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,9}))?)?)?/,
	    isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + offsetRegex.source + "?"),
	    isoTimeExtensionRegex = RegExp("(?:T" + isoTimeRegex.source + ")?"),
	    isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
	    isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/,
	    isoOrdinalRegex = /(\d{4})-?(\d{3})/,
	    extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"),
	    extractISOOrdinalData = simpleParse("year", "ordinal"),
	    sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/,
	    // dumbed-down version of the ISO one
	sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?"),
	    sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");
	
	function extractISOYmd(match, cursor) {
	  var item = {
	    year: parseInt(match[cursor]),
	    month: parseInt(match[cursor + 1]) || 1,
	    day: parseInt(match[cursor + 2]) || 1
	  };
	  return [item, null, cursor + 3];
	}
	
	function extractISOTime(match, cursor) {
	  var item = {
	    hour: parseInt(match[cursor]) || 0,
	    minute: parseInt(match[cursor + 1]) || 0,
	    second: parseInt(match[cursor + 2]) || 0,
	    millisecond: parseMillis(match[cursor + 3])
	  };
	  return [item, null, cursor + 4];
	}
	
	function extractISOOffset(match, cursor) {
	  var local = !match[cursor] && !match[cursor + 1],
	      fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
	      zone = local ? null : FixedOffsetZone.instance(fullOffset);
	  return [{}, zone, cursor + 3];
	}
	
	function extractIANAZone(match, cursor) {
	  var zone = match[cursor] ? new IANAZone(match[cursor]) : null;
	  return [{}, zone, cursor + 1];
	} // ISO duration parsing
	
	
	var isoDuration = /^P(?:(?:(-?\d{1,9})Y)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})D)?(?:T(?:(-?\d{1,9})H)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})(?:[.,](-?\d{1,9}))?S)?)?|(-?\d{1,9})W)$/;
	
	function extractISODuration(match) {
	  var yearStr = match[1],
	      monthStr = match[2],
	      dayStr = match[3],
	      hourStr = match[4],
	      minuteStr = match[5],
	      secondStr = match[6],
	      millisecondsStr = match[7],
	      weekStr = match[8];
	  return [{
	    years: parseInt(yearStr),
	    months: parseInt(monthStr),
	    weeks: parseInt(weekStr),
	    days: parseInt(dayStr),
	    hours: parseInt(hourStr),
	    minutes: parseInt(minuteStr),
	    seconds: parseInt(secondStr),
	    milliseconds: parseMillis(millisecondsStr)
	  }];
	} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
	// and not just that we're in -240 *right now*. But since I don't think these are used that often
	// I'm just going to ignore that
	
	
	var obsOffsets = {
	  GMT: 0,
	  EDT: -4 * 60,
	  EST: -5 * 60,
	  CDT: -5 * 60,
	  CST: -6 * 60,
	  MDT: -6 * 60,
	  MST: -7 * 60,
	  PDT: -7 * 60,
	  PST: -8 * 60
	};
	
	function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	  var result = {
	    year: yearStr.length === 2 ? untruncateYear(parseInt(yearStr)) : parseInt(yearStr),
	    month: monthStr.length === 2 ? parseInt(monthStr, 10) : monthsShort.indexOf(monthStr) + 1,
	    day: parseInt(dayStr),
	    hour: parseInt(hourStr),
	    minute: parseInt(minuteStr)
	  };
	  if (secondStr) result.second = parseInt(secondStr);
	
	  if (weekdayStr) {
	    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
	  }
	
	  return result;
	} // RFC 2822/5322
	
	
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
	
	function extractRFC2822(match) {
	  var weekdayStr = match[1],
	      dayStr = match[2],
	      monthStr = match[3],
	      yearStr = match[4],
	      hourStr = match[5],
	      minuteStr = match[6],
	      secondStr = match[7],
	      obsOffset = match[8],
	      milOffset = match[9],
	      offHourStr = match[10],
	      offMinuteStr = match[11],
	      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
	  var offset;
	
	  if (obsOffset) {
	    offset = obsOffsets[obsOffset];
	  } else if (milOffset) {
	    offset = 0;
	  } else {
	    offset = signedOffset(offHourStr, offMinuteStr);
	  }
	
	  return [result, new FixedOffsetZone(offset)];
	}
	
	function preprocessRFC2822(s) {
	  // Remove comments and folding whitespace and replace multiple-spaces with a single space
	  return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
	} // http date
	
	
	var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
	    rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
	    ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
	
	function extractRFC1123Or850(match) {
	  var weekdayStr = match[1],
	      dayStr = match[2],
	      monthStr = match[3],
	      yearStr = match[4],
	      hourStr = match[5],
	      minuteStr = match[6],
	      secondStr = match[7],
	      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
	  return [result, FixedOffsetZone.utcInstance];
	}
	
	function extractASCII(match) {
	  var weekdayStr = match[1],
	      monthStr = match[2],
	      dayStr = match[3],
	      hourStr = match[4],
	      minuteStr = match[5],
	      secondStr = match[6],
	      yearStr = match[7],
	      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
	  return [result, FixedOffsetZone.utcInstance];
	}
	/**
	 * @private
	 */
	
	
	function parseISODate(s) {
	  return parse(s, [combineRegexes(isoYmdRegex, isoTimeExtensionRegex), combineExtractors(extractISOYmd, extractISOTime, extractISOOffset)], [combineRegexes(isoWeekRegex, isoTimeExtensionRegex), combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset)], [combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex), combineExtractors(extractISOOrdinalData, extractISOTime)], [combineRegexes(isoTimeRegex), combineExtractors(extractISOTime, extractISOOffset)]);
	}
	function parseRFC2822Date(s) {
	  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
	}
	function parseHTTPDate(s) {
	  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
	}
	function parseISODuration(s) {
	  return parse(s, [isoDuration, extractISODuration]);
	}
	function parseSQL(s) {
	  return parse(s, [combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex), combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone)], [combineRegexes(sqlTimeRegex), combineExtractors(extractISOTime, extractISOOffset, extractIANAZone)]);
	}
	
	var Invalid =
	/*#__PURE__*/
	function () {
	  function Invalid(reason, explanation) {
	    this.reason = reason;
	    this.explanation = explanation;
	  }
	
	  var _proto = Invalid.prototype;
	
	  _proto.toMessage = function toMessage() {
	    if (this.explanation) {
	      return this.reason + ": " + this.explanation;
	    } else {
	      return this.reason;
	    }
	  };
	
	  return Invalid;
	}();
	
	var INVALID = "Invalid Duration"; // unit conversion constants
	
	var lowOrderMatrix = {
	  weeks: {
	    days: 7,
	    hours: 7 * 24,
	    minutes: 7 * 24 * 60,
	    seconds: 7 * 24 * 60 * 60,
	    milliseconds: 7 * 24 * 60 * 60 * 1000
	  },
	  days: {
	    hours: 24,
	    minutes: 24 * 60,
	    seconds: 24 * 60 * 60,
	    milliseconds: 24 * 60 * 60 * 1000
	  },
	  hours: {
	    minutes: 60,
	    seconds: 60 * 60,
	    milliseconds: 60 * 60 * 1000
	  },
	  minutes: {
	    seconds: 60,
	    milliseconds: 60 * 1000
	  },
	  seconds: {
	    milliseconds: 1000
	  }
	},
	    casualMatrix = Object.assign({
	  years: {
	    months: 12,
	    weeks: 52,
	    days: 365,
	    hours: 365 * 24,
	    minutes: 365 * 24 * 60,
	    seconds: 365 * 24 * 60 * 60,
	    milliseconds: 365 * 24 * 60 * 60 * 1000
	  },
	  quarters: {
	    months: 3,
	    weeks: 13,
	    days: 91,
	    hours: 91 * 24,
	    minutes: 91 * 24 * 60,
	    milliseconds: 91 * 24 * 60 * 60 * 1000
	  },
	  months: {
	    weeks: 4,
	    days: 30,
	    hours: 30 * 24,
	    minutes: 30 * 24 * 60,
	    seconds: 30 * 24 * 60 * 60,
	    milliseconds: 30 * 24 * 60 * 60 * 1000
	  }
	}, lowOrderMatrix),
	    daysInYearAccurate = 146097.0 / 400,
	    daysInMonthAccurate = 146097.0 / 4800,
	    accurateMatrix = Object.assign({
	  years: {
	    months: 12,
	    weeks: daysInYearAccurate / 7,
	    days: daysInYearAccurate,
	    hours: daysInYearAccurate * 24,
	    minutes: daysInYearAccurate * 24 * 60,
	    seconds: daysInYearAccurate * 24 * 60 * 60,
	    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
	  },
	  quarters: {
	    months: 3,
	    weeks: daysInYearAccurate / 28,
	    days: daysInYearAccurate / 4,
	    hours: daysInYearAccurate * 24 / 4,
	    minutes: daysInYearAccurate * 24 * 60 / 4,
	    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
	    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
	  },
	  months: {
	    weeks: daysInMonthAccurate / 7,
	    days: daysInMonthAccurate,
	    hours: daysInMonthAccurate * 24,
	    minutes: daysInMonthAccurate * 24 * 60,
	    seconds: daysInMonthAccurate * 24 * 60 * 60,
	    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
	  }
	}, lowOrderMatrix); // units ordered by size
	
	var orderedUnits = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
	var reverseUnits = orderedUnits.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"
	
	function clone(dur, alts, clear) {
	  if (clear === void 0) {
	    clear = false;
	  }
	
	  // deep merge for vals
	  var conf = {
	    values: clear ? alts.values : Object.assign({}, dur.values, alts.values || {}),
	    loc: dur.loc.clone(alts.loc),
	    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
	  };
	  return new Duration(conf);
	}
	
	function antiTrunc(n) {
	  return n < 0 ? Math.floor(n) : Math.ceil(n);
	} // NB: mutates parameters
	
	
	function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
	  var conv = matrix[toUnit][fromUnit],
	      raw = fromMap[fromUnit] / conv,
	      sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]),
	      // ok, so this is wild, but see the matrix in the tests
	  added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
	  toMap[toUnit] += added;
	  fromMap[fromUnit] -= added * conv;
	} // NB: mutates parameters
	
	
	function normalizeValues(matrix, vals) {
	  reverseUnits.reduce(function (previous, current) {
	    if (!isUndefined(vals[current])) {
	      if (previous) {
	        convert(matrix, vals, previous, vals, current);
	      }
	
	      return current;
	    } else {
	      return previous;
	    }
	  }, null);
	}
	/**
	 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime.plus} to add a Duration object to a DateTime, producing another DateTime.
	 *
	 * Here is a brief overview of commonly used methods and getters in Duration:
	 *
	 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
	 * * **Unit values** See the {@link Duration.years}, {@link Duration.months}, {@link Duration.weeks}, {@link Duration.days}, {@link Duration.hours}, {@link Duration.minutes}, {@link Duration.seconds}, {@link Duration.milliseconds} accessors.
	 * * **Configuration** See  {@link Duration.locale} and {@link Duration.numberingSystem} accessors.
	 * * **Transformation** To create new Durations out of old ones use {@link Duration.plus}, {@link Duration.minus}, {@link Duration.normalize}, {@link Duration.set}, {@link Duration.reconfigure}, {@link Duration.shiftTo}, and {@link Duration.negate}.
	 * * **Output** To convert the Duration into other representations, see {@link Duration.as}, {@link Duration.toISO}, {@link Duration.toFormat}, and {@link Duration.toJSON}
	 *
	 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
	 */
	
	
	var Duration =
	/*#__PURE__*/
	function () {
	  /**
	   * @private
	   */
	  function Duration(config) {
	    var accurate = config.conversionAccuracy === "longterm" || false;
	    /**
	     * @access private
	     */
	
	    this.values = config.values;
	    /**
	     * @access private
	     */
	
	    this.loc = config.loc || Locale.create();
	    /**
	     * @access private
	     */
	
	    this.conversionAccuracy = accurate ? "longterm" : "casual";
	    /**
	     * @access private
	     */
	
	    this.invalid = config.invalid || null;
	    /**
	     * @access private
	     */
	
	    this.matrix = accurate ? accurateMatrix : casualMatrix;
	    /**
	     * @access private
	     */
	
	    this.isLuxonDuration = true;
	  }
	  /**
	   * Create Duration from a number of milliseconds.
	   * @param {number} count of milliseconds
	   * @param {Object} opts - options for parsing
	   * @param {string} [opts.locale='en-US'] - the locale to use
	   * @param {string} opts.numberingSystem - the numbering system to use
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @return {Duration}
	   */
	
	
	  Duration.fromMillis = function fromMillis(count, opts) {
	    return Duration.fromObject(Object.assign({
	      milliseconds: count
	    }, opts));
	  };
	  /**
	   * Create a Duration from a Javascript object with keys like 'years' and 'hours.
	   * If this object is empty then zero  milliseconds duration is returned.
	   * @param {Object} obj - the object to create the DateTime from
	   * @param {number} obj.years
	   * @param {number} obj.quarters
	   * @param {number} obj.months
	   * @param {number} obj.weeks
	   * @param {number} obj.days
	   * @param {number} obj.hours
	   * @param {number} obj.minutes
	   * @param {number} obj.seconds
	   * @param {number} obj.milliseconds
	   * @param {string} [obj.locale='en-US'] - the locale to use
	   * @param {string} obj.numberingSystem - the numbering system to use
	   * @param {string} [obj.conversionAccuracy='casual'] - the conversion system to use
	   * @return {Duration}
	   */
	
	
	  Duration.fromObject = function fromObject(obj) {
	    if (obj == null || typeof obj !== "object") {
	      throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + typeof obj);
	    }
	
	    return new Duration({
	      values: normalizeObject(obj, Duration.normalizeUnit, true),
	      loc: Locale.fromObject(obj),
	      conversionAccuracy: obj.conversionAccuracy
	    });
	  };
	  /**
	   * Create a Duration from an ISO 8601 duration string.
	   * @param {string} text - text to parse
	   * @param {Object} opts - options for parsing
	   * @param {string} [opts.locale='en-US'] - the locale to use
	   * @param {string} opts.numberingSystem - the numbering system to use
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
	   * @example Duration.fromISO('P3Y6M4DT12H30M5S').toObject() //=> { years: 3, months: 6, day: 4, hours: 12, minutes: 30, seconds: 5 }
	   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
	   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
	   * @return {Duration}
	   */
	
	
	  Duration.fromISO = function fromISO(text, opts) {
	    var _parseISODuration = parseISODuration(text),
	        parsed = _parseISODuration[0];
	
	    if (parsed) {
	      var obj = Object.assign(parsed, opts);
	      return Duration.fromObject(obj);
	    } else {
	      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
	    }
	  };
	  /**
	   * Create an invalid Duration.
	   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
	   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
	   * @return {Duration}
	   */
	
	
	  Duration.invalid = function invalid(reason, explanation) {
	    if (explanation === void 0) {
	      explanation = null;
	    }
	
	    if (!reason) {
	      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
	    }
	
	    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
	
	    if (Settings.throwOnInvalid) {
	      throw new InvalidDurationError(invalid);
	    } else {
	      return new Duration({
	        invalid: invalid
	      });
	    }
	  };
	  /**
	   * @private
	   */
	
	
	  Duration.normalizeUnit = function normalizeUnit(unit, ignoreUnknown) {
	    if (ignoreUnknown === void 0) {
	      ignoreUnknown = false;
	    }
	
	    var normalized = {
	      year: "years",
	      years: "years",
	      quarter: "quarters",
	      quarters: "quarters",
	      month: "months",
	      months: "months",
	      week: "weeks",
	      weeks: "weeks",
	      day: "days",
	      days: "days",
	      hour: "hours",
	      hours: "hours",
	      minute: "minutes",
	      minutes: "minutes",
	      second: "seconds",
	      seconds: "seconds",
	      millisecond: "milliseconds",
	      milliseconds: "milliseconds"
	    }[unit ? unit.toLowerCase() : unit];
	    if (!ignoreUnknown && !normalized) throw new InvalidUnitError(unit);
	    return normalized;
	  };
	  /**
	   * Check if an object is a Duration. Works across context boundaries
	   * @param {object} o
	   * @return {boolean}
	   */
	
	
	  Duration.isDuration = function isDuration(o) {
	    return o.isLuxonDuration || false;
	  };
	  /**
	   * Get  the locale of a Duration, such 'en-GB'
	   * @type {string}
	   */
	
	
	  var _proto = Duration.prototype;
	
	  /**
	   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
	   * * `S` for milliseconds
	   * * `s` for seconds
	   * * `m` for minutes
	   * * `h` for hours
	   * * `d` for days
	   * * `M` for months
	   * * `y` for years
	   * Notes:
	   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
	   * * The duration will be converted to the set of units in the format string using {@link Duration.shiftTo} and the Durations's conversion accuracy setting.
	   * @param {string} fmt - the format string
	   * @param {Object} opts - options
	   * @param {boolean} [opts.floor=true] - floor numerical values
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
	   * @return {string}
	   */
	  _proto.toFormat = function toFormat(fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
	    var fmtOpts = Object.assign({}, opts, {
	      floor: opts.round !== false && opts.floor !== false
	    });
	    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID;
	  };
	  /**
	   * Returns a Javascript object with this Duration's values.
	   * @param opts - options for generating the object
	   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
	   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
	   * @return {Object}
	   */
	
	
	  _proto.toObject = function toObject(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) return {};
	    var base = Object.assign({}, this.values);
	
	    if (opts.includeConfig) {
	      base.conversionAccuracy = this.conversionAccuracy;
	      base.numberingSystem = this.loc.numberingSystem;
	      base.locale = this.loc.locale;
	    }
	
	    return base;
	  };
	  /**
	   * Returns an ISO 8601-compliant string representation of this Duration.
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
	   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
	   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
	   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
	   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
	   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
	   * @return {string}
	   */
	
	
	  _proto.toISO = function toISO() {
	    // we could use the formatter, but this is an easier way to get the minimum string
	    if (!this.isValid) return null;
	    var s = "P";
	    if (this.years !== 0) s += this.years + "Y";
	    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
	    if (this.days !== 0 || this.weeks !== 0) s += this.days + this.weeks * 7 + "D";
	    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
	    if (this.hours !== 0) s += this.hours + "H";
	    if (this.minutes !== 0) s += this.minutes + "M";
	    if (this.seconds !== 0 || this.milliseconds !== 0) s += this.seconds + this.milliseconds / 1000 + "S";
	    return s;
	  };
	  /**
	   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
	   * @return {string}
	   */
	
	
	  _proto.toJSON = function toJSON() {
	    return this.toISO();
	  };
	  /**
	   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
	   * @return {string}
	   */
	
	
	  _proto.toString = function toString() {
	    return this.toISO();
	  };
	  /**
	   * Returns an milliseconds value of this Duration.
	   * @return {number}
	   */
	
	
	  _proto.valueOf = function valueOf() {
	    return this.as("milliseconds");
	  };
	  /**
	   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
	   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   * @return {Duration}
	   */
	
	
	  _proto.plus = function plus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration),
	        result = {};
	
	    for (var _i = 0; _i < orderedUnits.length; _i++) {
	      var k = orderedUnits[_i];
	
	      if (dur.values.hasOwnProperty(k) || this.values.hasOwnProperty(k)) {
	        result[k] = dur.get(k) + this.get(k);
	      }
	    }
	
	    return clone(this, {
	      values: result
	    }, true);
	  };
	  /**
	   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
	   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   * @return {Duration}
	   */
	
	
	  _proto.minus = function minus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration);
	    return this.plus(dur.negate());
	  };
	  /**
	   * Get the value of unit.
	   * @param {string} unit - a unit such as 'minute' or 'day'
	   * @example Duration.fromObject({years: 2, days: 3}).years //=> 2
	   * @example Duration.fromObject({years: 2, days: 3}).months //=> 0
	   * @example Duration.fromObject({years: 2, days: 3}).days //=> 3
	   * @return {number}
	   */
	
	
	  _proto.get = function get(unit) {
	    return this[Duration.normalizeUnit(unit)];
	  };
	  /**
	   * "Set" the values of specified units. Return a newly-constructed Duration.
	   * @param {Object} values - a mapping of units to numbers
	   * @example dur.set({ years: 2017 })
	   * @example dur.set({ hours: 8, minutes: 30 })
	   * @return {Duration}
	   */
	
	
	  _proto.set = function set(values) {
	    var mixed = Object.assign(this.values, normalizeObject(values, Duration.normalizeUnit));
	    return clone(this, {
	      values: mixed
	    });
	  };
	  /**
	   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
	   * @example dur.reconfigure({ locale: 'en-GB' })
	   * @return {Duration}
	   */
	
	
	  _proto.reconfigure = function reconfigure(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        locale = _ref.locale,
	        numberingSystem = _ref.numberingSystem,
	        conversionAccuracy = _ref.conversionAccuracy;
	
	    var loc = this.loc.clone({
	      locale: locale,
	      numberingSystem: numberingSystem
	    }),
	        opts = {
	      loc: loc
	    };
	
	    if (conversionAccuracy) {
	      opts.conversionAccuracy = conversionAccuracy;
	    }
	
	    return clone(this, opts);
	  };
	  /**
	   * Return the length of the duration in the specified unit.
	   * @param {string} unit - a unit such as 'minutes' or 'days'
	   * @example Duration.fromObject({years: 1}).as('days') //=> 365
	   * @example Duration.fromObject({years: 1}).as('months') //=> 12
	   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
	   * @return {number}
	   */
	
	
	  _proto.as = function as(unit) {
	    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
	  };
	  /**
	   * Reduce this Duration to its canonical representation in its current units.
	   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
	   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
	   * @return {Duration}
	   */
	
	
	  _proto.normalize = function normalize() {
	    if (!this.isValid) return this;
	    var vals = this.toObject();
	    normalizeValues(this.matrix, vals);
	    return Duration.fromObject(vals);
	  };
	  /**
	   * Convert this Duration into its representation in a different set of units.
	   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
	   * @return {Duration}
	   */
	
	
	  _proto.shiftTo = function shiftTo() {
	    for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
	      units[_key] = arguments[_key];
	    }
	
	    if (!this.isValid) return this;
	
	    if (units.length === 0) {
	      return this;
	    }
	
	    units = units.map(function (u) {
	      return Duration.normalizeUnit(u);
	    });
	    var built = {},
	        accumulated = {},
	        vals = this.toObject();
	    var lastUnit;
	    normalizeValues(this.matrix, vals);
	
	    for (var _i2 = 0; _i2 < orderedUnits.length; _i2++) {
	      var k = orderedUnits[_i2];
	
	      if (units.indexOf(k) >= 0) {
	        lastUnit = k;
	        var own = 0; // anything we haven't boiled down yet should get boiled to this unit
	
	        for (var ak in accumulated) {
	          if (accumulated.hasOwnProperty(ak)) {
	            own += this.matrix[ak][k] * accumulated[ak];
	            accumulated[ak] = 0;
	          }
	        } // plus anything that's already in this unit
	
	
	        if (isNumber(vals[k])) {
	          own += vals[k];
	        }
	
	        var i = Math.trunc(own);
	        built[k] = i;
	        accumulated[k] = own - i; // we'd like to absorb these fractions in another unit
	        // plus anything further down the chain that should be rolled up in to this
	
	        for (var down in vals) {
	          if (orderedUnits.indexOf(down) > orderedUnits.indexOf(k)) {
	            convert(this.matrix, vals, down, built, k);
	          }
	        } // otherwise, keep it in the wings to boil it later
	
	      } else if (isNumber(vals[k])) {
	        accumulated[k] = vals[k];
	      }
	    } // anything leftover becomes the decimal for the last unit
	
	
	    if (lastUnit) {
	      for (var key in accumulated) {
	        if (accumulated.hasOwnProperty(key)) {
	          if (accumulated[key] !== 0) {
	            built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
	          }
	        }
	      }
	    }
	
	    return clone(this, {
	      values: built
	    }, true);
	  };
	  /**
	   * Return the negative of this Duration.
	   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
	   * @return {Duration}
	   */
	
	
	  _proto.negate = function negate() {
	    if (!this.isValid) return this;
	    var negated = {};
	
	    var _arr = Object.keys(this.values);
	
	    for (var _i3 = 0; _i3 < _arr.length; _i3++) {
	      var k = _arr[_i3];
	      negated[k] = -this.values[k];
	    }
	
	    return clone(this, {
	      values: negated
	    }, true);
	  };
	  /**
	   * Get the years.
	   * @type {number}
	   */
	
	
	  /**
	   * Equality check
	   * Two Durations are equal iff they have the same units and the same values for each unit.
	   * @param {Duration} other
	   * @return {boolean}
	   */
	  _proto.equals = function equals(other) {
	    if (!this.isValid || !other.isValid) {
	      return false;
	    }
	
	    if (!this.loc.equals(other.loc)) {
	      return false;
	    }
	
	    for (var _i4 = 0; _i4 < orderedUnits.length; _i4++) {
	      var u = orderedUnits[_i4];
	
	      if (this.values[u] !== other.values[u]) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  _createClass(Duration, [{
	    key: "locale",
	    get: function get() {
	      return this.isValid ? this.loc.locale : null;
	    }
	    /**
	     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "numberingSystem",
	    get: function get() {
	      return this.isValid ? this.loc.numberingSystem : null;
	    }
	  }, {
	    key: "years",
	    get: function get() {
	      return this.isValid ? this.values.years || 0 : NaN;
	    }
	    /**
	     * Get the quarters.
	     * @type {number}
	     */
	
	  }, {
	    key: "quarters",
	    get: function get() {
	      return this.isValid ? this.values.quarters || 0 : NaN;
	    }
	    /**
	     * Get the months.
	     * @type {number}
	     */
	
	  }, {
	    key: "months",
	    get: function get() {
	      return this.isValid ? this.values.months || 0 : NaN;
	    }
	    /**
	     * Get the weeks
	     * @type {number}
	     */
	
	  }, {
	    key: "weeks",
	    get: function get() {
	      return this.isValid ? this.values.weeks || 0 : NaN;
	    }
	    /**
	     * Get the days.
	     * @type {number}
	     */
	
	  }, {
	    key: "days",
	    get: function get() {
	      return this.isValid ? this.values.days || 0 : NaN;
	    }
	    /**
	     * Get the hours.
	     * @type {number}
	     */
	
	  }, {
	    key: "hours",
	    get: function get() {
	      return this.isValid ? this.values.hours || 0 : NaN;
	    }
	    /**
	     * Get the minutes.
	     * @type {number}
	     */
	
	  }, {
	    key: "minutes",
	    get: function get() {
	      return this.isValid ? this.values.minutes || 0 : NaN;
	    }
	    /**
	     * Get the seconds.
	     * @return {number}
	     */
	
	  }, {
	    key: "seconds",
	    get: function get() {
	      return this.isValid ? this.values.seconds || 0 : NaN;
	    }
	    /**
	     * Get the milliseconds.
	     * @return {number}
	     */
	
	  }, {
	    key: "milliseconds",
	    get: function get() {
	      return this.isValid ? this.values.milliseconds || 0 : NaN;
	    }
	    /**
	     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
	     * on invalid DateTimes or Intervals.
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isValid",
	    get: function get() {
	      return this.invalid === null;
	    }
	    /**
	     * Returns an error code if this Duration became invalid, or null if the Duration is valid
	     * @return {string}
	     */
	
	  }, {
	    key: "invalidReason",
	    get: function get() {
	      return this.invalid ? this.invalid.reason : null;
	    }
	    /**
	     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidExplanation",
	    get: function get() {
	      return this.invalid ? this.invalid.explanation : null;
	    }
	  }]);
	
	  return Duration;
	}();
	function friendlyDuration(durationish) {
	  if (isNumber(durationish)) {
	    return Duration.fromMillis(durationish);
	  } else if (Duration.isDuration(durationish)) {
	    return durationish;
	  } else if (typeof durationish === "object") {
	    return Duration.fromObject(durationish);
	  } else {
	    throw new InvalidArgumentError("Unknown duration argument " + durationish + " of type " + typeof durationish);
	  }
	}
	
	var INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end
	
	function validateStartEnd(start, end) {
	  if (!start || !start.isValid) {
	    return new Invalid("missing or invalid start");
	  } else if (!end || !end.isValid) {
	    return new Invalid("missing or invalid end");
	  } else if (end < start) {
	    return new Invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
	  } else {
	    return null;
	  }
	}
	/**
	 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
	 *
	 * Here is a brief overview of the most commonly used methods and getters in Interval:
	 *
	 * * **Creation** To create an Interval, use {@link fromDateTimes}, {@link after}, {@link before}, or {@link fromISO}.
	 * * **Accessors** Use {@link start} and {@link end} to get the start and end.
	 * * **Interrogation** To analyze the Interval, use {@link count}, {@link length}, {@link hasSame}, {@link contains}, {@link isAfter}, or {@link isBefore}.
	 * * **Transformation** To create other Intervals out of this one, use {@link set}, {@link splitAt}, {@link splitBy}, {@link divideEqually}, {@link merge}, {@link xor}, {@link union}, {@link intersection}, or {@link difference}.
	 * * **Comparison** To compare this Interval to another one, use {@link equals}, {@link overlaps}, {@link abutsStart}, {@link abutsEnd}, {@link engulfs}
	 * * **Output*** To convert the Interval into other representations, see {@link toString}, {@link toISO}, {@link toFormat}, and {@link toDuration}.
	 */
	
	
	var Interval =
	/*#__PURE__*/
	function () {
	  /**
	   * @private
	   */
	  function Interval(config) {
	    /**
	     * @access private
	     */
	    this.s = config.start;
	    /**
	     * @access private
	     */
	
	    this.e = config.end;
	    /**
	     * @access private
	     */
	
	    this.invalid = config.invalid || null;
	    /**
	     * @access private
	     */
	
	    this.isLuxonInterval = true;
	  }
	  /**
	   * Create an invalid Interval.
	   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
	   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
	   * @return {Interval}
	   */
	
	
	  Interval.invalid = function invalid(reason, explanation) {
	    if (explanation === void 0) {
	      explanation = null;
	    }
	
	    if (!reason) {
	      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
	    }
	
	    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
	
	    if (Settings.throwOnInvalid) {
	      throw new InvalidIntervalError(invalid);
	    } else {
	      return new Interval({
	        invalid: invalid
	      });
	    }
	  };
	  /**
	   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
	   * @param {DateTime|Date|Object} start
	   * @param {DateTime|Date|Object} end
	   * @return {Interval}
	   */
	
	
	  Interval.fromDateTimes = function fromDateTimes(start, end) {
	    var builtStart = friendlyDateTime(start),
	        builtEnd = friendlyDateTime(end);
	    return new Interval({
	      start: builtStart,
	      end: builtEnd,
	      invalid: validateStartEnd(builtStart, builtEnd)
	    });
	  };
	  /**
	   * Create an Interval from a start DateTime and a Duration to extend to.
	   * @param {DateTime|Date|Object} start
	   * @param {Duration|Object|number} duration - the length of the Interval.
	   * @return {Interval}
	   */
	
	
	  Interval.after = function after(start, duration) {
	    var dur = friendlyDuration(duration),
	        dt = friendlyDateTime(start);
	    return Interval.fromDateTimes(dt, dt.plus(dur));
	  };
	  /**
	   * Create an Interval from an end DateTime and a Duration to extend backwards to.
	   * @param {DateTime|Date|Object} end
	   * @param {Duration|Object|number} duration - the length of the Interval.
	   * @return {Interval}
	   */
	
	
	  Interval.before = function before(end, duration) {
	    var dur = friendlyDuration(duration),
	        dt = friendlyDateTime(end);
	    return Interval.fromDateTimes(dt.minus(dur), dt);
	  };
	  /**
	   * Create an Interval from an ISO 8601 string.
	   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
	   * @param {string} text - the ISO string to parse
	   * @param {Object} [opts] - options to pass {@link DateTime.fromISO} and optionally {@link Duration.fromISO}
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
	   * @return {Interval}
	   */
	
	
	  Interval.fromISO = function fromISO(text, opts) {
	    var _split = (text || "").split("/", 2),
	        s = _split[0],
	        e = _split[1];
	
	    if (s && e) {
	      var start = DateTime.fromISO(s, opts),
	          end = DateTime.fromISO(e, opts);
	
	      if (start.isValid && end.isValid) {
	        return Interval.fromDateTimes(start, end);
	      }
	
	      if (start.isValid) {
	        var dur = Duration.fromISO(e, opts);
	
	        if (dur.isValid) {
	          return Interval.after(start, dur);
	        }
	      } else if (end.isValid) {
	        var _dur = Duration.fromISO(s, opts);
	
	        if (_dur.isValid) {
	          return Interval.before(end, _dur);
	        }
	      }
	    }
	
	    return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed asISO 8601");
	  };
	  /**
	   * Check if an object is an Interval. Works across context boundaries
	   * @param {object} o
	   * @return {boolean}
	   */
	
	
	  Interval.isInterval = function isInterval(o) {
	    return o instanceof Interval || o.isLuxonInterval;
	  };
	  /**
	   * Returns the start of the Interval
	   * @type {DateTime}
	   */
	
	
	  var _proto = Interval.prototype;
	
	  /**
	   * Returns the length of the Interval in the specified unit.
	   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
	   * @return {number}
	   */
	  _proto.length = function length(unit) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
	  };
	  /**
	   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
	   * Unlike {@link length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
	   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
	   * @param {string} [unit='milliseconds'] - the unit of time to count.
	   * @return {number}
	   */
	
	
	  _proto.count = function count(unit) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    if (!this.isValid) return NaN;
	    var start = this.start.startOf(unit),
	        end = this.end.startOf(unit);
	    return Math.floor(end.diff(start, unit).get(unit)) + 1;
	  };
	  /**
	   * Returns whether this Interval's start and end are both in the same unit of time
	   * @param {string} unit - the unit of time to check sameness on
	   * @return {boolean}
	   */
	
	
	  _proto.hasSame = function hasSame(unit) {
	    return this.isValid ? this.e.minus(1).hasSame(this.s, unit) : false;
	  };
	  /**
	   * Return whether this Interval has the same start and end DateTimes.
	   * @return {boolean}
	   */
	
	
	  _proto.isEmpty = function isEmpty() {
	    return this.s.valueOf() === this.e.valueOf();
	  };
	  /**
	   * Return whether this Interval's start is after the specified DateTime.
	   * @param {DateTime} dateTime
	   * @return {boolean}
	   */
	
	
	  _proto.isAfter = function isAfter(dateTime) {
	    if (!this.isValid) return false;
	    return this.s > dateTime;
	  };
	  /**
	   * Return whether this Interval's end is before the specified DateTime.
	   * @param {DateTime} dateTime
	   * @return {boolean}
	   */
	
	
	  _proto.isBefore = function isBefore(dateTime) {
	    if (!this.isValid) return false;
	    return this.e <= dateTime;
	  };
	  /**
	   * Return whether this Interval contains the specified DateTime.
	   * @param {DateTime} dateTime
	   * @return {boolean}
	   */
	
	
	  _proto.contains = function contains(dateTime) {
	    if (!this.isValid) return false;
	    return this.s <= dateTime && this.e > dateTime;
	  };
	  /**
	   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
	   * @param {Object} values - the values to set
	   * @param {DateTime} values.start - the starting DateTime
	   * @param {DateTime} values.end - the ending DateTime
	   * @return {Interval}
	   */
	
	
	  _proto.set = function set(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        start = _ref.start,
	        end = _ref.end;
	
	    if (!this.isValid) return this;
	    return Interval.fromDateTimes(start || this.s, end || this.e);
	  };
	  /**
	   * Split this Interval at each of the specified DateTimes
	   * @param {...[DateTime]} dateTimes - the unit of time to count.
	   * @return {[Interval]}
	   */
	
	
	  _proto.splitAt = function splitAt() {
	    if (!this.isValid) return [];
	
	    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
	      dateTimes[_key] = arguments[_key];
	    }
	
	    var sorted = dateTimes.map(friendlyDateTime).sort(),
	        results = [];
	    var s = this.s,
	        i = 0;
	
	    while (s < this.e) {
	      var added = sorted[i] || this.e,
	          next = +added > +this.e ? this.e : added;
	      results.push(Interval.fromDateTimes(s, next));
	      s = next;
	      i += 1;
	    }
	
	    return results;
	  };
	  /**
	   * Split this Interval into smaller Intervals, each of the specified length.
	   * Left over time is grouped into a smaller interval
	   * @param {Duration|Object|number} duration - The length of each resulting interval.
	   * @return {[Interval]}
	   */
	
	
	  _proto.splitBy = function splitBy(duration) {
	    var dur = friendlyDuration(duration);
	
	    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
	      return [];
	    }
	
	    var s = this.s,
	        added,
	        next;
	    var results = [];
	
	    while (s < this.e) {
	      added = s.plus(dur);
	      next = +added > +this.e ? this.e : added;
	      results.push(Interval.fromDateTimes(s, next));
	      s = next;
	    }
	
	    return results;
	  };
	  /**
	   * Split this Interval into the specified number of smaller intervals.
	   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
	   * @return {[Interval]}
	   */
	
	
	  _proto.divideEqually = function divideEqually(numberOfParts) {
	    if (!this.isValid) return [];
	    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
	  };
	  /**
	   * Return whether this Interval overlaps with the specified Interval
	   * @param {Interval} other
	   * @return {boolean}
	   */
	
	
	  _proto.overlaps = function overlaps(other) {
	    return this.e > other.s && this.s < other.e;
	  };
	  /**
	   * Return whether this Interval's end is adjacent to the specified Interval's start.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	
	
	  _proto.abutsStart = function abutsStart(other) {
	    if (!this.isValid) return false;
	    return +this.e === +other.s;
	  };
	  /**
	   * Return whether this Interval's start is adjacent to the specified Interval's end.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	
	
	  _proto.abutsEnd = function abutsEnd(other) {
	    if (!this.isValid) return false;
	    return +other.e === +this.s;
	  };
	  /**
	   * Return whether this Interval engulfs the start and end of the specified Interval.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	
	
	  _proto.engulfs = function engulfs(other) {
	    if (!this.isValid) return false;
	    return this.s <= other.s && this.e >= other.e;
	  };
	  /**
	   * Return whether this Interval has the same start and end as the specified Interval.
	   * @param {Interval} other
	   * @return {boolean}
	   */
	
	
	  _proto.equals = function equals(other) {
	    if (!this.isValid || !other.isValid) {
	      return false;
	    }
	
	    return this.s.equals(other.s) && this.e.equals(other.e);
	  };
	  /**
	   * Return an Interval representing the intersection of this Interval and the specified Interval.
	   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
	   * Returns null if the intersection is empty, i.e., the intervals don't intersect.
	   * @param {Interval} other
	   * @return {Interval}
	   */
	
	
	  _proto.intersection = function intersection(other) {
	    if (!this.isValid) return this;
	    var s = this.s > other.s ? this.s : other.s,
	        e = this.e < other.e ? this.e : other.e;
	
	    if (s > e) {
	      return null;
	    } else {
	      return Interval.fromDateTimes(s, e);
	    }
	  };
	  /**
	   * Return an Interval representing the union of this Interval and the specified Interval.
	   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
	   * @param {Interval} other
	   * @return {Interval}
	   */
	
	
	  _proto.union = function union(other) {
	    if (!this.isValid) return this;
	    var s = this.s < other.s ? this.s : other.s,
	        e = this.e > other.e ? this.e : other.e;
	    return Interval.fromDateTimes(s, e);
	  };
	  /**
	   * Merge an array of Intervals into a equivalent minimal set of Intervals.
	   * Combines overlapping and adjacent Intervals.
	   * @param {[Interval]} intervals
	   * @return {[Interval]}
	   */
	
	
	  Interval.merge = function merge(intervals) {
	    var _intervals$sort$reduc = intervals.sort(function (a, b) {
	      return a.s - b.s;
	    }).reduce(function (_ref2, item) {
	      var sofar = _ref2[0],
	          current = _ref2[1];
	
	      if (!current) {
	        return [sofar, item];
	      } else if (current.overlaps(item) || current.abutsStart(item)) {
	        return [sofar, current.union(item)];
	      } else {
	        return [sofar.concat([current]), item];
	      }
	    }, [[], null]),
	        found = _intervals$sort$reduc[0],
	        final = _intervals$sort$reduc[1];
	
	    if (final) {
	      found.push(final);
	    }
	
	    return found;
	  };
	  /**
	   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
	   * @param {[Interval]} intervals
	   * @return {[Interval]}
	   */
	
	
	  Interval.xor = function xor(intervals) {
	    var _Array$prototype;
	
	    var start = null,
	        currentCount = 0;
	
	    var results = [],
	        ends = intervals.map(function (i) {
	      return [{
	        time: i.s,
	        type: "s"
	      }, {
	        time: i.e,
	        type: "e"
	      }];
	    }),
	        flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends),
	        arr = flattened.sort(function (a, b) {
	      return a.time - b.time;
	    });
	
	    for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref3 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref3 = _i.value;
	      }
	
	      var i = _ref3;
	      currentCount += i.type === "s" ? 1 : -1;
	
	      if (currentCount === 1) {
	        start = i.time;
	      } else {
	        if (start && +start !== +i.time) {
	          results.push(Interval.fromDateTimes(start, i.time));
	        }
	
	        start = null;
	      }
	    }
	
	    return Interval.merge(results);
	  };
	  /**
	   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
	   * @param {...Interval} intervals
	   * @return {[Interval]}
	   */
	
	
	  _proto.difference = function difference() {
	    var _this = this;
	
	    for (var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      intervals[_key2] = arguments[_key2];
	    }
	
	    return Interval.xor([this].concat(intervals)).map(function (i) {
	      return _this.intersection(i);
	    }).filter(function (i) {
	      return i && !i.isEmpty();
	    });
	  };
	  /**
	   * Returns a string representation of this Interval appropriate for debugging.
	   * @return {string}
	   */
	
	
	  _proto.toString = function toString() {
	    if (!this.isValid) return INVALID$1;
	    return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
	  };
	  /**
	   * Returns an ISO 8601-compliant string representation of this Interval.
	   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
	   * @param {Object} opts - The same options as {@link DateTime.toISO}
	   * @return {string}
	   */
	
	
	  _proto.toISO = function toISO(opts) {
	    if (!this.isValid) return INVALID$1;
	    return this.s.toISO(opts) + "/" + this.e.toISO(opts);
	  };
	  /**
	   * Returns a string representation of this Interval formatted according to the specified format string.
	   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime.toFormat} for details.
	   * @param {Object} opts - options
	   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
	   * @return {string}
	   */
	
	
	  _proto.toFormat = function toFormat(dateFormat, _temp2) {
	    var _ref4 = _temp2 === void 0 ? {} : _temp2,
	        _ref4$separator = _ref4.separator,
	        separator = _ref4$separator === void 0 ? " – " : _ref4$separator;
	
	    if (!this.isValid) return INVALID$1;
	    return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
	  };
	  /**
	   * Return a Duration representing the time spanned by this interval.
	   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
	   * @param {Object} opts - options that affect the creation of the Duration
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
	   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
	   * @return {Duration}
	   */
	
	
	  _proto.toDuration = function toDuration(unit, opts) {
	    if (!this.isValid) {
	      return Duration.invalid(this.invalidReason);
	    }
	
	    return this.e.diff(this.s, unit, opts);
	  };
	  /**
	   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
	   * @param {function} mapFn
	   * @return {Interval}
	   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
	   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
	   */
	
	
	  _proto.mapEndpoints = function mapEndpoints(mapFn) {
	    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
	  };
	
	  _createClass(Interval, [{
	    key: "start",
	    get: function get() {
	      return this.isValid ? this.s : null;
	    }
	    /**
	     * Returns the end of the Interval
	     * @type {DateTime}
	     */
	
	  }, {
	    key: "end",
	    get: function get() {
	      return this.isValid ? this.e : null;
	    }
	    /**
	     * Returns whether this Interval's end is at least its start, i.e. that the Interval isn't 'backwards'.
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isValid",
	    get: function get() {
	      return this.invalidReason === null;
	    }
	    /**
	     * Returns an error code if this Interval is invalid, or null if the Interval is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidReason",
	    get: function get() {
	      return this.invalid ? this.invalid.reason : null;
	    }
	    /**
	     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidExplanation",
	    get: function get() {
	      return this.invalid ? this.invalid.explanation : null;
	    }
	  }]);
	
	  return Interval;
	}();
	
	/**
	 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
	 */
	
	var Info =
	/*#__PURE__*/
	function () {
	  function Info() {}
	
	  /**
	   * Return whether the specified zone contains a DST.
	   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
	   * @return {boolean}
	   */
	  Info.hasDST = function hasDST(zone) {
	    if (zone === void 0) {
	      zone = Settings.defaultZone;
	    }
	
	    var proto = DateTime.local().setZone(zone).set({
	      month: 12
	    });
	    return !zone.universal && proto.offset !== proto.set({
	      month: 6
	    }).offset;
	  };
	  /**
	   * Return whether the specified zone is a valid IANA specifier.
	   * @param {string} zone - Zone to check
	   * @return {boolean}
	   */
	
	
	  Info.isValidIANAZone = function isValidIANAZone(zone) {
	    return !!IANAZone.isValidSpecifier(zone) && IANAZone.isValidZone(zone);
	  };
	  /**
	   * Converts the input into a {@link Zone} instance.
	   *
	   * * If `input` is already a Zone instance, it is returned unchanged.
	   * * If `input` is a string containing a valid time zone name, a Zone instance
	   *   with that name is returned.
	   * * If `input` is a string that doesn't refer to a known time zone, a Zone
	   *   instance with {@link Zone.isValid} == false is returned.
	   * * If `input is a number, a Zone instance with the specified fixed offset
	   *   in minutes is returned.
	   * * If `input` is `null` or `undefined`, the default zone is returned.
	   * @param {string|Zone|number} [input] - the value to be converted
	   * @return {Zone}
	   */
	
	
	  Info.normalizeZone = function normalizeZone$$1(input) {
	    return normalizeZone(input, Settings.defaultZone);
	  };
	  /**
	   * Return an array of standalone month names.
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
	   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @param {string} [opts.outputCalendar='gregory'] - the calendar
	   * @example Info.months()[0] //=> 'January'
	   * @example Info.months('short')[0] //=> 'Jan'
	   * @example Info.months('numeric')[0] //=> '1'
	   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
	   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
	   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
	   * @return {[string]}
	   */
	
	
	  Info.months = function months(length, _temp) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref = _temp === void 0 ? {} : _temp,
	        _ref$locale = _ref.locale,
	        locale = _ref$locale === void 0 ? null : _ref$locale,
	        _ref$numberingSystem = _ref.numberingSystem,
	        numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem,
	        _ref$outputCalendar = _ref.outputCalendar,
	        outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
	
	    return Locale.create(locale, numberingSystem, outputCalendar).months(length);
	  };
	  /**
	   * Return an array of format month names.
	   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
	   * changes the string.
	   * See {@link months}
	   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @param {string} [opts.outputCalendar='gregory'] - the calendar
	   * @return {[string]}
	   */
	
	
	  Info.monthsFormat = function monthsFormat(length, _temp2) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref2 = _temp2 === void 0 ? {} : _temp2,
	        _ref2$locale = _ref2.locale,
	        locale = _ref2$locale === void 0 ? null : _ref2$locale,
	        _ref2$numberingSystem = _ref2.numberingSystem,
	        numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem,
	        _ref2$outputCalendar = _ref2.outputCalendar,
	        outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
	
	    return Locale.create(locale, numberingSystem, outputCalendar).months(length, true);
	  };
	  /**
	   * Return an array of standalone week names.
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
	   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @example Info.weekdays()[0] //=> 'Monday'
	   * @example Info.weekdays('short')[0] //=> 'Mon'
	   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
	   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
	   * @return {[string]}
	   */
	
	
	  Info.weekdays = function weekdays(length, _temp3) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref3 = _temp3 === void 0 ? {} : _temp3,
	        _ref3$locale = _ref3.locale,
	        locale = _ref3$locale === void 0 ? null : _ref3$locale,
	        _ref3$numberingSystem = _ref3.numberingSystem,
	        numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem;
	
	    return Locale.create(locale, numberingSystem, null).weekdays(length);
	  };
	  /**
	   * Return an array of format week names.
	   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
	   * changes the string.
	   * See {@link weekdays}
	   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
	   * @param {Object} opts - options
	   * @param {string} [opts.locale=null] - the locale code
	   * @param {string} [opts.numberingSystem=null] - the numbering system
	   * @return {[string]}
	   */
	
	
	  Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
	    if (length === void 0) {
	      length = "long";
	    }
	
	    var _ref4 = _temp4 === void 0 ? {} : _temp4,
	        _ref4$locale = _ref4.locale,
	        locale = _ref4$locale === void 0 ? null : _ref4$locale,
	        _ref4$numberingSystem = _ref4.numberingSystem,
	        numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem;
	
	    return Locale.create(locale, numberingSystem, null).weekdays(length, true);
	  };
	  /**
	   * Return an array of meridiems.
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
	   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
	   * @return {[string]}
	   */
	
	
	  Info.meridiems = function meridiems(_temp5) {
	    var _ref5 = _temp5 === void 0 ? {} : _temp5,
	        _ref5$locale = _ref5.locale,
	        locale = _ref5$locale === void 0 ? null : _ref5$locale;
	
	    return Locale.create(locale).meridiems();
	  };
	  /**
	   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
	   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
	   * @param {Object} opts - options
	   * @param {string} [opts.locale] - the locale code
	   * @example Info.eras() //=> [ 'BC', 'AD' ]
	   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
	   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
	   * @return {[string]}
	   */
	
	
	  Info.eras = function eras(length, _temp6) {
	    if (length === void 0) {
	      length = "short";
	    }
	
	    var _ref6 = _temp6 === void 0 ? {} : _temp6,
	        _ref6$locale = _ref6.locale,
	        locale = _ref6$locale === void 0 ? null : _ref6$locale;
	
	    return Locale.create(locale, null, "gregory").eras(length);
	  };
	  /**
	   * Return the set of available features in this environment.
	   * Some features of Luxon are not available in all environments. For example, on older browsers, timezone support is not available. Use this function to figure out if that's the case.
	   * Keys:
	   * * `zones`: whether this environment supports IANA timezones
	   * * `intlTokens`: whether this environment supports internationalized token-based formatting/parsing
	   * * `intl`: whether this environment supports general internationalization
	   * * `relative`: whether this environment supports relative time formatting
	   * @example Info.features() //=> { intl: true, intlTokens: false, zones: true, relative: false }
	   * @return {Object}
	   */
	
	
	  Info.features = function features() {
	    var intl = false,
	        intlTokens = false,
	        zones = false,
	        relative = hasRelative();
	
	    if (hasIntl()) {
	      intl = true;
	      intlTokens = hasFormatToParts();
	
	      try {
	        zones = new Intl.DateTimeFormat("en", {
	          timeZone: "America/New_York"
	        }).resolvedOptions().timeZone === "America/New_York";
	      } catch (e) {
	        zones = false;
	      }
	    }
	
	    return {
	      intl: intl,
	      intlTokens: intlTokens,
	      zones: zones,
	      relative: relative
	    };
	  };
	
	  return Info;
	}();
	
	function dayDiff(earlier, later) {
	  var utcDayStart = function utcDayStart(dt) {
	    return dt.toUTC(0, {
	      keepLocalTime: true
	    }).startOf("day").valueOf();
	  },
	      ms = utcDayStart(later) - utcDayStart(earlier);
	
	  return Math.floor(Duration.fromMillis(ms).as("days"));
	}
	
	function highOrderDiffs(cursor, later, units) {
	  var differs = [["years", function (a, b) {
	    return b.year - a.year;
	  }], ["months", function (a, b) {
	    return b.month - a.month + (b.year - a.year) * 12;
	  }], ["weeks", function (a, b) {
	    var days = dayDiff(a, b);
	    return (days - days % 7) / 7;
	  }], ["days", dayDiff]];
	  var results = {};
	  var lowestOrder, highWater;
	
	  for (var _i = 0; _i < differs.length; _i++) {
	    var _differs$_i = differs[_i],
	        unit = _differs$_i[0],
	        differ = _differs$_i[1];
	
	    if (units.indexOf(unit) >= 0) {
	      var _cursor$plus;
	
	      lowestOrder = unit;
	      var delta = differ(cursor, later);
	      highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));
	
	      if (highWater > later) {
	        var _highWater$minus;
	
	        cursor = highWater.minus((_highWater$minus = {}, _highWater$minus[unit] = 1, _highWater$minus));
	        delta -= 1;
	      } else {
	        cursor = highWater;
	      }
	
	      results[unit] = delta;
	    }
	  }
	
	  return [cursor, results, highWater, lowestOrder];
	}
	
	function _diff (earlier, later, units, opts) {
	  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
	      cursor = _highOrderDiffs[0],
	      results = _highOrderDiffs[1],
	      highWater = _highOrderDiffs[2],
	      lowestOrder = _highOrderDiffs[3];
	
	  var remainingMillis = later - cursor;
	  var lowerOrderUnits = units.filter(function (u) {
	    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
	  });
	
	  if (lowerOrderUnits.length === 0) {
	    if (highWater < later) {
	      var _cursor$plus2;
	
	      highWater = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[lowestOrder] = 1, _cursor$plus2));
	    }
	
	    if (highWater !== cursor) {
	      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
	    }
	  }
	
	  var duration = Duration.fromObject(Object.assign(results, opts));
	
	  if (lowerOrderUnits.length > 0) {
	    var _Duration$fromMillis;
	
	    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
	  } else {
	    return duration;
	  }
	}
	
	var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
	
	function intUnit(regex, post) {
	  if (post === void 0) {
	    post = function post(i) {
	      return i;
	    };
	  }
	
	  return {
	    regex: regex,
	    deser: function deser(_ref) {
	      var s = _ref[0];
	      return post(parseInt(s));
	    }
	  };
	}
	
	function fixListRegex(s) {
	  // make dots optional and also make them literal
	  return s.replace(/\./, "\\.?");
	}
	
	function stripInsensitivities(s) {
	  return s.replace(/\./, "").toLowerCase();
	}
	
	function oneOf(strings, startIndex) {
	  if (strings === null) {
	    return null;
	  } else {
	    return {
	      regex: RegExp(strings.map(fixListRegex).join("|")),
	      deser: function deser(_ref2) {
	        var s = _ref2[0];
	        return strings.findIndex(function (i) {
	          return stripInsensitivities(s) === stripInsensitivities(i);
	        }) + startIndex;
	      }
	    };
	  }
	}
	
	function offset(regex, groups) {
	  return {
	    regex: regex,
	    deser: function deser(_ref3) {
	      var h = _ref3[1],
	          m = _ref3[2];
	      return signedOffset(h, m);
	    },
	    groups: groups
	  };
	}
	
	function simple(regex) {
	  return {
	    regex: regex,
	    deser: function deser(_ref4) {
	      var s = _ref4[0];
	      return s;
	    }
	  };
	}
	
	function unitForToken(token, loc) {
	  var one = /\d/,
	      two = /\d{2}/,
	      three = /\d{3}/,
	      four = /\d{4}/,
	      oneOrTwo = /\d{1,2}/,
	      oneToThree = /\d{1,3}/,
	      twoToFour = /\d{2,4}/,
	      literal = function literal(t) {
	    return {
	      regex: RegExp(t.val),
	      deser: function deser(_ref5) {
	        var s = _ref5[0];
	        return s;
	      },
	      literal: true
	    };
	  },
	      unitate = function unitate(t) {
	    if (token.literal) {
	      return literal(t);
	    }
	
	    switch (t.val) {
	      // era
	      case "G":
	        return oneOf(loc.eras("short", false), 0);
	
	      case "GG":
	        return oneOf(loc.eras("long", false), 0);
	      // years
	
	      case "y":
	        return intUnit(/\d{1,6}/);
	
	      case "yy":
	        return intUnit(twoToFour, untruncateYear);
	
	      case "yyyy":
	        return intUnit(four);
	
	      case "yyyyy":
	        return intUnit(/\d{4,6}/);
	
	      case "yyyyyy":
	        return intUnit(/\d{6}/);
	      // months
	
	      case "M":
	        return intUnit(oneOrTwo);
	
	      case "MM":
	        return intUnit(two);
	
	      case "MMM":
	        return oneOf(loc.months("short", false, false), 1);
	
	      case "MMMM":
	        return oneOf(loc.months("long", false, false), 1);
	
	      case "L":
	        return intUnit(oneOrTwo);
	
	      case "LL":
	        return intUnit(two);
	
	      case "LLL":
	        return oneOf(loc.months("short", true, false), 1);
	
	      case "LLLL":
	        return oneOf(loc.months("long", true, false), 1);
	      // dates
	
	      case "d":
	        return intUnit(oneOrTwo);
	
	      case "dd":
	        return intUnit(two);
	      // ordinals
	
	      case "o":
	        return intUnit(oneToThree);
	
	      case "ooo":
	        return intUnit(three);
	      // time
	
	      case "HH":
	        return intUnit(two);
	
	      case "H":
	        return intUnit(oneOrTwo);
	
	      case "hh":
	        return intUnit(two);
	
	      case "h":
	        return intUnit(oneOrTwo);
	
	      case "mm":
	        return intUnit(two);
	
	      case "m":
	        return intUnit(oneOrTwo);
	
	      case "s":
	        return intUnit(oneOrTwo);
	
	      case "ss":
	        return intUnit(two);
	
	      case "S":
	        return intUnit(oneToThree);
	
	      case "SSS":
	        return intUnit(three);
	
	      case "u":
	        return simple(/\d{1,9}/);
	      // meridiem
	
	      case "a":
	        return oneOf(loc.meridiems(), 0);
	      // weekYear (k)
	
	      case "kkkk":
	        return intUnit(four);
	
	      case "kk":
	        return intUnit(twoToFour, untruncateYear);
	      // weekNumber (W)
	
	      case "W":
	        return intUnit(oneOrTwo);
	
	      case "WW":
	        return intUnit(two);
	      // weekdays
	
	      case "E":
	      case "c":
	        return intUnit(one);
	
	      case "EEE":
	        return oneOf(loc.weekdays("short", false, false), 1);
	
	      case "EEEE":
	        return oneOf(loc.weekdays("long", false, false), 1);
	
	      case "ccc":
	        return oneOf(loc.weekdays("short", true, false), 1);
	
	      case "cccc":
	        return oneOf(loc.weekdays("long", true, false), 1);
	      // offset/zone
	
	      case "Z":
	      case "ZZ":
	        return offset(/([+-]\d{1,2})(?::(\d{2}))?/, 2);
	
	      case "ZZZ":
	        return offset(/([+-]\d{1,2})(\d{2})?/, 2);
	      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
	      // because we don't have any way to figure out what they are
	
	      case "z":
	        return simple(/[a-z_+-]{1,256}(\/[a-z_+-]{1,256}(\/[a-z_+-]{1,256})?)?/i);
	
	      default:
	        return literal(t);
	    }
	  };
	
	  var unit = unitate(token) || {
	    invalidReason: MISSING_FTP
	  };
	  unit.token = token;
	  return unit;
	}
	
	function buildRegex(units) {
	  var re = units.map(function (u) {
	    return u.regex;
	  }).reduce(function (f, r) {
	    return f + "(" + r.source + ")";
	  }, "");
	  return ["^" + re + "$", units];
	}
	
	function match(input, regex, handlers) {
	  var matches = input.match(regex);
	
	  if (matches) {
	    var all = {};
	    var matchIndex = 1;
	
	    for (var i in handlers) {
	      if (handlers.hasOwnProperty(i)) {
	        var h = handlers[i],
	            groups = h.groups ? h.groups + 1 : 1;
	
	        if (!h.literal && h.token) {
	          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
	        }
	
	        matchIndex += groups;
	      }
	    }
	
	    return [matches, all];
	  } else {
	    return [matches, {}];
	  }
	}
	
	function dateTimeFromMatches(matches) {
	  var toField = function toField(token) {
	    switch (token) {
	      case "S":
	        return "millisecond";
	
	      case "s":
	        return "second";
	
	      case "m":
	        return "minute";
	
	      case "h":
	      case "H":
	        return "hour";
	
	      case "d":
	        return "day";
	
	      case "o":
	        return "ordinal";
	
	      case "L":
	      case "M":
	        return "month";
	
	      case "y":
	        return "year";
	
	      case "E":
	      case "c":
	        return "weekday";
	
	      case "W":
	        return "weekNumber";
	
	      case "k":
	        return "weekYear";
	
	      default:
	        return null;
	    }
	  };
	
	  var zone;
	
	  if (!isUndefined(matches.Z)) {
	    zone = new FixedOffsetZone(matches.Z);
	  } else if (!isUndefined(matches.z)) {
	    zone = new IANAZone(matches.z);
	  } else {
	    zone = null;
	  }
	
	  if (!isUndefined(matches.h)) {
	    if (matches.h < 12 && matches.a === 1) {
	      matches.h += 12;
	    } else if (matches.h === 12 && matches.a === 0) {
	      matches.h = 0;
	    }
	  }
	
	  if (matches.G === 0 && matches.y) {
	    matches.y = -matches.y;
	  }
	
	  if (!isUndefined(matches.u)) {
	    matches.S = parseMillis(matches.u);
	  }
	
	  var vals = Object.keys(matches).reduce(function (r, k) {
	    var f = toField(k);
	
	    if (f) {
	      r[f] = matches[k];
	    }
	
	    return r;
	  }, {});
	  return [vals, zone];
	}
	/**
	 * @private
	 */
	
	
	function explainFromTokens(locale, input, format) {
	  var tokens = Formatter.parseFormat(format),
	      units = tokens.map(function (t) {
	    return unitForToken(t, locale);
	  }),
	      disqualifyingUnit = units.find(function (t) {
	    return t.invalidReason;
	  });
	
	  if (disqualifyingUnit) {
	    return {
	      input: input,
	      tokens: tokens,
	      invalidReason: disqualifyingUnit.invalidReason
	    };
	  } else {
	    var _buildRegex = buildRegex(units),
	        regexString = _buildRegex[0],
	        handlers = _buildRegex[1],
	        regex = RegExp(regexString, "i"),
	        _match = match(input, regex, handlers),
	        rawMatches = _match[0],
	        matches = _match[1],
	        _ref6 = matches ? dateTimeFromMatches(matches) : [null, null],
	        result = _ref6[0],
	        zone = _ref6[1];
	
	    return {
	      input: input,
	      tokens: tokens,
	      regex: regex,
	      rawMatches: rawMatches,
	      matches: matches,
	      result: result,
	      zone: zone
	    };
	  }
	}
	function parseFromTokens(locale, input, format) {
	  var _explainFromTokens = explainFromTokens(locale, input, format),
	      result = _explainFromTokens.result,
	      zone = _explainFromTokens.zone,
	      invalidReason = _explainFromTokens.invalidReason;
	
	  return [result, zone, invalidReason];
	}
	
	var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
	    leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
	
	function unitOutOfRange(unit, value) {
	  return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
	}
	
	function dayOfWeek(year, month, day) {
	  var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
	  return js === 0 ? 7 : js;
	}
	
	function computeOrdinal(year, month, day) {
	  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
	}
	
	function uncomputeOrdinal(year, ordinal) {
	  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
	      month0 = table.findIndex(function (i) {
	    return i < ordinal;
	  }),
	      day = ordinal - table[month0];
	  return {
	    month: month0 + 1,
	    day: day
	  };
	}
	/**
	 * @private
	 */
	
	
	function gregorianToWeek(gregObj) {
	  var year = gregObj.year,
	      month = gregObj.month,
	      day = gregObj.day,
	      ordinal = computeOrdinal(year, month, day),
	      weekday = dayOfWeek(year, month, day);
	  var weekNumber = Math.floor((ordinal - weekday + 10) / 7),
	      weekYear;
	
	  if (weekNumber < 1) {
	    weekYear = year - 1;
	    weekNumber = weeksInWeekYear(weekYear);
	  } else if (weekNumber > weeksInWeekYear(year)) {
	    weekYear = year + 1;
	    weekNumber = 1;
	  } else {
	    weekYear = year;
	  }
	
	  return Object.assign({
	    weekYear: weekYear,
	    weekNumber: weekNumber,
	    weekday: weekday
	  }, timeObject(gregObj));
	}
	function weekToGregorian(weekData) {
	  var weekYear = weekData.weekYear,
	      weekNumber = weekData.weekNumber,
	      weekday = weekData.weekday,
	      weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
	      yearInDays = daysInYear(weekYear);
	  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
	      year;
	
	  if (ordinal < 1) {
	    year = weekYear - 1;
	    ordinal += daysInYear(year);
	  } else if (ordinal > yearInDays) {
	    year = weekYear + 1;
	    ordinal -= daysInYear(weekYear);
	  } else {
	    year = weekYear;
	  }
	
	  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
	      month = _uncomputeOrdinal.month,
	      day = _uncomputeOrdinal.day;
	
	  return Object.assign({
	    year: year,
	    month: month,
	    day: day
	  }, timeObject(weekData));
	}
	function gregorianToOrdinal(gregData) {
	  var year = gregData.year,
	      month = gregData.month,
	      day = gregData.day,
	      ordinal = computeOrdinal(year, month, day);
	  return Object.assign({
	    year: year,
	    ordinal: ordinal
	  }, timeObject(gregData));
	}
	function ordinalToGregorian(ordinalData) {
	  var year = ordinalData.year,
	      ordinal = ordinalData.ordinal,
	      _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
	      month = _uncomputeOrdinal2.month,
	      day = _uncomputeOrdinal2.day;
	
	  return Object.assign({
	    year: year,
	    month: month,
	    day: day
	  }, timeObject(ordinalData));
	}
	function hasInvalidWeekData(obj) {
	  var validYear = isNumber(obj.weekYear),
	      validWeek = numberBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
	      validWeekday = numberBetween(obj.weekday, 1, 7);
	
	  if (!validYear) {
	    return unitOutOfRange("weekYear", obj.weekYear);
	  } else if (!validWeek) {
	    return unitOutOfRange("week", obj.week);
	  } else if (!validWeekday) {
	    return unitOutOfRange("weekday", obj.weekday);
	  } else return false;
	}
	function hasInvalidOrdinalData(obj) {
	  var validYear = isNumber(obj.year),
	      validOrdinal = numberBetween(obj.ordinal, 1, daysInYear(obj.year));
	
	  if (!validYear) {
	    return unitOutOfRange("year", obj.year);
	  } else if (!validOrdinal) {
	    return unitOutOfRange("ordinal", obj.ordinal);
	  } else return false;
	}
	function hasInvalidGregorianData(obj) {
	  var validYear = isNumber(obj.year),
	      validMonth = numberBetween(obj.month, 1, 12),
	      validDay = numberBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
	
	  if (!validYear) {
	    return unitOutOfRange("year", obj.year);
	  } else if (!validMonth) {
	    return unitOutOfRange("month", obj.month);
	  } else if (!validDay) {
	    return unitOutOfRange("day", obj.day);
	  } else return false;
	}
	function hasInvalidTimeData(obj) {
	  var validHour = numberBetween(obj.hour, 0, 23),
	      validMinute = numberBetween(obj.minute, 0, 59),
	      validSecond = numberBetween(obj.second, 0, 59),
	      validMillisecond = numberBetween(obj.millisecond, 0, 999);
	
	  if (!validHour) {
	    return unitOutOfRange("hour", obj.hour);
	  } else if (!validMinute) {
	    return unitOutOfRange("minute", obj.minute);
	  } else if (!validSecond) {
	    return unitOutOfRange("second", obj.secon);
	  } else if (!validMillisecond) {
	    return unitOutOfRange("millisecond", obj.millisecond);
	  } else return false;
	}
	
	var INVALID$2 = "Invalid DateTime";
	
	function unsupportedZone(zone) {
	  return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
	} // we cache week data on the DT object and this intermediates the cache
	
	
	function possiblyCachedWeekData(dt) {
	  if (dt.weekData === null) {
	    dt.weekData = gregorianToWeek(dt.c);
	  }
	
	  return dt.weekData;
	} // clone really means, "make a new object with these modifications". all "setters" really use this
	// to create a new object while only changing some of the properties
	
	
	function clone$1(inst, alts) {
	  var current = {
	    ts: inst.ts,
	    zone: inst.zone,
	    c: inst.c,
	    o: inst.o,
	    loc: inst.loc,
	    invalid: inst.invalid
	  };
	  return new DateTime(Object.assign({}, current, alts, {
	    old: current
	  }));
	} // find the right offset a given local time. The o input is our guess, which determines which
	// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
	
	
	function fixOffset(localTS, o, tz) {
	  // Our UTC time is just a guess because our offset is just a guess
	  var utcGuess = localTS - o * 60 * 1000; // Test whether the zone matches the offset for this ts
	
	  var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done
	
	  if (o === o2) {
	    return [utcGuess, o];
	  } // If not, change the ts by the difference in the offset
	
	
	  utcGuess -= (o2 - o) * 60 * 1000; // If that gives us the local time we want, we're done
	
	  var o3 = tz.offset(utcGuess);
	
	  if (o2 === o3) {
	    return [utcGuess, o2];
	  } // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
	
	
	  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
	} // convert an epoch timestamp into a calendar object with the given offset
	
	
	function tsToObj(ts, offset) {
	  ts += offset * 60 * 1000;
	  var d = new Date(ts);
	  return {
	    year: d.getUTCFullYear(),
	    month: d.getUTCMonth() + 1,
	    day: d.getUTCDate(),
	    hour: d.getUTCHours(),
	    minute: d.getUTCMinutes(),
	    second: d.getUTCSeconds(),
	    millisecond: d.getUTCMilliseconds()
	  };
	} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)
	
	
	function objToLocalTS(obj) {
	  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
	
	  if (obj.year < 100 && obj.year >= 0) {
	    d = new Date(d);
	    d.setUTCFullYear(obj.year);
	  }
	
	  return +d;
	} // convert a calendar object to a epoch timestamp
	
	
	function objToTS(obj, offset, zone) {
	  return fixOffset(objToLocalTS(obj), offset, zone);
	} // create a new DT instance by adding a duration, adjusting for DSTs
	
	
	function adjustTime(inst, dur) {
	  var oPre = inst.o,
	      year = inst.c.year + dur.years,
	      month = inst.c.month + dur.months + dur.quarters * 3,
	      c = Object.assign({}, inst.c, {
	    year: year,
	    month: month,
	    day: Math.min(inst.c.day, daysInMonth(year, month)) + dur.days + dur.weeks * 7
	  }),
	      millisToAdd = Duration.fromObject({
	    hours: dur.hours,
	    minutes: dur.minutes,
	    seconds: dur.seconds,
	    milliseconds: dur.milliseconds
	  }).as("milliseconds"),
	      localTS = objToLocalTS(c);
	
	  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
	      ts = _fixOffset[0],
	      o = _fixOffset[1];
	
	  if (millisToAdd !== 0) {
	    ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same
	
	    o = inst.zone.offset(ts);
	  }
	
	  return {
	    ts: ts,
	    o: o
	  };
	} // helper useful in turning the results of parsing into real dates
	// by handling the zone options
	
	
	function parseDataToDateTime(parsed, parsedZone, opts, format, text) {
	  var setZone = opts.setZone,
	      zone = opts.zone;
	
	  if (parsed && Object.keys(parsed).length !== 0) {
	    var interpretationZone = parsedZone || zone,
	        inst = DateTime.fromObject(Object.assign(parsed, opts, {
	      zone: interpretationZone
	    }));
	    return setZone ? inst : inst.setZone(zone);
	  } else {
	    return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
	  }
	} // if you want to output a technical format (e.g. RFC 2822), this helper
	// helps handle the details
	
	
	function toTechFormat(dt, format) {
	  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
	    allowZ: true,
	    forceSimple: true
	  }).formatDateTimeFromString(dt, format) : null;
	} // technical time formats (e.g. the time part of ISO 8601), take some options
	// and this commonizes their handling
	
	
	function toTechTimeFormat(dt, _ref) {
	  var _ref$suppressSeconds = _ref.suppressSeconds,
	      suppressSeconds = _ref$suppressSeconds === void 0 ? false : _ref$suppressSeconds,
	      _ref$suppressMillisec = _ref.suppressMilliseconds,
	      suppressMilliseconds = _ref$suppressMillisec === void 0 ? false : _ref$suppressMillisec,
	      _ref$includeOffset = _ref.includeOffset,
	      includeOffset = _ref$includeOffset === void 0 ? true : _ref$includeOffset,
	      _ref$includeZone = _ref.includeZone,
	      includeZone = _ref$includeZone === void 0 ? false : _ref$includeZone,
	      _ref$spaceZone = _ref.spaceZone,
	      spaceZone = _ref$spaceZone === void 0 ? false : _ref$spaceZone;
	  var fmt = "HH:mm";
	
	  if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
	    fmt += ":ss";
	
	    if (!suppressMilliseconds || dt.millisecond !== 0) {
	      fmt += ".SSS";
	    }
	  }
	
	  if ((includeZone || includeOffset) && spaceZone) {
	    fmt += " ";
	  }
	
	  if (includeZone) {
	    fmt += "z";
	  } else if (includeOffset) {
	    fmt += "ZZ";
	  }
	
	  return toTechFormat(dt, fmt);
	} // defaults for unspecified units in the supported calendars
	
	
	var defaultUnitValues = {
	  month: 1,
	  day: 1,
	  hour: 0,
	  minute: 0,
	  second: 0,
	  millisecond: 0
	},
	    defaultWeekUnitValues = {
	  weekNumber: 1,
	  weekday: 1,
	  hour: 0,
	  minute: 0,
	  second: 0,
	  millisecond: 0
	},
	    defaultOrdinalUnitValues = {
	  ordinal: 1,
	  hour: 0,
	  minute: 0,
	  second: 0,
	  millisecond: 0
	}; // Units in the supported calendars, sorted by bigness
	
	var orderedUnits$1 = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
	    orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
	    orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"]; // standardize case and plurality in units
	
	function normalizeUnit(unit, ignoreUnknown) {
	  if (ignoreUnknown === void 0) {
	    ignoreUnknown = false;
	  }
	
	  var normalized = {
	    year: "year",
	    years: "year",
	    month: "month",
	    months: "month",
	    day: "day",
	    days: "day",
	    hour: "hour",
	    hours: "hour",
	    minute: "minute",
	    minutes: "minute",
	    second: "second",
	    seconds: "second",
	    millisecond: "millisecond",
	    milliseconds: "millisecond",
	    weekday: "weekday",
	    weekdays: "weekday",
	    weeknumber: "weekNumber",
	    weeksnumber: "weekNumber",
	    weeknumbers: "weekNumber",
	    weekyear: "weekYear",
	    weekyears: "weekYear",
	    ordinal: "ordinal"
	  }[unit ? unit.toLowerCase() : unit];
	  if (!ignoreUnknown && !normalized) throw new InvalidUnitError(unit);
	  return normalized;
	} // this is a dumbed down version of fromObject() that runs about 60% faster
	// but doesn't do any validation, makes a bunch of assumptions about what units
	// are present, and so on.
	
	
	function quickDT(obj, zone) {
	  // assume we have the higher-order units
	  for (var _i = 0; _i < orderedUnits$1.length; _i++) {
	    var u = orderedUnits$1[_i];
	
	    if (isUndefined(obj[u])) {
	      obj[u] = defaultUnitValues[u];
	    }
	  }
	
	  var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
	
	  if (invalid) {
	    return DateTime.invalid(invalid);
	  }
	
	  var tsNow = Settings.now(),
	      offsetProvis = zone.offset(tsNow),
	      _objToTS = objToTS(obj, offsetProvis, zone),
	      ts = _objToTS[0],
	      o = _objToTS[1];
	
	  return new DateTime({
	    ts: ts,
	    zone: zone,
	    o: o
	  });
	}
	
	function diffRelative(start, end, opts) {
	  var round = isUndefined(opts.round) ? true : opts.round,
	      format = function format(c, unit) {
	    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
	    var formatter = end.loc.clone(opts).relFormatter(opts);
	    return formatter.format(c, unit);
	  },
	      differ = function differ(unit) {
	    if (opts.calendary) {
	      if (!end.hasSame(start, unit)) {
	        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
	      } else return 0;
	    } else {
	      return end.diff(start, unit).get(unit);
	    }
	  };
	
	  if (opts.unit) {
	    return format(differ(opts.unit), opts.unit);
	  }
	
	  for (var _iterator = opts.units, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref2;
	
	    if (_isArray) {
	      if (_i2 >= _iterator.length) break;
	      _ref2 = _iterator[_i2++];
	    } else {
	      _i2 = _iterator.next();
	      if (_i2.done) break;
	      _ref2 = _i2.value;
	    }
	
	    var unit = _ref2;
	    var count = differ(unit);
	
	    if (Math.abs(count) >= 1) {
	      return format(count, unit);
	    }
	  }
	
	  return format(0, opts.units[opts.units.length - 1]);
	}
	/**
	 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
	 *
	 * A DateTime comprises of:
	 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
	 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
	 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
	 *
	 * Here is a brief overview of the most commonly used functionality it provides:
	 *
	 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link local}, {@link utc}, and (most flexibly) {@link fromObject}. To create one from a standard string format, use {@link fromISO}, {@link fromHTTP}, and {@link fromRFC2822}. To create one from a custom string format, use {@link fromFormat}. To create one from a native JS date, use {@link fromJSDate}.
	 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link toObject}), use the {@link year}, {@link month},
	 * {@link day}, {@link hour}, {@link minute}, {@link second}, {@link millisecond} accessors.
	 * * **Week calendar**: For ISO week calendar attributes, see the {@link weekYear}, {@link weekNumber}, and {@link weekday} accessors.
	 * * **Configuration** See the {@link locale} and {@link numberingSystem} accessors.
	 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link set}, {@link reconfigure}, {@link setZone}, {@link setLocale}, {@link plus}, {@link minus}, {@link endOf}, {@link startOf}, {@link toUTC}, and {@link toLocal}.
	 * * **Output**: To convert the DateTime to other representations, use the {@link toRelative}, {@link toRelativeCalendar}, {@link toJSON}, {@link toISO}, {@link toHTTP}, {@link toObject}, {@link toRFC2822}, {@link toString}, {@link toLocaleString}, {@link toFormat}, {@link toMillis} and {@link toJSDate}.
	 *
	 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
	 */
	
	
	var DateTime =
	/*#__PURE__*/
	function () {
	  /**
	   * @access private
	   */
	  function DateTime(config) {
	    var zone = config.zone || Settings.defaultZone,
	        invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
	    /**
	     * @access private
	     */
	
	    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
	    var c = null,
	        o = null;
	
	    if (!invalid) {
	      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
	      c = unchanged ? config.old.c : tsToObj(this.ts, zone.offset(this.ts));
	      o = unchanged ? config.old.o : zone.offset(this.ts);
	    }
	    /**
	     * @access private
	     */
	
	
	    this._zone = zone;
	    /**
	     * @access private
	     */
	
	    this.loc = config.loc || Locale.create();
	    /**
	     * @access private
	     */
	
	    this.invalid = invalid;
	    /**
	     * @access private
	     */
	
	    this.weekData = null;
	    /**
	     * @access private
	     */
	
	    this.c = c;
	    /**
	     * @access private
	     */
	
	    this.o = o;
	    /**
	     * @access private
	     */
	
	    this.isLuxonDateTime = true;
	  } // CONSTRUCT
	
	  /**
	   * Create a local DateTime
	   * @param {number} year - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
	   * @param {number} [month=1] - The month, 1-indexed
	   * @param {number} [day=1] - The day of the month
	   * @param {number} [hour=0] - The hour of the day, in 24-hour time
	   * @param {number} [minute=0] - The minute of the hour, i.e. a number between 0 and 59
	   * @param {number} [second=0] - The second of the minute, i.e. a number between 0 and 59
	   * @param {number} [millisecond=0] - The millisecond of the second, i.e. a number between 0 and 999
	   * @example DateTime.local()                            //~> now
	   * @example DateTime.local(2017)                        //~> 2017-01-01T00:00:00
	   * @example DateTime.local(2017, 3)                     //~> 2017-03-01T00:00:00
	   * @example DateTime.local(2017, 3, 12)                 //~> 2017-03-12T00:00:00
	   * @example DateTime.local(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00
	   * @example DateTime.local(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00
	   * @example DateTime.local(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10
	   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765
	   * @return {DateTime}
	   */
	
	
	  DateTime.local = function local(year, month, day, hour, minute, second, millisecond) {
	    if (isUndefined(year)) {
	      return new DateTime({
	        ts: Settings.now()
	      });
	    } else {
	      return quickDT({
	        year: year,
	        month: month,
	        day: day,
	        hour: hour,
	        minute: minute,
	        second: second,
	        millisecond: millisecond
	      }, Settings.defaultZone);
	    }
	  };
	  /**
	   * Create a DateTime in UTC
	   * @param {number} year - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
	   * @param {number} [month=1] - The month, 1-indexed
	   * @param {number} [day=1] - The day of the month
	   * @param {number} [hour=0] - The hour of the day, in 24-hour time
	   * @param {number} [minute=0] - The minute of the hour, i.e. a number between 0 and 59
	   * @param {number} [second=0] - The second of the minute, i.e. a number between 0 and 59
	   * @param {number} [millisecond=0] - The millisecond of the second, i.e. a number between 0 and 999
	   * @example DateTime.utc()                            //~> now
	   * @example DateTime.utc(2017)                        //~> 2017-01-01T00:00:00Z
	   * @example DateTime.utc(2017, 3)                     //~> 2017-03-01T00:00:00Z
	   * @example DateTime.utc(2017, 3, 12)                 //~> 2017-03-12T00:00:00Z
	   * @example DateTime.utc(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00Z
	   * @example DateTime.utc(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00Z
	   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10Z
	   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765Z
	   * @return {DateTime}
	   */
	
	
	  DateTime.utc = function utc(year, month, day, hour, minute, second, millisecond) {
	    if (isUndefined(year)) {
	      return new DateTime({
	        ts: Settings.now(),
	        zone: FixedOffsetZone.utcInstance
	      });
	    } else {
	      return quickDT({
	        year: year,
	        month: month,
	        day: day,
	        hour: hour,
	        minute: minute,
	        second: second,
	        millisecond: millisecond
	      }, FixedOffsetZone.utcInstance);
	    }
	  };
	  /**
	   * Create a DateTime from a Javascript Date object. Uses the default zone.
	   * @param {Date} date - a Javascript Date object
	   * @param {Object} options - configuration options for the DateTime
	   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
	   * @return {DateTime}
	   */
	
	
	  DateTime.fromJSDate = function fromJSDate(date, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    return new DateTime({
	      ts: isDate(date) ? date.valueOf() : NaN,
	      zone: normalizeZone(options.zone, Settings.defaultZone),
	      loc: Locale.fromObject(options)
	    });
	  };
	  /**
	   * Create a DateTime from a number of milliseconds since the epoch (i.e. since 1 January 1970 00:00:00 UTC). Uses the default zone.
	   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
	   * @param {Object} options - configuration options for the DateTime
	   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
	   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
	   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @return {DateTime}
	   */
	
	
	  DateTime.fromMillis = function fromMillis(milliseconds, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!isNumber(milliseconds)) {
	      throw new InvalidArgumentError("fromMillis requires a numerical input");
	    } else {
	      return new DateTime({
	        ts: milliseconds,
	        zone: normalizeZone(options.zone, Settings.defaultZone),
	        loc: Locale.fromObject(options)
	      });
	    }
	  };
	  /**
	   * Create a DateTime from a number of seconds since the epoch (i.e. since 1 January 1970 00:00:00 UTC). Uses the default zone.
	   * @param {number} seconds - a number of seconds since 1970 UTC
	   * @param {Object} options - configuration options for the DateTime
	   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
	   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
	   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @return {DateTime}
	   */
	
	
	  DateTime.fromSeconds = function fromSeconds(seconds, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!isNumber(seconds)) {
	      throw new InvalidArgumentError("fromSeconds requires a numerical input");
	    } else {
	      return new DateTime({
	        ts: seconds * 1000,
	        zone: normalizeZone(options.zone, Settings.defaultZone),
	        loc: Locale.fromObject(options)
	      });
	    }
	  };
	  /**
	   * Create a DateTime from a Javascript object with keys like 'year' and 'hour' with reasonable defaults.
	   * @param {Object} obj - the object to create the DateTime from
	   * @param {number} obj.year - a year, such as 1987
	   * @param {number} obj.month - a month, 1-12
	   * @param {number} obj.day - a day of the month, 1-31, depending on the month
	   * @param {number} obj.ordinal - day of the year, 1-365 or 366
	   * @param {number} obj.weekYear - an ISO week year
	   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
	   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
	   * @param {number} obj.hour - hour of the day, 0-23
	   * @param {number} obj.minute - minute of the hour, 0-59
	   * @param {number} obj.second - second of the minute, 0-59
	   * @param {number} obj.millisecond - millisecond of the second, 0-999
	   * @param {string|Zone} [obj.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
	   * @param {string} [obj.locale='en-US'] - a locale to set on the resulting DateTime instance
	   * @param {string} obj.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} obj.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
	   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01T00'
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'utc' }),
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'local' })
	   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'America/New_York' })
	   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
	   * @return {DateTime}
	   */
	
	
	  DateTime.fromObject = function fromObject(obj) {
	    var zoneToUse = normalizeZone(obj.zone, Settings.defaultZone);
	
	    if (!zoneToUse.isValid) {
	      return DateTime.invalid(unsupportedZone(zoneToUse));
	    }
	
	    var tsNow = Settings.now(),
	        offsetProvis = zoneToUse.offset(tsNow),
	        normalized = normalizeObject(obj, normalizeUnit, true),
	        containsOrdinal = !isUndefined(normalized.ordinal),
	        containsGregorYear = !isUndefined(normalized.year),
	        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
	        containsGregor = containsGregorYear || containsGregorMD,
	        definiteWeekDef = normalized.weekYear || normalized.weekNumber,
	        loc = Locale.fromObject(obj); // cases:
	    // just a weekday -> this week's instance of that weekday, no worries
	    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
	    // (gregorian month or day) + ordinal -> error
	    // otherwise just use weeks or ordinals or gregorian, depending on what's specified
	
	    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
	      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
	    }
	
	    if (containsGregorMD && containsOrdinal) {
	      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
	    }
	
	    var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff
	
	    var units,
	        defaultValues,
	        objNow = tsToObj(tsNow, offsetProvis);
	
	    if (useWeekData) {
	      units = orderedWeekUnits;
	      defaultValues = defaultWeekUnitValues;
	      objNow = gregorianToWeek(objNow);
	    } else if (containsOrdinal) {
	      units = orderedOrdinalUnits;
	      defaultValues = defaultOrdinalUnitValues;
	      objNow = gregorianToOrdinal(objNow);
	    } else {
	      units = orderedUnits$1;
	      defaultValues = defaultUnitValues;
	    } // set default values for missing stuff
	
	
	    var foundFirst = false;
	
	    for (var _iterator2 = units, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray2) {
	        if (_i3 >= _iterator2.length) break;
	        _ref3 = _iterator2[_i3++];
	      } else {
	        _i3 = _iterator2.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var u = _ref3;
	      var v = normalized[u];
	
	      if (!isUndefined(v)) {
	        foundFirst = true;
	      } else if (foundFirst) {
	        normalized[u] = defaultValues[u];
	      } else {
	        normalized[u] = objNow[u];
	      }
	    } // make sure the values we have are in range
	
	
	    var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
	        invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
	
	    if (invalid) {
	      return DateTime.invalid(invalid);
	    } // compute the actual time
	
	
	    var gregorian = useWeekData ? weekToGregorian(normalized) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
	        _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse),
	        tsFinal = _objToTS2[0],
	        offsetFinal = _objToTS2[1],
	        inst = new DateTime({
	      ts: tsFinal,
	      zone: zoneToUse,
	      o: offsetFinal,
	      loc: loc
	    }); // gregorian data + weekday serves only to validate
	
	
	    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
	      return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
	    }
	
	    return inst;
	  };
	  /**
	   * Create a DateTime from an ISO 8601 string
	   * @param {string} text - the ISO string
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
	   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='en-US'] - a locale to set on the resulting DateTime instance
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
	   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
	   * @example DateTime.fromISO('2016-W05-4')
	   * @return {DateTime}
	   */
	
	
	  DateTime.fromISO = function fromISO(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseISODate = parseISODate(text),
	        vals = _parseISODate[0],
	        parsedZone = _parseISODate[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
	  };
	  /**
	   * Create a DateTime from an RFC 2822 string
	   * @param {string} text - the RFC 2822 string
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
	   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='en-US'] - a locale to set on the resulting DateTime instance
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
	   * @example DateTime.fromRFC2822('Tue, 25 Nov 2016 13:23:12 +0600')
	   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
	   * @return {DateTime}
	   */
	
	
	  DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseRFC2822Date = parseRFC2822Date(text),
	        vals = _parseRFC2822Date[0],
	        parsedZone = _parseRFC2822Date[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
	  };
	  /**
	   * Create a DateTime from an HTTP header date
	   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
	   * @param {string} text - the HTTP header date
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
	   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
	   * @param {string} [opts.locale='en-US'] - a locale to set on the resulting DateTime instance
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
	   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
	   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
	   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
	   * @return {DateTime}
	   */
	
	
	  DateTime.fromHTTP = function fromHTTP(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseHTTPDate = parseHTTPDate(text),
	        vals = _parseHTTPDate[0],
	        parsedZone = _parseHTTPDate[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
	  };
	  /**
	   * Create a DateTime from an input string and format string
	   * Defaults to en-US if no locale has been specified, regardless of the system's locale
	   * @param {string} text - the string to parse
	   * @param {string} fmt - the format the string is expected to be in (see description)
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
	   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
	   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @return {DateTime}
	   */
	
	
	  DateTime.fromFormat = function fromFormat(text, fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (isUndefined(text) || isUndefined(fmt)) {
	      throw new InvalidArgumentError("fromFormat requires an input string and a format");
	    }
	
	    var _opts = opts,
	        _opts$locale = _opts.locale,
	        locale = _opts$locale === void 0 ? null : _opts$locale,
	        _opts$numberingSystem = _opts.numberingSystem,
	        numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem,
	        localeToUse = Locale.fromOpts({
	      locale: locale,
	      numberingSystem: numberingSystem,
	      defaultToEN: true
	    }),
	        _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
	        vals = _parseFromTokens[0],
	        parsedZone = _parseFromTokens[1],
	        invalid = _parseFromTokens[2];
	
	    if (invalid) {
	      return DateTime.invalid(invalid);
	    } else {
	      return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text);
	    }
	  };
	  /**
	   * @deprecated use fromFormat instead
	   */
	
	
	  DateTime.fromString = function fromString(text, fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return DateTime.fromFormat(text, fmt, opts);
	  };
	  /**
	   * Create a DateTime from a SQL date, time, or datetime
	   * Defaults to en-US if no locale has been specified, regardless of the system's locale
	   * @param {string} text - the string to parse
	   * @param {Object} opts - options to affect the creation
	   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
	   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
	   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
	   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
	   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
	   * @example DateTime.fromSQL('2017-05-15')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
	   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
	   * @example DateTime.fromSQL('09:12:34.342')
	   * @return {DateTime}
	   */
	
	
	  DateTime.fromSQL = function fromSQL(text, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _parseSQL = parseSQL(text),
	        vals = _parseSQL[0],
	        parsedZone = _parseSQL[1];
	
	    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
	  };
	  /**
	   * Create an invalid DateTime.
	   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
	   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
	   * @return {DateTime}
	   */
	
	
	  DateTime.invalid = function invalid(reason, explanation) {
	    if (explanation === void 0) {
	      explanation = null;
	    }
	
	    if (!reason) {
	      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
	    }
	
	    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
	
	    if (Settings.throwOnInvalid) {
	      throw new InvalidDateTimeError(invalid);
	    } else {
	      return new DateTime({
	        invalid: invalid
	      });
	    }
	  };
	  /**
	   * Check if an object is a DateTime. Works across context boundaries
	   * @param {object} o
	   * @return {boolean}
	   */
	
	
	  DateTime.isDateTime = function isDateTime(o) {
	    return o.isLuxonDateTime || false;
	  }; // INFO
	
	  /**
	   * Get the value of unit.
	   * @param {string} unit - a unit such as 'minute' or 'day'
	   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
	   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
	   * @return {number}
	   */
	
	
	  var _proto = DateTime.prototype;
	
	  _proto.get = function get(unit) {
	    return this[unit];
	  };
	  /**
	   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
	   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
	   * * The DateTime was created by an operation on another invalid date
	   * @type {boolean}
	   */
	
	
	  /**
	   * Returns the resolved Intl options for this DateTime.
	   * This is useful in understanding the behavior of formatting methods
	   * @param {Object} opts - the same options as toLocaleString
	   * @return {Object}
	   */
	  _proto.resolvedLocaleOpts = function resolvedLocaleOpts(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
	        locale = _Formatter$create$res.locale,
	        numberingSystem = _Formatter$create$res.numberingSystem,
	        calendar = _Formatter$create$res.calendar;
	
	    return {
	      locale: locale,
	      numberingSystem: numberingSystem,
	      outputCalendar: calendar
	    };
	  }; // TRANSFORM
	
	  /**
	   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
	   *
	   * Equivalent to {@link setZone}('utc')
	   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
	   * @param {Object} [opts={}] - options to pass to `setZone()`
	   * @return {DateTime}
	   */
	
	
	  _proto.toUTC = function toUTC(offset, opts) {
	    if (offset === void 0) {
	      offset = 0;
	    }
	
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.setZone(FixedOffsetZone.instance(offset), opts);
	  };
	  /**
	   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
	   *
	   * Equivalent to `setZone('local')`
	   * @return {DateTime}
	   */
	
	
	  _proto.toLocal = function toLocal() {
	    return this.setZone(new LocalZone());
	  };
	  /**
	   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
	   *
	   * By default, the setter keeps the underlying time the same (as in, the same UTC timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link plus}. You may wish to use {@link toLocal} and {@link toUTC} which provide simple convenience wrappers for commonly used zones.
	   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'utc+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link Zone} class.
	   * @param {Object} opts - options
	   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
	   * @return {DateTime}
	   */
	
	
	  _proto.setZone = function setZone(zone, _temp) {
	    var _ref4 = _temp === void 0 ? {} : _temp,
	        _ref4$keepLocalTime = _ref4.keepLocalTime,
	        keepLocalTime = _ref4$keepLocalTime === void 0 ? false : _ref4$keepLocalTime,
	        _ref4$keepCalendarTim = _ref4.keepCalendarTime,
	        keepCalendarTime = _ref4$keepCalendarTim === void 0 ? false : _ref4$keepCalendarTim;
	
	    zone = normalizeZone(zone, Settings.defaultZone);
	
	    if (zone.equals(this.zone)) {
	      return this;
	    } else if (!zone.isValid) {
	      return DateTime.invalid(unsupportedZone(zone));
	    } else {
	      var newTS = keepLocalTime || keepCalendarTime // keepCalendarTime is the deprecated name for keepLocalTime
	      ? this.ts + (this.o - zone.offset(this.ts)) * 60 * 1000 : this.ts;
	      return clone$1(this, {
	        ts: newTS,
	        zone: zone
	      });
	    }
	  };
	  /**
	   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
	   * @param {Object} properties - the properties to set
	   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
	   * @return {DateTime}
	   */
	
	
	  _proto.reconfigure = function reconfigure(_temp2) {
	    var _ref5 = _temp2 === void 0 ? {} : _temp2,
	        locale = _ref5.locale,
	        numberingSystem = _ref5.numberingSystem,
	        outputCalendar = _ref5.outputCalendar;
	
	    var loc = this.loc.clone({
	      locale: locale,
	      numberingSystem: numberingSystem,
	      outputCalendar: outputCalendar
	    });
	    return clone$1(this, {
	      loc: loc
	    });
	  };
	  /**
	   * "Set" the locale. Returns a newly-constructed DateTime.
	   * Just a convenient alias for reconfigure({ locale })
	   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
	   * @return {DateTime}
	   */
	
	
	  _proto.setLocale = function setLocale(locale) {
	    return this.reconfigure({
	      locale: locale
	    });
	  };
	  /**
	   * "Set" the values of specified units. Returns a newly-constructed DateTime.
	   * You can only set units with this method; for "setting" metadata, see {@link reconfigure} and {@link setZone}.
	   * @param {Object} values - a mapping of units to numbers
	   * @example dt.set({ year: 2017 })
	   * @example dt.set({ hour: 8, minute: 30 })
	   * @example dt.set({ weekday: 5 })
	   * @example dt.set({ year: 2005, ordinal: 234 })
	   * @return {DateTime}
	   */
	
	
	  _proto.set = function set(values) {
	    if (!this.isValid) return this;
	    var normalized = normalizeObject(values, normalizeUnit),
	        settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday);
	    var mixed;
	
	    if (settingWeekStuff) {
	      mixed = weekToGregorian(Object.assign(gregorianToWeek(this.c), normalized));
	    } else if (!isUndefined(normalized.ordinal)) {
	      mixed = ordinalToGregorian(Object.assign(gregorianToOrdinal(this.c), normalized));
	    } else {
	      mixed = Object.assign(this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
	      // use the last day of the right month
	
	      if (isUndefined(normalized.day)) {
	        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
	      }
	    }
	
	    var _objToTS3 = objToTS(mixed, this.o, this.zone),
	        ts = _objToTS3[0],
	        o = _objToTS3[1];
	
	    return clone$1(this, {
	      ts: ts,
	      o: o
	    });
	  };
	  /**
	   * Add a period of time to this DateTime and return the resulting DateTime
	   *
	   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
	   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   * @example DateTime.local().plus(123) //~> in 123 milliseconds
	   * @example DateTime.local().plus({ minutes: 15 }) //~> in 15 minutes
	   * @example DateTime.local().plus({ days: 1 }) //~> this time tomorrow
	   * @example DateTime.local().plus({ days: -1 }) //~> this time yesterday
	   * @example DateTime.local().plus({ hours: 3, minutes: 13 }) //~> in 1 hr, 13 min
	   * @example DateTime.local().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 1 hr, 13 min
	   * @return {DateTime}
	   */
	
	
	  _proto.plus = function plus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration);
	    return clone$1(this, adjustTime(this, dur));
	  };
	  /**
	   * Subtract a period of time to this DateTime and return the resulting DateTime
	   * See {@link plus}
	   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
	   @return {DateTime}
	  */
	
	
	  _proto.minus = function minus(duration) {
	    if (!this.isValid) return this;
	    var dur = friendlyDuration(duration).negate();
	    return clone$1(this, adjustTime(this, dur));
	  };
	  /**
	   * "Set" this DateTime to the beginning of a unit of time.
	   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'month', 'day', 'hour', 'minute', 'second', or 'millisecond'.
	   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
	   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
	   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
	   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
	   * @return {DateTime}
	   */
	
	
	  _proto.startOf = function startOf(unit) {
	    if (!this.isValid) return this;
	    var o = {},
	        normalizedUnit = Duration.normalizeUnit(unit);
	
	    switch (normalizedUnit) {
	      case "years":
	        o.month = 1;
	      // falls through
	
	      case "quarters":
	      case "months":
	        o.day = 1;
	      // falls through
	
	      case "weeks":
	      case "days":
	        o.hour = 0;
	      // falls through
	
	      case "hours":
	        o.minute = 0;
	      // falls through
	
	      case "minutes":
	        o.second = 0;
	      // falls through
	
	      case "seconds":
	        o.millisecond = 0;
	        break;
	
	      case "milliseconds":
	        break;
	
	      default:
	        throw new InvalidUnitError(unit);
	    }
	
	    if (normalizedUnit === "weeks") {
	      o.weekday = 1;
	    }
	
	    if (normalizedUnit === "quarters") {
	      var q = Math.ceil(this.month / 3);
	      o.month = (q - 1) * 3 + 1;
	    }
	
	    return this.set(o);
	  };
	  /**
	   * "Set" this DateTime to the end (i.e. the last millisecond) of a unit of time
	   * @param {string} unit - The unit to go to the end of. Can be 'year', 'month', 'day', 'hour', 'minute', 'second', or 'millisecond'.
	   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
	   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
	   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
	   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
	   * @return {DateTime}
	   */
	
	
	  _proto.endOf = function endOf(unit) {
	    var _this$plus;
	
	    return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
	  }; // OUTPUT
	
	  /**
	   * Returns a string representation of this DateTime formatted according to the specified format string.
	   * **You may not want this.** See {@link toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens).
	   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
	   * @see https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
	   * @param {string} fmt - the format string
	   * @param {Object} opts - opts to override the configuration options
	   * @example DateTime.local().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
	   * @example DateTime.local().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
	   * @example DateTime.local().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
	   * @example DateTime.local().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
	   * @return {string}
	   */
	
	
	  _proto.toFormat = function toFormat(fmt, opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID$2;
	  };
	  /**
	   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
	   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation.
	   * of the DateTime in the assigned locale.
	   * Defaults to the system's locale if no locale has been specified
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
	   * @param opts {Object} - Intl.DateTimeFormat constructor options and configuration options
	   * @example DateTime.local().toLocaleString(); //=> 4/20/2017
	   * @example DateTime.local().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
	   * @example DateTime.local().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
	   * @example DateTime.local().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
	   * @example DateTime.local().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
	   * @example DateTime.local().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
	   * @example DateTime.local().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
	   * @example DateTime.local().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
	   * @example DateTime.local().toLocaleString({ hour: '2-digit', minute: '2-digit', hour12: false }); //=> '11:32'
	   * @return {string}
	   */
	
	
	  _proto.toLocaleString = function toLocaleString(opts) {
	    if (opts === void 0) {
	      opts = DATE_SHORT;
	    }
	
	    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTime(this) : INVALID$2;
	  };
	  /**
	   * Returns an array of format "parts", i.e. individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
	   * Defaults to the system's locale if no locale has been specified
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
	   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
	   * @example DateTime.local().toLocaleString(); //=> [
	   *                                    //=>   { type: 'day', value: '25' },
	   *                                    //=>   { type: 'literal', value: '/' },
	   *                                    //=>   { type: 'month', value: '05' },
	   *                                    //=>   { type: 'literal', value: '/' },
	   *                                    //=>   { type: 'year', value: '1982' }
	   *                                    //=> ]
	   */
	
	
	  _proto.toLocaleParts = function toLocaleParts(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
	  };
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime
	   * @param {Object} opts - options
	   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
	   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
	   * @example DateTime.local().toISO() //=> '2017-04-22T20:47:05.335-04:00'
	   * @example DateTime.local().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
	   * @return {string}
	   */
	
	
	  _proto.toISO = function toISO(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) {
	      return null;
	    }
	
	    return this.toISODate() + "T" + this.toISOTime(opts);
	  };
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime's date component
	   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
	   * @return {string}
	   */
	
	
	  _proto.toISODate = function toISODate() {
	    return toTechFormat(this, "yyyy-MM-dd");
	  };
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime's week date
	   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
	   * @return {string}
	   */
	
	
	  _proto.toISOWeekDate = function toISOWeekDate() {
	    return toTechFormat(this, "kkkk-'W'WW-c");
	  };
	  /**
	   * Returns an ISO 8601-compliant string representation of this DateTime's time component
	   * @param {Object} opts - options
	   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
	   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc().hour(7).minute(34).toISOTime() //=> '07:34:19.361Z'
	   * @example DateTime.utc().hour(7).minute(34).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
	   * @return {string}
	   */
	
	
	  _proto.toISOTime = function toISOTime(_temp3) {
	    var _ref6 = _temp3 === void 0 ? {} : _temp3,
	        _ref6$suppressMillise = _ref6.suppressMilliseconds,
	        suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise,
	        _ref6$suppressSeconds = _ref6.suppressSeconds,
	        suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds,
	        _ref6$includeOffset = _ref6.includeOffset,
	        includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset;
	
	    return toTechTimeFormat(this, {
	      suppressSeconds: suppressSeconds,
	      suppressMilliseconds: suppressMilliseconds,
	      includeOffset: includeOffset
	    });
	  };
	  /**
	   * Returns an RFC 2822-compatible string representation of this DateTime, always in UTC
	   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
	   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
	   * @return {string}
	   */
	
	
	  _proto.toRFC2822 = function toRFC2822() {
	    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ");
	  };
	  /**
	   * Returns a string representation of this DateTime appropriate for use in HTTP headers.
	   * Specifically, the string conforms to RFC 1123.
	   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
	   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
	   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
	   * @return {string}
	   */
	
	
	  _proto.toHTTP = function toHTTP() {
	    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
	  };
	  /**
	   * Returns a string representation of this DateTime appropriate for use in SQL Date
	   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
	   * @return {string}
	   */
	
	
	  _proto.toSQLDate = function toSQLDate() {
	    return toTechFormat(this, "yyyy-MM-dd");
	  };
	  /**
	   * Returns a string representation of this DateTime appropriate for use in SQL Time
	   * @param {Object} opts - options
	   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overides includeOffset.
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
	   * @example DateTime.local().toSQL() //=> '05:15:16.345 -04:00'
	   * @example DateTime.local().toSQL({ includeOffset: false }) //=> '05:15:16.345'
	   * @example DateTime.local().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
	   * @return {string}
	   */
	
	
	  _proto.toSQLTime = function toSQLTime(_temp4) {
	    var _ref7 = _temp4 === void 0 ? {} : _temp4,
	        _ref7$includeOffset = _ref7.includeOffset,
	        includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset,
	        _ref7$includeZone = _ref7.includeZone,
	        includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone;
	
	    return toTechTimeFormat(this, {
	      includeOffset: includeOffset,
	      includeZone: includeZone,
	      spaceZone: true
	    });
	  };
	  /**
	   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
	   * @param {Object} opts - options
	   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
	   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
	   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
	   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
	   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
	   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
	   * @return {string}
	   */
	
	
	  _proto.toSQL = function toSQL(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) {
	      return null;
	    }
	
	    return this.toSQLDate() + " " + this.toSQLTime(opts);
	  };
	  /**
	   * Returns a string representation of this DateTime appropriate for debugging
	   * @return {string}
	   */
	
	
	  _proto.toString = function toString() {
	    return this.isValid ? this.toISO() : INVALID$2;
	  };
	  /**
	   * Returns the epoch milliseconds of this DateTime. Alias of {@link toMillis}
	   * @return {number}
	   */
	
	
	  _proto.valueOf = function valueOf() {
	    return this.toMillis();
	  };
	  /**
	   * Returns the epoch milliseconds of this DateTime.
	   * @return {number}
	   */
	
	
	  _proto.toMillis = function toMillis() {
	    return this.isValid ? this.ts : NaN;
	  };
	  /**
	   * Returns the epoch seconds of this DateTime.
	   * @return {number}
	   */
	
	
	  _proto.toSeconds = function toSeconds() {
	    return this.isValid ? this.ts / 1000 : NaN;
	  };
	  /**
	   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
	   * @return {string}
	   */
	
	
	  _proto.toJSON = function toJSON() {
	    return this.toISO();
	  };
	  /**
	   * Returns a BSON serializable equivalent to this DateTime.
	   * @return {Date}
	   */
	
	
	  _proto.toBSON = function toBSON() {
	    return this.toJSDate();
	  };
	  /**
	   * Returns a Javascript object with this DateTime's year, month, day, and so on.
	   * @param opts - options for generating the object
	   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
	   * @example DateTime.local().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
	   * @return {Object}
	   */
	
	
	  _proto.toObject = function toObject(opts) {
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid) return {};
	    var base = Object.assign({}, this.c);
	
	    if (opts.includeConfig) {
	      base.outputCalendar = this.outputCalendar;
	      base.numberingSystem = this.loc.numberingSystem;
	      base.locale = this.loc.locale;
	    }
	
	    return base;
	  };
	  /**
	   * Returns a Javascript Date equivalent to this DateTime.
	   * @return {Date}
	   */
	
	
	  _proto.toJSDate = function toJSDate() {
	    return new Date(this.isValid ? this.ts : NaN);
	  }; // COMPARE
	
	  /**
	   * Return the difference between two DateTimes as a Duration.
	   * @param {DateTime} otherDateTime - the DateTime to compare this one to
	   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
	   * @param {Object} opts - options that affect the creation of the Duration
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @example
	   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
	   *     i2 = DateTime.fromISO('1983-10-14T10:30');
	   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
	   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
	   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
	   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
	   * @return {Duration}
	   */
	
	
	  _proto.diff = function diff(otherDateTime, unit, opts) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    if (!this.isValid || !otherDateTime.isValid) {
	      return Duration.invalid(this.invalid || otherDateTime.invalid, "created by diffing an invalid DateTime");
	    }
	
	    var durOpts = Object.assign({
	      locale: this.locale,
	      numberingSystem: this.numberingSystem
	    }, opts);
	
	    var units = maybeArray(unit).map(Duration.normalizeUnit),
	        otherIsLater = otherDateTime.valueOf() > this.valueOf(),
	        earlier = otherIsLater ? this : otherDateTime,
	        later = otherIsLater ? otherDateTime : this,
	        diffed = _diff(earlier, later, units, durOpts);
	
	    return otherIsLater ? diffed.negate() : diffed;
	  };
	  /**
	   * Return the difference between this DateTime and right now.
	   * See {@link diff}
	   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
	   * @param {Object} opts - options that affect the creation of the Duration
	   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
	   * @return {Duration}
	   */
	
	
	  _proto.diffNow = function diffNow(unit, opts) {
	    if (unit === void 0) {
	      unit = "milliseconds";
	    }
	
	    if (opts === void 0) {
	      opts = {};
	    }
	
	    return this.diff(DateTime.local(), unit, opts);
	  };
	  /**
	   * Return an Interval spanning between this DateTime and another DateTime
	   * @param {DateTime} otherDateTime - the other end point of the Interval
	   * @return {Interval}
	   */
	
	
	  _proto.until = function until(otherDateTime) {
	    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
	  };
	  /**
	   * Return whether this DateTime is in the same unit of time as another DateTime
	   * @param {DateTime} otherDateTime - the other DateTime
	   * @param {string} unit - the unit of time to check sameness on
	   * @example DateTime.local().hasSame(otherDT, 'day'); //~> true if both the same calendar day
	   * @return {boolean}
	   */
	
	
	  _proto.hasSame = function hasSame(otherDateTime, unit) {
	    if (!this.isValid) return false;
	
	    if (unit === "millisecond") {
	      return this.valueOf() === otherDateTime.valueOf();
	    } else {
	      var inputMs = otherDateTime.valueOf();
	      return this.startOf(unit) <= inputMs && inputMs <= this.endOf(unit);
	    }
	  };
	  /**
	   * Equality check
	   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
	   * To compare just the millisecond values, use `+dt1 === ~dt2`.
	   * @param {DateTime} other - the other DateTime
	   * @return {boolean}
	   */
	
	
	  _proto.equals = function equals(other) {
	    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
	  };
	  /**
	   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
	   * platform supports Intl.RelativeDateFormat. Rounds down by default.
	   * @param {Object} options - options that affect the output
	   * @param {DateTime} [options.base=DateTime.local()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
	   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
	   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "year", "quarter", "month", "week", "day", "hour", "minute", or "second"
	   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
	   * @param {boolean} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
	   * @param {string} options.locale - override the locale of this DateTime
	   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
	   * @example DateTime.local().plus({ days: 1 }).toRelative() //=> "in 1 day"
	   * @example DateTime.local().setLocale("es").toRelative({ days: 1 }).toRelative() //=> "dentro de 1 día"
	   * @example DateTime.local().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
	   * @example DateTime.local().minus({ days: 2 }).toRelative() //=> "2 days ago"
	   * @example DateTime.local().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
	   * @example DateTime.local().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
	   */
	
	
	  _proto.toRelative = function toRelative(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!this.isValid) return null;
	    var base = options.base || DateTime.local(),
	        padding = options.padding ? this < base ? -options.padding : options.padding : 0;
	    return diffRelative(base, this.plus(padding), Object.assign(options, {
	      numeric: "always",
	      units: ["years", "months", "days", "hours", "minutes", "seconds"]
	    }));
	  };
	  /**
	   * Returns a string representation this date relative to today, such as "yesterday" or "next month"
	   * platform supports Intl.RelativeDateFormat.
	   * @param {Object} options - options that affect the output
	   * @param {DateTime} [options.base=DateTime.local()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
	   * @param {string} options.locale - override the locale of this DateTime
	   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "year", "quarter", "month", "week", or "day"
	   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
	   * @example DateTime.local().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
	   * @example DateTime.local().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
	   * @example DateTime.local().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
	   * @example DateTime.local().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
	   */
	
	
	  _proto.toRelativeCalendar = function toRelativeCalendar(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!this.isValid) return null;
	    return diffRelative(options.base || DateTime.local(), this, Object.assign(options, {
	      numeric: "auto",
	      units: ["years", "months", "days"],
	      calendary: true
	    }));
	  };
	  /**
	   * Return the min of several date times
	   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
	   * @return {DateTime} the min DateTime, or undefined if called with no argument
	   */
	
	
	  DateTime.min = function min() {
	    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
	      dateTimes[_key] = arguments[_key];
	    }
	
	    return bestBy(dateTimes, function (i) {
	      return i.valueOf();
	    }, Math.min);
	  };
	  /**
	   * Return the max of several date times
	   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
	   * @return {DateTime} the max DateTime, or undefined if called with no argument
	   */
	
	
	  DateTime.max = function max() {
	    for (var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      dateTimes[_key2] = arguments[_key2];
	    }
	
	    return bestBy(dateTimes, function (i) {
	      return i.valueOf();
	    }, Math.max);
	  }; // MISC
	
	  /**
	   * Explain how a string would be parsed by fromFormat()
	   * @param {string} text - the string to parse
	   * @param {string} fmt - the format the string is expected to be in (see description)
	   * @param {Object} options - options taken by fromFormat()
	   * @return {Object}
	   */
	
	
	  DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        _options$locale = _options.locale,
	        locale = _options$locale === void 0 ? null : _options$locale,
	        _options$numberingSys = _options.numberingSystem,
	        numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys,
	        localeToUse = Locale.fromOpts({
	      locale: locale,
	      numberingSystem: numberingSystem,
	      defaultToEN: true
	    });
	    return explainFromTokens(localeToUse, text, fmt);
	  };
	  /**
	   * @deprecated use fromFormatExplain instead
	   */
	
	
	  DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    return DateTime.fromFormatExplain(text, fmt, options);
	  }; // FORMAT PRESETS
	
	  /**
	   * {@link toLocaleString} format like 10/14/1983
	   * @type {Object}
	   */
	
	
	  _createClass(DateTime, [{
	    key: "isValid",
	    get: function get() {
	      return this.invalid === null;
	    }
	    /**
	     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidReason",
	    get: function get() {
	      return this.invalid ? this.invalid.reason : null;
	    }
	    /**
	     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
	     * @type {string}
	     */
	
	  }, {
	    key: "invalidExplanation",
	    get: function get() {
	      return this.invalid ? this.invalid.explanation : null;
	    }
	    /**
	     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "locale",
	    get: function get() {
	      return this.isValid ? this.loc.locale : null;
	    }
	    /**
	     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "numberingSystem",
	    get: function get() {
	      return this.isValid ? this.loc.numberingSystem : null;
	    }
	    /**
	     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
	     *
	     * @type {string}
	     */
	
	  }, {
	    key: "outputCalendar",
	    get: function get() {
	      return this.isValid ? this.loc.outputCalendar : null;
	    }
	    /**
	     * Get the time zone associated with this DateTime.
	     * @type {Zone}
	     */
	
	  }, {
	    key: "zone",
	    get: function get() {
	      return this._zone;
	    }
	    /**
	     * Get the name of the time zone.
	     * @type {string}
	     */
	
	  }, {
	    key: "zoneName",
	    get: function get() {
	      return this.isValid ? this.zone.name : null;
	    }
	    /**
	     * Get the year
	     * @example DateTime.local(2017, 5, 25).year //=> 2017
	     * @type {number}
	     */
	
	  }, {
	    key: "year",
	    get: function get() {
	      return this.isValid ? this.c.year : NaN;
	    }
	    /**
	     * Get the quarter
	     * @example DateTime.local(2017, 5, 25).quarter //=> 2
	     * @type {number}
	     */
	
	  }, {
	    key: "quarter",
	    get: function get() {
	      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
	    }
	    /**
	     * Get the month (1-12).
	     * @example DateTime.local(2017, 5, 25).month //=> 5
	     * @type {number}
	     */
	
	  }, {
	    key: "month",
	    get: function get() {
	      return this.isValid ? this.c.month : NaN;
	    }
	    /**
	     * Get the day of the month (1-30ish).
	     * @example DateTime.local(2017, 5, 25).day //=> 25
	     * @type {number}
	     */
	
	  }, {
	    key: "day",
	    get: function get() {
	      return this.isValid ? this.c.day : NaN;
	    }
	    /**
	     * Get the hour of the day (0-23).
	     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
	     * @type {number}
	     */
	
	  }, {
	    key: "hour",
	    get: function get() {
	      return this.isValid ? this.c.hour : NaN;
	    }
	    /**
	     * Get the minute of the hour (0-59).
	     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
	     * @type {number}
	     */
	
	  }, {
	    key: "minute",
	    get: function get() {
	      return this.isValid ? this.c.minute : NaN;
	    }
	    /**
	     * Get the second of the minute (0-59).
	     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
	     * @type {number}
	     */
	
	  }, {
	    key: "second",
	    get: function get() {
	      return this.isValid ? this.c.second : NaN;
	    }
	    /**
	     * Get the millisecond of the second (0-999).
	     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
	     * @type {number}
	     */
	
	  }, {
	    key: "millisecond",
	    get: function get() {
	      return this.isValid ? this.c.millisecond : NaN;
	    }
	    /**
	     * Get the week year
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2014, 11, 31).weekYear //=> 2015
	     * @type {number}
	     */
	
	  }, {
	    key: "weekYear",
	    get: function get() {
	      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
	    }
	    /**
	     * Get the week number of the week year (1-52ish).
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
	     * @type {number}
	     */
	
	  }, {
	    key: "weekNumber",
	    get: function get() {
	      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
	    }
	    /**
	     * Get the day of the week.
	     * 1 is Monday and 7 is Sunday
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2014, 11, 31).weekday //=> 4
	     * @type {number}
	     */
	
	  }, {
	    key: "weekday",
	    get: function get() {
	      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
	    }
	    /**
	     * Get the ordinal (i.e. the day of the year)
	     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
	     * @type {number|DateTime}
	     */
	
	  }, {
	    key: "ordinal",
	    get: function get() {
	      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
	    }
	    /**
	     * Get the human readable short month name, such as 'Oct'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
	     * @type {string}
	     */
	
	  }, {
	    key: "monthShort",
	    get: function get() {
	      return this.isValid ? Info.months("short", {
	        locale: this.locale
	      })[this.month - 1] : null;
	    }
	    /**
	     * Get the human readable long month name, such as 'October'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).monthLong //=> October
	     * @type {string}
	     */
	
	  }, {
	    key: "monthLong",
	    get: function get() {
	      return this.isValid ? Info.months("long", {
	        locale: this.locale
	      })[this.month - 1] : null;
	    }
	    /**
	     * Get the human readable short weekday, such as 'Mon'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
	     * @type {string}
	     */
	
	  }, {
	    key: "weekdayShort",
	    get: function get() {
	      return this.isValid ? Info.weekdays("short", {
	        locale: this.locale
	      })[this.weekday - 1] : null;
	    }
	    /**
	     * Get the human readable long weekday, such as 'Monday'.
	     * Defaults to the system's locale if no locale has been specified
	     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
	     * @type {string}
	     */
	
	  }, {
	    key: "weekdayLong",
	    get: function get() {
	      return this.isValid ? Info.weekdays("long", {
	        locale: this.locale
	      })[this.weekday - 1] : null;
	    }
	    /**
	     * Get the UTC offset of this DateTime in minutes
	     * @example DateTime.local().offset //=> -240
	     * @example DateTime.utc().offset //=> 0
	     * @type {number}
	     */
	
	  }, {
	    key: "offset",
	    get: function get() {
	      return this.isValid ? this.zone.offset(this.ts) : NaN;
	    }
	    /**
	     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
	     * Defaults to the system's locale if no locale has been specified
	     * @type {string}
	     */
	
	  }, {
	    key: "offsetNameShort",
	    get: function get() {
	      if (this.isValid) {
	        return this.zone.offsetName(this.ts, {
	          format: "short",
	          locale: this.locale
	        });
	      } else {
	        return null;
	      }
	    }
	    /**
	     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
	     * Defaults to the system's locale if no locale has been specified
	     * @type {string}
	     */
	
	  }, {
	    key: "offsetNameLong",
	    get: function get() {
	      if (this.isValid) {
	        return this.zone.offsetName(this.ts, {
	          format: "long",
	          locale: this.locale
	        });
	      } else {
	        return null;
	      }
	    }
	    /**
	     * Get whether this zone's offset ever changes, as in a DST.
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isOffsetFixed",
	    get: function get() {
	      return this.isValid ? this.zone.universal : null;
	    }
	    /**
	     * Get whether the DateTime is in a DST.
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isInDST",
	    get: function get() {
	      if (this.isOffsetFixed) {
	        return false;
	      } else {
	        return this.offset > this.set({
	          month: 1
	        }).offset || this.offset > this.set({
	          month: 5
	        }).offset;
	      }
	    }
	    /**
	     * Returns true if this DateTime is in a leap year, false otherwise
	     * @example DateTime.local(2016).isInLeapYear //=> true
	     * @example DateTime.local(2013).isInLeapYear //=> false
	     * @type {boolean}
	     */
	
	  }, {
	    key: "isInLeapYear",
	    get: function get() {
	      return isLeapYear(this.year);
	    }
	    /**
	     * Returns the number of days in this DateTime's month
	     * @example DateTime.local(2016, 2).daysInMonth //=> 29
	     * @example DateTime.local(2016, 3).daysInMonth //=> 31
	     * @type {number}
	     */
	
	  }, {
	    key: "daysInMonth",
	    get: function get() {
	      return daysInMonth(this.year, this.month);
	    }
	    /**
	     * Returns the number of days in this DateTime's year
	     * @example DateTime.local(2016).daysInYear //=> 366
	     * @example DateTime.local(2013).daysInYear //=> 365
	     * @type {number}
	     */
	
	  }, {
	    key: "daysInYear",
	    get: function get() {
	      return this.isValid ? daysInYear(this.year) : NaN;
	    }
	    /**
	     * Returns the number of weeks in this DateTime's year
	     * @see https://en.wikipedia.org/wiki/ISO_week_date
	     * @example DateTime.local(2004).weeksInWeekYear //=> 53
	     * @example DateTime.local(2013).weeksInWeekYear //=> 52
	     * @type {number}
	     */
	
	  }, {
	    key: "weeksInWeekYear",
	    get: function get() {
	      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
	    }
	  }], [{
	    key: "DATE_SHORT",
	    get: function get() {
	      return DATE_SHORT;
	    }
	    /**
	     * {@link toLocaleString} format like 'Oct 14, 1983'
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATE_MED",
	    get: function get() {
	      return DATE_MED;
	    }
	    /**
	     * {@link toLocaleString} format like 'October 14, 1983'
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATE_FULL",
	    get: function get() {
	      return DATE_FULL;
	    }
	    /**
	     * {@link toLocaleString} format like 'Tuesday, October 14, 1983'
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATE_HUGE",
	    get: function get() {
	      return DATE_HUGE;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_SIMPLE",
	    get: function get() {
	      return TIME_SIMPLE;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_WITH_SECONDS",
	    get: function get() {
	      return TIME_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_WITH_SHORT_OFFSET",
	    get: function get() {
	      return TIME_WITH_SHORT_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_WITH_LONG_OFFSET",
	    get: function get() {
	      return TIME_WITH_LONG_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_SIMPLE",
	    get: function get() {
	      return TIME_24_SIMPLE;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_WITH_SECONDS",
	    get: function get() {
	      return TIME_24_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 EDT', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_WITH_SHORT_OFFSET",
	    get: function get() {
	      return TIME_24_WITH_SHORT_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
	     * @type {Object}
	     */
	
	  }, {
	    key: "TIME_24_WITH_LONG_OFFSET",
	    get: function get() {
	      return TIME_24_WITH_LONG_OFFSET;
	    }
	    /**
	     * {@link toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_SHORT",
	    get: function get() {
	      return DATETIME_SHORT;
	    }
	    /**
	     * {@link toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_SHORT_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_SHORT_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_MED",
	    get: function get() {
	      return DATETIME_MED;
	    }
	    /**
	     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_MED_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_MED_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_FULL",
	    get: function get() {
	      return DATETIME_FULL;
	    }
	    /**
	     * {@link toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_FULL_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_FULL_WITH_SECONDS;
	    }
	    /**
	     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_HUGE",
	    get: function get() {
	      return DATETIME_HUGE;
	    }
	    /**
	     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
	     * @type {Object}
	     */
	
	  }, {
	    key: "DATETIME_HUGE_WITH_SECONDS",
	    get: function get() {
	      return DATETIME_HUGE_WITH_SECONDS;
	    }
	  }]);
	
	  return DateTime;
	}();
	function friendlyDateTime(dateTimeish) {
	  if (DateTime.isDateTime(dateTimeish)) {
	    return dateTimeish;
	  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
	    return DateTime.fromJSDate(dateTimeish);
	  } else if (dateTimeish && typeof dateTimeish === "object") {
	    return DateTime.fromObject(dateTimeish);
	  } else {
	    throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
	  }
	}
	
	exports.DateTime = DateTime;
	exports.Duration = Duration;
	exports.Interval = Interval;
	exports.Info = Info;
	exports.Zone = Zone;
	exports.FixedOffsetZone = FixedOffsetZone;
	exports.IANAZone = IANAZone;
	exports.InvalidZone = InvalidZone;
	exports.LocalZone = LocalZone;
	exports.Settings = Settings;
	//# sourceMappingURL=luxon.js.map


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(81);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(72);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(80);
	
	var _HelmetConstants = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(78);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(75);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(82);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(114);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _chromaJs = __webpack_require__(53);
	
	var _chromaJs2 = _interopRequireDefault(_chromaJs);
	
	var _lighterCrc = __webpack_require__(77);
	
	var _lighterCrc2 = _interopRequireDefault(_lighterCrc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function hashRange(num) {
		var bitSkip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var bitCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 32;
	
		return (num / Math.pow(2, bitSkip) & Math.pow(2, bitCount) - 1) / (Math.pow(2, bitCount) - 1);
	}
	
	var Tag = function (_React$Component) {
		_inherits(Tag, _React$Component);
	
		function Tag() {
			_classCallCheck(this, Tag);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Tag.prototype.render = function render() {
			var _props = this.props,
			    category = _props.category,
			    label = _props.label,
			    longLabel = _props.longLabel,
			    parent = _props.parent;
	
	
			var categoryHash = (0, _lighterCrc2.default)('salt-Q' + category.label);
			var categoryChroma = 30 + hashRange(categoryHash, 0, 10) * 20;
			var categoryLightness = 30 + hashRange(categoryHash, 10, 10) * 10;
			var categoryHue = hashRange(categoryHash, 20, 12) * 360;
			var labelHash = (0, _lighterCrc2.default)('salt-f' + label);
			var labelHueDiff = hashRange(labelHash, 0, 10) * 30;
			var labelLightnessDiff = hashRange(labelHash, 10, 10) * 50;
			var labelChromaDiff = hashRange(labelHash, 20, 12) * 40;
	
			var categoryColour = _chromaJs2.default.hcl(categoryHue, categoryChroma, categoryLightness);
			var labelColour = _chromaJs2.default.hcl(categoryHue + labelHueDiff, categoryChroma + labelChromaDiff, categoryLightness + labelLightnessDiff);
	
			return _react2.default.createElement(
				'span',
				{ className: 'tag' },
				_react2.default.createElement(
					'span',
					{
						className: (0, _classnames2.default)('tag__label', labelColour.luminance() > 0.18 && 'tag__label--light-bg'),
						title: longLabel,
						style: {
							backgroundColor: labelColour.hex()
						}
					},
					label
				)
			);
		};
	
		return Tag;
	}(_react2.default.Component);
	
	Tag.propTypes = {
		category: _propTypes2.default.object.isRequired,
		label: _propTypes2.default.string.isRequired,
		longLabel: _propTypes2.default.string,
		parent: _propTypes2.default.object
	};
	exports.default = Tag;
	module.exports = exports['default'];

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TagListFromStrings = undefined;
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tags = __webpack_require__(105);
	
	var _Tag = __webpack_require__(110);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagList = function (_React$Component) {
		_inherits(TagList, _React$Component);
	
		function TagList() {
			_classCallCheck(this, TagList);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		TagList.prototype.render = function render() {
			var tags = this.props.tags;
	
	
			if (tags.length === 0) {
				return null;
			}
	
			return _react2.default.createElement(
				'ul',
				{ className: 'tag-list' },
				tags.map(function (tag) {
					return _react2.default.createElement(
						_react2.default.Fragment,
						{ key: tag.label },
						_react2.default.createElement(
							'li',
							{ className: 'tag-list__item' },
							_react2.default.createElement(_Tag2.default, tag)
						),
						" "
					);
				})
			);
		};
	
		return TagList;
	}(_react2.default.Component);
	
	TagList.propTypes = {
		tags: _propTypes2.default.arrayOf(_propTypes2.default.object.isRequired).isRequired
	};
	TagList.defaultProps = {
		tags: []
	};
	exports.default = TagList;
	
	var TagListFromStrings = exports.TagListFromStrings = function (_React$Component2) {
		_inherits(TagListFromStrings, _React$Component2);
	
		function TagListFromStrings() {
			_classCallCheck(this, TagListFromStrings);
	
			return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
		}
	
		TagListFromStrings.prototype.render = function render() {
			var tags = this.props.tags;
	
	
			if (tags.length === 0) {
				return null;
			}
	
			var fullTags = tags.map(function (tag) {
				return _tags.tags[tag];
			});
	
			return _react2.default.createElement(TagList, { tags: fullTags });
		};
	
		return TagListFromStrings;
	}(_react2.default.Component);
	
	TagListFromStrings.propTypes = {
		tags: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired
	};
	TagListFromStrings.defaultProps = {
		tags: []
	};

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _luxon = __webpack_require__(106);
	
	var _reactHelmet = __webpack_require__(79);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(158);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TagList = __webpack_require__(111);
	
	var _ucfirst = __webpack_require__(243);
	
	var _ucfirst2 = _interopRequireDefault(_ucfirst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
		var data = _ref.data;
		var markdownRemark = data.markdownRemark;
		var frontmatter = markdownRemark.frontmatter,
		    html = markdownRemark.html;
	
	
		var date = _luxon.DateTime.fromISO(frontmatter.date);
		var dateString = void 0;
		if (/^\d\d\d\d$/.test(frontmatter.date)) {
			dateString = date.toFormat('yyyy');
		} else if (/^\d\d\d\d-\d\d$/.test(frontmatter.date)) {
			dateString = date.toFormat('MMMM yyyy');
		} else {
			dateString = date.toFormat('MMMM d, yyyy');
		}
	
		var writeupDate = _luxon.DateTime.fromISO(frontmatter.writeupDate);
	
		return _react2.default.createElement(
			_react2.default.Fragment,
			null,
			_react2.default.createElement(_reactHelmet2.default, { title: (0, _ucfirst2.default)(frontmatter.title) }),
			_react2.default.createElement(
				'nav',
				null,
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ to: '/' },
					'\u21A9 Home'
				)
			),
			_react2.default.createElement(
				'article',
				null,
				_react2.default.createElement(
					'header',
					{ className: 'projectHeader' },
					_react2.default.createElement(
						'h1',
						null,
						(0, _ucfirst2.default)(frontmatter.title)
					),
					frontmatter.summary && _react2.default.createElement(
						'p',
						{ className: 'projectSummary' },
						(0, _ucfirst2.default)(frontmatter.summary)
					),
					frontmatter.taskSummary && _react2.default.createElement(
						'p',
						{ className: 'taskSummary' },
						(0, _ucfirst2.default)(frontmatter.taskSummary)
					),
					_react2.default.createElement(_TagList.TagListFromStrings, { tags: frontmatter.tags }),
					_react2.default.createElement(
						'p',
						{ className: 'projectDate' },
						_react2.default.createElement(
							'time',
							{ dateTime: frontmatter.date },
							dateString
						)
					),
					frontmatter.url && _react2.default.createElement(
						'p',
						{ className: 'projectUrl' },
						_react2.default.createElement(
							'a',
							{ href: frontmatter.url, 'aria-label': 'Visit the live website' },
							frontmatter.url
						)
					)
				),
				_react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: html } }),
				_react2.default.createElement(
					'footer',
					{ className: 'projectFooter' },
					_react2.default.createElement(
						'time',
						{ dateTime: writeupDate.toFormat('yyyy-MM-dd') },
						writeupDate.toFormat('MMMM d, yyyy')
					)
				)
			)
		);
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ucfirst;
	function ucfirst(str) {
		if (str.length === 0) {
			return str;
		}
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-project-js-5a57af44120b15be2693.js